export default {
    brandSeo: {
        pageTitle: '{title} on Miral AI',
        toolDescription: 'On Miral AI, {description}',
        sectionTitle: '{title} with Miral AI',
        faqTitle: '{title} on Miral AI',
        toolFreeTrialCta: 'Try This Tool Free on Miral AI',
        toolProcessCta: '{action} for Free',
        imageFaqs: [
            { q: 'Can I try AI image generation for free on Miral?', a: 'Yes. Sign up for Miral AI to receive free credits and try image generation. Each result still uses the credits required by the selected model.' },
            { q: 'Why create images with Miral AI?', a: 'Miral AI brings leading image models together in one place, so you can compare capabilities and continue creating without switching platforms.' }
        ],
        toolFaqs: [
            { q: 'Can I try this Miral AI tool for free?', a: 'Yes. Sign in to Miral AI to start a free trial. Availability may depend on your account limits, so free trial access does not mean unlimited use.' },
            { q: 'Why use creative tools on Miral AI?', a: 'Miral AI combines image generation and practical editing tools in one platform, making it easier to create, process, and download results in one workflow.' }
        ]
    },
    common: {
        loading: 'Loading...',
        error: 'An error occurred',
        success: 'Success',
        confirm: 'OK',
        prev: 'Previous',
        next: 'Next',
        optional: 'Optional',
        remove: 'Remove',
        generate: 'Generate',
        generating: 'Generating...',
        required: 'Required',
        generateFailedContactSupport: 'Generation failed. Please try again or contact support!',
        localMediaTransferFailed:
            'Network instability interrupted service transfer or interaction. Generation stopped. Please try again or contact support.',
        errorDetails: 'Error details',
        tryAgainOrContactSupportTail: ' Please try again or contact support!',
        errorCategoryImageSizeInvalid: 'The image size does not meet the requirements. Please upload a valid image',
        errorCategoryOutputEmptyOrSensitive: 'The generation was blocked by safety rules or produced no output. Please adjust your prompt/reference image',
        errorCategoryUpstreamBusy: 'The service is busy right now',
        errorCategoryAiNetworkError: 'Network connection error. Please check your network and try again',
        errorCategoryAiTimeout: 'AI request timed out. Network may be unstable, please try again shortly',
        close: 'Close',
        leaveConfirmTitle: 'Friendly Reminder',
        leaveConfirmMessage: 'Your AI work is still being generated. Switching pages will not affect progress. You can check processing or completed works in [My - My Works].\nAre you sure you want to leave?',
        leaveConfirmConfirm: 'Leave Page',
        leaveConfirmCancel: 'Stay Here',
        genDotIdle: 'No generation task',
        genDotActive: 'Generation in progress, please do not close the browser',
        genRecoveryTimeout: 'Generation timed out or page was closed',
        genRecoveryInterrupted: 'Generation interrupted by page refresh'
    },
    api: {
        errors: {
            requestFailed: 'Request failed',
            badRequest: 'Bad request',
            unauthorized: 'Unauthorized, please login again',
            forbidden: 'Forbidden',
            notFound: 'Resource not found',
            serverError: 'Internal server error',
            timeout: 'Request timeout, please try again',
            networkError: 'Network error, please check your connection',
            sessionExpired: 'Session expired, please login again',
            operationFailed: 'Operation failed!'
        }
    },
    nav: {
        home: 'Home',
        models: 'AI Models',
        pricing: 'Pricing',
        faq: 'FAQ',
        login: 'Login',
        signup: 'Upgrade',
        register: 'Register',
        email: 'Email',
        logout: 'Logout',
        help: 'Help',
        profile: 'Profile',
        myWorks: 'My Works',
        username: 'Username',
        password: 'Password',
        confirmPassword: 'Confirm Password',
        processing: 'Processing...',
        haveAccount: 'Already have an account?',
        noAccount: "Don't have an account?",
        orContinueWith: 'Or continue with',
        loginFailed: 'Login failed, please try again',
        registerFailed: 'Registration failed, please try again',
        fillRequired: 'Please fill in all required fields',
        passwordMismatch: 'Passwords do not match',
        passwordTooShort: 'Password must be at least 6 characters',
        googleNotLoaded: 'Google login service not loaded, please refresh the page',
        googleInitFailed: 'Google login initialization failed',
        googleUserInfoFailed: 'Unable to get user information',
        googleCancelled: 'Google login cancelled',
        codeLoginHint: 'Enter your email, we will send a verification code',
        verificationCode: 'Verification Code',
        sendCode: 'Send Code',
        resendCode: 'Resend',
        verifyAndLogin: 'Verify & Login',
        enterEmail: 'Please enter your email address',
        invalidEmail: 'Please enter a valid email address',
        sendCodeFailed: 'Failed to send verification code, please try again',
        checkSpamFolder: "Can't find the email? Check your spam/junk folder",
        enterValidCode: 'Please enter 6-digit verification code',
        verifyCodeFailed: 'Invalid or expired verification code',
        googleLoginFailed: 'Google login failed, please try again',
        registerHint: 'By registering, you agree to our',
        and: 'and',
        freeCreditsLabel: 'Free Credits:',
        freeCreditsDesc: 'Get free credits just by logging in — no payment required!',
        sidebar: {
            navigation: 'Navigation',
            home: 'Home',
            inspiration: 'Inspiration',
            allModels: 'All AI Models',
            videoAI: 'Video AI',
            videoGenerator: 'Video Generator',
            newModels: 'New Models',
            otherModels: 'Other Models',
            videoEnhance: 'Video Enhance',
            musicAI: 'AI Music',
            musicGenerator: 'AI Music',
            imageAI: 'Image AI',
            imageGenerator: 'Image Generator',
            hotModels: 'Hot Models',
            hotTools: 'Hot Tools',
            history: 'History',
            upgrade: 'Upgrade'
        }
    },
    footer: {
        brand: 'Miral',
        siteTitle: 'Miral - AI Image, Video & Music Creation Platform',
        desc: 'An all-in-one AI platform for image, video, and music creation.',
        fluxModels: 'FLUX Models',
        aiImages: 'AI Images',
        aiVideos: 'AI Videos',
        aiMusic: 'AI Music',
        product: 'Product',
        videoModels: 'AI Video Models',
        imageModels: 'AI Image Models',
        musicModels: 'AI Music Models',
        apps: 'Apps',
        tools: 'Tools',
        company: 'Company',
        about: 'About Us',
        contact: 'Contact Us',
        blog: 'Blog',
        resources: 'Resources',
        allModels: 'All AI Models',
        pricing: 'Pricing',
        trustSafety: 'Trust & Safety',
        terms: 'Terms of Service',
        privacy: 'Privacy Policy',
        faq: 'FAQ',
        musicGenerator: 'AI Music Generator',
        copyright: '© 2025 Miral. All rights reserved.',
        langZh: '简体中文',
        langEn: 'English'
    },
    about: {
        tag: 'About Miral',
        title: 'About Us',
        subtitle: 'Create images, videos, and music with leading AI models in one place.',
        paragraphs: [
            'Miral is an AI creation platform for creators, designers, and businesses. Generate images and videos, compose AI music, and use practical tools such as watermark removal and document cleanup.',
            'We continuously integrate leading models and reliable channels so you can go from idea to finished content in the browser.',
            'Learn more about our data practices on Trust & Safety, or contact support when you need help.'
        ]
    },
    contact: {
        tag: 'Support',
        title: 'Contact Us',
        subtitle: 'We will get back to your questions and feedback as soon as we can.',
        emailLabel: 'Support email',
        hint: 'Email us about billing, credits, or generation issues. We usually reply on business days.',
        cta: 'Send Email'
    },
    models: {
        image: {
            'nano-banana': {name: 'Nano Banana Pro', desc: 'Cinematic realism with natural skin, texture, and lighting details'},
            'nano-banana-31': {name: 'Nano Banana 3.1', desc: 'Multi-resolution image generation with v2.5 & v3.1 modes'},
            'seedream-4': {name: 'Seedream 4', desc: 'Artistic Style'},
            'seedream-5': {name: 'Seedream 5', desc: 'Artistic Style'},
            'midjourney': {name: 'Midjourney', desc: 'Artistic Style'},
            'gpt-image-1': {name: 'GPT-Image-1', desc: 'Multi-purpose'},
            'gpt-image-1-5': {name: 'GPT-Image-1-5', desc: 'Multi-purpose'},
            'flux-pro-1-1-ultra': {name: 'Flux Pro 1.1 Ultra', desc: 'High-quality text-to-image'},
            'flux-schnell': {name: 'Flux Schnell', desc: 'Fast text-to-image'},
            'flux-kontext': {name: 'Flux Kontext', desc: 'High-quality text-to-image & editing'},
            'flux-2': {name: 'FLUX.2', desc: 'Next-gen text-to-image'},
            'qwen-image-2-0-pro': {name: 'Qwen Image 2.0 Pro', desc: 'High-resolution text-to-image with fine detail'},
            'z-image-turbo': {name: 'Z Image Turbo', desc: 'High-resolution text-to-image generation'},
            'sd-3-5': {name: 'Stable Diffusion 3.5', desc: 'Stable Diffusion 3.5 text-to-image generation'}
        },
        video: {
            'pollodance': {name: 'Pollo Dance', desc: 'Motion control, refs & cinematic styles'},
            'seegen': {name: 'SeeGen', desc: 'Text & image to video, multi resolution'},
            'seedance': {name: 'Seedance AI', desc: 'Native Audio-Visual Sync'},
            'wan-2-5': {name: 'Wan 2.5', desc: 'Animation Style'},
            'wan-2-6': {name: 'Wan 2.6', desc: 'Enhanced Quality'},
            'veo-3-1': {name: 'Veo 3.1', desc: 'Multi-image Reference'},
            'veo-3-1-fast': {name: 'Veo 3.1 Fast', desc: 'Fast, supports tail frame'},
            'kling-2-6': {name: 'Kling 2.6', desc: 'Lip Sync'},
            'kling-3': {name: 'Kling 3', desc: 'Lip Sync'},
            'sora-2': {name: 'Sora 2', desc: '4s / 8s / 12s'},
            'kling-2-5': {name: 'Kling 2.5', desc: 'Standard'},
            'wan-2-2': {name: 'Wan 2.2', desc: 'Classic'},
            'vidu-q3-pro': {name: 'Vidu Q3 Pro', desc: 'Text & image to video, multi-res'},
            'veo-3-0': {name: 'Veo 3.0', desc: 'Text/Image to Video'},
            'hailuo-2-3': {name: 'Hailuo 2.3', desc: 'Creative Video'},
            'runway': {name: 'Runway', desc: 'Workbench'},
            'wan-animate': {name: 'Wan Animate', desc: 'Character Animation'}
        }
    },
    tools: {
        demoTitle: 'Demo',
        page: {
            tag: 'AI Toolbox',
            title: 'Professional AI Toolbox',
            subtitle: 'Watermark removal, photo restoration, HD upscaling, video enhancement and more professional tools for all your post-processing needs.',
            allTools: 'All Tools'
        },
        detail: {
            useNow: 'Use Now',
            clickUpload: 'Click or drag to upload ',
            support: 'Supports',
            reupload: 'Reupload',
            scale: 'Scale',
            process: 'Process',
            processing: 'Processing...',
            before: 'Before',
            after: 'After',
            download: 'Download Result',
            processNew: 'Process New File',
            howToUse: 'How to Use',
            moreTools: 'More Tools',
            notFound: 'Tool Not Found',
            backToList: 'Back to Tools',
            loginRequired: 'Login Required',
            loginRequiredDesc: 'Please login to use this tool',
            loginNow: 'Login now',
            demo: 'Demo',
            uploadOriginalFailed: 'Failed to upload original image, please try again'
        },
        steps: {
            upload: {
                title: 'Upload File',
                desc: 'Select or drag and drop the image or video file you want to process'
            },
            adjust: {
                title: 'Adjust Settings',
                desc: 'Configure processing parameters such as scale factor and output format'
            },
            process: {
                title: 'One-Click Process',
                desc: 'AI processes automatically, usually completed within seconds to minutes'
            },
            download: {title: 'Download Result', desc: 'Preview the result and download the high-quality output.'}
        },
        fileTypes: {
            image: 'Image',
            video: 'Video'
        },
        imageEnhancer: {
            name: 'Image Enhancer',
            desc: 'Upscale images to 4K resolution with enhanced details',
            fullDesc: 'Upscale images to 4K resolution with enhanced details. Uses advanced AI algorithms to enhance details, making blurry images sharp and clear.'
        },
        'doc-crop-enhance': {
            name: 'Image Crop & Dewarp',
            desc: 'Crop edges and correct document distortion with AI',
            fullDesc: 'Crop document edges online, correct skew, perspective and curved pages, then improve scans with brighten, sharpen, black-and-white, grayscale and shadow removal modes. Ideal for test papers, homework, textbooks and classroom worksheets.',
            enhanceMode: 'Enhance Mode',
            enhanceModes: {
                disabled: 'Disabled',
                brighten: 'Brighten',
                sharpen: 'Enhance & Sharpen',
                blackWhite: 'Black & White',
                grayscale: 'Grayscale',
                deshadow: 'Shadow Removal',
                bitmap: 'Bitmap'
            },
            cropImage: 'Crop Edges',
            dewarpImage: 'Dewarp',
            featuresKicker: 'DOCUMENT SCAN ENHANCEMENT',
            featuresTitle: 'Turn Document Photos into Clean, Properly Aligned Scans',
            featuresIntro: 'Handle document edges, skew, perspective, curved pages, shadows and text clarity for common mobile capture and scan-enhancement needs.',
            features: [
                { title: 'Detect and Crop Document Edges Automatically', desc: 'Find the boundary between the paper and its background, then remove desks, edge shadows and unrelated areas for a cleaner page.', cta: 'Crop a Document for Free' },
                { title: 'Straighten Skewed Documents and Correct Perspective', desc: 'Fix trapezoid distortion, tilted pages and proportions caused by angled phone photos of contracts, forms and test papers.', cta: 'Correct a Document Photo' },
                { title: 'Dewarp Curved Pages and Scanned Documents', desc: 'Correct distortion near book bindings, curled paper and folded pages to make textbook and book photos easier to read.', cta: 'Dewarp a Curved Document' },
                { title: 'Remove Shadows from Document Scans', desc: 'Reduce shadows caused by phones, fingers, book spines and uneven lighting for cleaner receipts, worksheets and scanned pages.', cta: 'Remove Document Shadows' },
                { title: 'Brighten Documents and Sharpen Text', desc: 'Improve brightness and printed text edges in low-contrast documents for easier reading, printing and organization.', cta: 'Sharpen Scanned Text' },
                { title: 'Create Black-and-White, Grayscale or Bitmap Scans', desc: 'Convert color document photos into black-and-white, grayscale or bitmap-enhanced images for printing and archiving.', cta: 'Enhance a Document Image' }
            ],
            useCasesKicker: 'COMMON USE CASES',
            useCasesTitle: 'Which Document Images Can Be Cropped and Enhanced?',
            useCasesIntro: 'Designed for individual document images captured by phone or scanner with uneven framing, shadows, distortion or unclear text.',
            useCases: [
                { title: 'Phone Photo to Scan', desc: 'Remove desk backgrounds and correct camera angles to make phone photos look more like scans.' },
                { title: 'Contracts and Forms', desc: 'Crop contracts, applications and forms to restore clean edges and page proportions.' },
                { title: 'Receipts and Invoices', desc: 'Reduce shadows and sharpen faint printed text for clearer viewing and archiving.' },
                { title: 'Curved Book Pages', desc: 'Correct curvature near the bindings of textbooks, books and workbooks.' },
                { title: 'Test Papers and Worksheets', desc: 'Straighten test papers, remove shadows and sharpen printed text for reuse or printing.' },
                { title: 'Black-and-White Archives', desc: 'Convert document photos into consistent black-and-white or grayscale scan styles.' }
            ],
            faqTitle: 'AI Document Crop and Correction FAQ',
            faqs: [
                { q: 'What is AI document cropping and correction?', a: 'It detects the document area, removes surrounding background and can correct skew, perspective or curved-page distortion based on your settings.' },
                { q: 'How do I auto-crop scanned document images online?', a: 'Enable edge cropping, then upload the scanned document image. The tool attempts to detect the paper boundary and remove the area outside the document.' },
                { q: 'Can I deskew a scanned document online?', a: 'Yes. Use straightening for a tilted scan and perspective correction for an angled phone photo. Use dewarping only when the page itself is curved.' },
                { q: 'What is the difference between deshadow and sharpen modes?', a: 'Deshadow improves uneven page lighting, while sharpen strengthens text and line edges. Choose the mode that matches the source problem.' },
                { q: 'What tool can I use to enhance scanned test papers, contracts and receipts?', a: 'Use this document crop and enhancement tool with deshadow for uneven lighting, sharpen for faint text, and black-and-white or grayscale when preparing documents for printing.' },
                { q: 'Can it turn a phone photo into a scanned document?', a: 'Cropping, correction and enhancement can produce a scan-like image, but the tool does not generate PDFs or extract OCR text.' },
                { q: 'Which image formats and file sizes are supported?', a: 'JPG, PNG and WebP images are supported, with a maximum file size of 15MB.' },
                { q: 'Does processing change the original document content?', a: 'The tool adjusts framing, geometry, brightness and clarity. It does not edit text or extract document content.' }
            ],
            education: {
                kicker: 'EDUCATION DOCUMENTS',
                title: 'Turn Test Papers, Homework and Textbook Photos into Clear Scans',
                intro: 'Detect educational document edges automatically and correct skew, perspective, curved pages and shadows for cleaner printing, archiving and classroom use.',
                items: [
                    { title: 'Crop Test Paper Photos', desc: 'Detect test paper edges and remove the desk background to create a clean, properly framed page.' },
                    { title: 'Correct Homework Images', desc: 'Fix skew and perspective in homework photos so they are easier to review, submit and print.' },
                    { title: 'Dewarp Textbook Pages', desc: 'Correct curved pages near book bindings and reduce shadows that make printed content harder to read.' },
                    { title: 'Sharpen Classroom Worksheets', desc: 'Brighten and sharpen worksheets or study materials with clean black-and-white or grayscale scan effects.' }
                ],
                relatedTitle: 'Need to remove handwritten answers from a test paper?',
                relatedDesc: 'This tool handles cropping, geometric correction and image enhancement. Use the handwriting eraser to remove student answers, calculations or teacher annotations.',
                relatedCta: 'Open Handwriting Eraser'
            },
            notImageFile: 'Please upload a valid image file',
            fileTooLarge: 'Image too large, please select an image under 15MB',
            noImageInResponse: 'Processing failed, please try again',
            downloadName: 'doc-crop-enhanced.png'
        },
        'watermark-remover': {
            name: 'AI Watermark Remover',
            desc: 'Remove watermarks from images and photos online with AI',
            fullDesc: 'Use the free AI watermark remover online to clean full-image watermarks, logos, timestamps, text, and draft marks from photos while preserving the original content, background details, and visual quality.',
            aiRepair: 'Watermark Removal',
            uploadLabel: 'Upload Image',
            uploadHint: 'Supports JPG, PNG, or WebP images up to 15MB.',
            featuresKicker: 'Fast and accurate',
            featuresTitle: 'Remove Different Watermarks from Photos Online',
            featuresIntro: 'Upload a JPG, PNG, or WebP image and let AI detect watermark areas and reconstruct the background without manual brushing.',
            features: [
                { title: 'Clear Full-Image Watermarks', desc: 'Remove repeated translucent text or pattern watermarks that cover the whole image for a cleaner result.', cta: 'Try AI Watermark Remover Free' },
                { title: 'Remove Timestamps and Date Marks', desc: 'Clean dates, timestamps, and camera marks from photo corners while reconstructing the background behind them.', cta: 'Erase Image Watermarks Online' },
                { title: 'Erase Brand Logos', desc: 'Remove brand logos, corner badges, and promotional marks from images you have permission to edit.', cta: 'Remove Photo Watermarks Now' },
                { title: 'Clean Text and Draft Marks', desc: 'Remove text overlays from previews, design drafts, and photos to create cleaner visual content.', cta: 'Try the Watermark Remover Now' }
            ],
            useCasesKicker: 'Use cases',
            useCasesTitle: 'What Can the AI Image Watermark Remover Clean?',
            audienceLabels: ['Ecommerce Sellers', 'Marketing Teams', 'Designers & Creators', 'Fashion & Apparel Stores'],
            audienceCases: [
                { title: 'Prepare Product Visuals 3× Faster', desc: 'Before creating polished product listing images, clean authorized product photos, supplier images, or draft assets first. Remove distracting marks so shoppers can focus on the product.' },
                { title: 'Cut Manual Cleanup by 60% and Create Campaign Assets Faster', desc: 'Before turning owned or licensed visuals into ads, banners, and brand graphics, remove unwanted watermarks. Clean assets can move faster into campaign promotions, product launches, and product posters.' },
                { title: 'Turn Clean Images into Fresh Creative Concepts Faster', desc: 'Start with cleaner source images to explore new design directions without rebuilding from scratch. Use cleaned drafts as references for AI sketches, concept art, or poster-style visuals.' },
                { title: 'Refresh Product Catalog Images Without Reshooting', desc: 'Before preparing catalog updates, seasonal launches, or AI virtual try-on visuals, clean authorized apparel photos so shoppers can focus on fit, fabric, and product details.' }
            ],
            useCases: [
                { title: 'Watermark Removal for Product Photos', desc: 'Clean text, logos, and promotional marks from product photos before relayout of your own assets.' },
                { title: 'Watermark Removal for Social Photos', desc: 'Remove platform marks or timestamps from your own photos for a cleaner publishing version.' },
                { title: 'Clean Multiple Watermarks', desc: 'When one image contains several watermarks, AI can detect and clean multiple covered areas.' }
            ],
            howToKicker: 'Three simple steps',
            howToTitle: 'How to Remove Watermarks from Images Online for Free',
            howToIntro: 'No software installation is needed. Upload an image, run the AI watermark remover, and download the cleaned result.',
            howToCta: 'Remove Watermarks Online Now',
            steps: {
                upload: { title: 'Upload a Watermarked Image', desc: 'Choose a JPG, PNG, or WebP image under 15MB. Make sure you have the right to edit and use it.' },
                remove: { title: 'Remove the Watermark with AI', desc: 'Start processing and AI will detect logos, text, timestamps, or full-image watermarks and reconstruct the background.' },
                download: { title: 'Preview and Download', desc: 'Compare the before and after results, then download the cleaned image or upload another one.' }
            },
            faqTitle: 'AI Watermark Remover FAQ',
            faqs: [
                { q: 'What is an AI watermark remover?', a: 'An AI watermark remover detects watermark areas and reconstructs covered backgrounds using nearby colors, textures, and image content.' },
                { q: 'How to remove watermarks from photos online for free?', a: 'Sign up, upload an image to the Miral AI watermark remover, and start processing to preview the cleaned result.' },
                { q: 'Which image formats are supported?', a: 'The tool currently supports JPG, PNG, and WebP images under 15MB. This page does not remove watermarks from videos.' },
                { q: 'Can it remove full-image watermarks, logos, and timestamps?', a: 'Yes. AI can process repeated full-image watermarks, brand logos, date stamps, text, and draft marks. Results depend on opacity, covered area, and background complexity.' },
                { q: 'What tool can I use to remove multiple logos or timestamps from one photo?', a: 'The Miral AI watermark remover can process multiple watermark areas, including logos and timestamps. Check the preview when large marks cover people or complex textures.' },
                { q: 'Is removing a watermark from an image legal?', a: 'Only process images you own, are authorized to edit, or may legally use. Removing copyright watermarks without permission may infringe the rights of the owner.' },
                { q: 'How to fix blurry areas after removing a watermark?', a: 'Start with the highest-quality source image available and check the preview before downloading. AI attempts to preserve the original composition, resolution, and details, but content hidden by large watermarks must be reconstructed, so local results may differ from the original.' }
            ],
            fileTooLarge: 'Image is too large. Please use a file under 15MB (JPG, PNG, or WebP).',
            notImageFile: 'Please upload an image file.',
            noImageInResponse: 'No result image was returned. Please try again later.',
            downloadName: 'watermark-removed.png'
        },
        'full-watermark-remover': {
            name: 'AI Watermark Remover',
            desc: 'Remove image watermarks with AI',
            fullDesc: 'Use AI to detect and remove image watermarks while preserving the original content, details, and visual quality.',
            notImageFile: 'Please upload a valid image file.',
            fileTooLarge: 'Image too large, please select an image under 15MB.',
            downloadName: 'full-watermark-removed.png'
        },
        'ai-text-remover': {
            name: 'AI Text Remover',
            desc: 'Remove unwanted text from images with AI',
            fullDesc: 'Remove unwanted text from images with AI while preserving the background, texture, and natural visual details.',
            notImageFile: 'Please upload a valid image file.',
            fileTooLarge: 'Image too large, please select an image under 15MB.',
            downloadName: 'text-removed.png'
        },
        'ai-logo-remover': {
            name: 'AI Logo Remover',
            desc: 'Remove unwanted logos from images with AI',
            fullDesc: 'Remove unwanted logos from images with AI while preserving the background, texture, and natural visual details.',
            notImageFile: 'Please upload a valid image file.',
            fileTooLarge: 'Image too large, please select an image under 15MB.',
            downloadName: 'logo-removed.png'
        },
        'ai-passersby-remover': {
            name: 'AI Passersby Remover',
            desc: 'Remove passersby from images with AI',
            fullDesc: 'Use AI to detect and remove passersby from images while preserving the subject, background texture, and natural visual details.',
            notImageFile: 'Please upload a valid image file.',
            fileTooLarge: 'Image too large, please select an image under 15MB.',
            downloadName: 'passersby-removed.png'
        },
        'background-remover': {
            name: 'Background Remover',
            desc: 'Remove image backgrounds in one click with AI',
            heroTitle: 'Free AI Background Remover for Transparent PNGs',
            fullDesc: 'Upload a JPG, PNG, or WebP image and let AI detect portraits, products, and subject edges. Preserve fine details such as hair and download a transparent PNG without Photoshop.',
            uploadLabel: 'Upload an Image',
            uploadHint: 'Click or drag to upload an image',
            uploadSpec: 'Supports JPG, PNG, or WebP files up to 15MB. Results download as transparent PNGs.',
            processButton: 'Remove Image Background',
            previewAlt: 'Image preview ready for AI background removal',
            demoBeforeAlt: 'Portrait before background removal',
            demoAfterAlt: 'Portrait after AI background removal',
            processingAlt: 'AI removing the image background',
            processingLabel: 'Creating Cutout',
            resultLabel: 'Transparent Background Ready',
            resultBeforeAlt: 'Original image before background removal',
            resultAfterAlt: 'Transparent PNG after AI background removal',
            productBeforeAlt: 'Product photo before background removal',
            productAfterAlt: 'Product cutout with a transparent background',
            featuresKicker: 'Precise subject detection',
            featuresTitle: 'Online AI Background Remover for Portraits and Product Photos',
            featuresIntro: 'From detailed portrait edges to ecommerce product cutouts, AI separates the subject from its background without manual brushes, paths, or masks.',
            features: [
                { title: 'Remove Portrait Backgrounds and Preserve Hair', desc: 'Detect people, clothing, and fine hair edges for profile photos, headshots, posters, and social media graphics with a cleaner cutout.', cta: 'Remove Portrait Background Free' },
                { title: 'Create Product Photo Cutouts in One Click', desc: 'Remove tables, walls, and studio scenes from product photos, then reuse the transparent subject in white-background listings, ads, and product pages.', cta: 'Remove Product Background Online' },
                { title: 'Download a Transparent PNG', desc: 'Keep the transparent channel so the subject is ready for a new background, banner, presentation, thumbnail, or graphic design without another manual cutout.', cta: 'Make Background Transparent' }
            ],
            featureAlts: {
                portraitBefore: 'Portrait photo before background removal',
                portraitAfter: 'Portrait cutout with preserved hair details',
                productBefore: 'Product photo before removing the background',
                productAfter: 'Product cutout on a transparent background',
                ecommerceBefore: 'Ecommerce product image before background removal',
                ecommerceAfter: 'Transparent PNG for an ecommerce product'
            },
            useCasesKicker: 'Popular use cases',
            useCasesTitle: 'Which Images Work with One-Click AI Cutout?',
            useCasesIntro: 'Use the background remover whenever you need an isolated subject or transparent image asset for everyday creative and commercial work.',
            useCases: [
                { title: 'Ecommerce Product Images', desc: 'Prepare clean transparent product assets for catalogs, stores, and marketing layouts.' },
                { title: 'Portraits and Profile Photos', desc: 'Remove a distracting scene while preserving hair, clothing, and the subject outline.' },
                { title: 'Social Media Graphics', desc: 'Place people or products into covers, posts, thumbnails, and short-form video designs.' },
                { title: 'Headshots and ID Photo Prep', desc: 'Separate the person first, then add the required solid color in your design tool.' },
                { title: 'Logos and Graphic Assets', desc: 'Remove an unwanted background before reusing artwork on websites, posters, or slides.' },
                { title: 'Ads and Graphic Design', desc: 'Create flexible transparent PNG assets and spend less time on repetitive manual cutouts.' }
            ],
            howToKicker: 'Three simple steps',
            howToTitle: 'How to Remove an Image Background Online for Free',
            howToIntro: 'Upload an image, run the automatic AI cutout, then preview and download a transparent PNG.',
            steps: [
                { title: 'Upload a JPG, PNG, or WebP', desc: 'Choose a clear portrait, product, or design image under 15MB.' },
                { title: 'Remove the Background with AI', desc: 'Start processing and AI will separate the subject while preserving important edge details.' },
                { title: 'Preview and Download the PNG', desc: 'Compare the result, download the transparent image, or process another file.' }
            ],
            faqTitle: 'AI Background Remover FAQ',
            faqs: [
                { q: 'How can I remove an image background online for free?', a: 'Upload a JPG, PNG, or WebP image and select Remove Image Background. AI detects the subject automatically, then lets you preview and download the transparent PNG.' },
                { q: 'Can AI background removal preserve hair and fine edges?', a: 'The tool detects portrait outlines and aims to retain hair, clothing, and small edge details. A clear image with good subject-to-background contrast usually produces a more natural cutout.' },
                { q: 'Can I remove the background from a product photo?', a: 'Yes. Product photos with a clearly visible subject work well for creating transparent assets for ecommerce listings, product pages, and advertising designs.' },
                { q: 'What file format do I get after background removal?', a: 'The processed result downloads as a PNG with transparency, ready to place on another background or use in a design layout.' },
                { q: 'Which image formats and file sizes are supported?', a: 'You can upload JPG, PNG, and WebP images up to 15MB per file.' },
                { q: 'Do I need Photoshop to make an image background transparent?', a: 'No. AI detects the main subject and removes the background directly in your browser without manual paths, masks, or desktop software.' }
            ],
            fileTooLarge: 'Image is too large. Please use a file under 15MB (JPG, PNG, or WebP).',
            notImageFile: 'Please upload an image file.',
            noImageInResponse: 'No result image was returned. Please try again later.',
            downloadName: 'background-removed.png'
        },
        'image-eraser': {
            name: 'Image Eraser',
            desc: 'Erase any object, person, or watermark from images with AI',
            fullDesc: 'AI-powered image eraser. Brush over any unwanted object, person, watermark, or text in your photo and the AI will seamlessly remove it and fill the area with natural content. Perfect for cleaning up photos and removing distractions.',
            fileTooLarge: 'Image is too large. Please use a file under 15MB (JPG, PNG, or WebP).',
            notImageFile: 'Please upload an image file.',
            noImageInResponse: 'No result image was returned. Please try again later.',
            downloadName: 'image-erased.png'
        },
        'object-remover': {
            name: 'AI Object Remover',
            desc: 'Remove unwanted objects and distractions from photos with AI',
            fullDesc: 'Remove unwanted objects from photos online for free with AI. Upload an image, brush over people, clutter, signs, wires, or other distractions, and let AI reconstruct the covered background for a clean, natural-looking result.',
            uploadLabel: 'Upload Image',
            uploadHint: 'Click or drag to upload an image',
            uploadSpec: 'Supports JPG, PNG, or WebP images.',
            maskHint: 'Brush over every part of the object you want AI to remove.',
            processButton: 'Remove Object',
            demoBeforeAlt: 'Photo before unwanted object removal',
            demoAfterAlt: 'Photo after unwanted object removal',
            processingAlt: 'AI processing the marked photo',
            resultBeforeAlt: 'Original photo before object removal',
            resultAfterAlt: 'Clean photo after object removal',
            featureImageLabels: {
                object: 'unwanted object removal example',
                person: 'person removal example',
                distraction: 'background distraction removal example'
            },
            featuresKicker: 'Precise photo cleanup',
            featuresTitle: 'Remove Unwanted Objects from Photos Online',
            featuresIntro: 'Mark the exact area you want to clean and use AI object removal for everyday photo distractions without manually rebuilding the background.',
            features: [
                { title: 'Brush Away Unwanted Objects', desc: 'Use an adjustable brush to mark clutter, signs, props, or other objects. AI removes the selected area and fills it with surrounding image details.', cta: 'Remove Objects Free' },
                { title: 'Remove People from Photo Backgrounds', desc: 'Clean photobombers, tourists, or passersby from travel shots and portraits when they distract from the main subject.', cta: 'Clean Photo Backgrounds Free' },
                { title: 'Erase Small Background Distractions', desc: 'Remove wires, bins, street clutter, marks, or isolated visual distractions to create a cleaner composition.', cta: 'Erase Photo Distractions Free' }
            ],
            useCasesKicker: 'Popular use cases',
            useCasesTitle: 'What Can You Remove with the AI Object Remover?',
            useCasesIntro: 'Designed for focused edits where you can clearly brush over the unwanted area and keep the rest of the photo unchanged.',
            useCases: [
                { title: 'Travel Photo Cleanup', desc: 'Remove passersby, signs, bins, or street clutter from vacation photos.' },
                { title: 'Product Photo Cleanup', desc: 'Erase props, labels, cables, and distracting items around a product.' },
                { title: 'Portrait Background Cleanup', desc: 'Remove background people and small objects that pull attention from the subject.' },
                { title: 'Real Estate Photos', desc: 'Clean temporary clutter and isolated objects from room or property images.' },
                { title: 'Social Media Images', desc: 'Polish photos before posting by removing visible distractions from the frame.' },
                { title: 'Creative Photo Editing', desc: 'Clear selected areas before reusing an image in a layout or visual project.' }
            ],
            howToKicker: 'Three simple steps',
            howToTitle: 'How to Remove an Object from a Photo Online',
            howToIntro: 'Upload a photo, brush over the unwanted object, and download the AI-cleaned result.',
            steps: [
                { title: 'Upload Your Photo', desc: 'Choose the image that contains the person, item, or distraction you want to erase.' },
                { title: 'Brush Over the Object', desc: 'Adjust the brush and cover the full unwanted area. Use undo or the eraser to refine the mask.' },
                { title: 'Remove and Download', desc: 'Start AI processing, compare the before and after images, then download the cleaned photo.' }
            ],
            faqTitle: 'AI Object Remover FAQ',
            faqs: [
                { q: 'How to remove unwanted objects from photos online?', a: 'Upload a photo, brush over the entire unwanted object, and start processing. AI reconstructs the selected area using nearby colors, textures, and scene details.' },
                { q: 'What tool can I use to remove a person from a photo background?', a: 'Use the brush to cover the person and include details such as shadows or carried items. Results are usually better when the surrounding background is visible.' },
                { q: 'Can AI remove signs, wires, bins, and street clutter?', a: 'Yes. Clearly mark the unwanted area and avoid covering nearby subjects you want to keep. Small, isolated distractions are generally easier to reconstruct.' },
                { q: 'How can I get a more natural object removal result?', a: 'Use a clear, high-quality source image and brush slightly beyond the object edges. Process difficult areas separately when several objects overlap.' },
                { q: 'Does the object remover change the whole photo?', a: 'The removal request is based on the brushed mask. The tool focuses on the selected area, although AI must reconstruct pixels around its edges.' },
                { q: 'Which image formats can I upload?', a: 'The upload control accepts common image formats including JPG, PNG, and WebP.' }
            ],
            fileTooLarge: 'Image is too large. Please use a file under 15MB (JPG, PNG, or WebP).',
            notImageFile: 'Please upload an image file.',
            noImageInResponse: 'No result image was returned. Please try again later.',
            downloadName: 'object-removed.png'
        },
        'ai-person-remover': {
            name: 'AI People Remover',
            desc: 'Remove people from photos with AI',
            fullDesc: 'AI-powered person remover. Brush over any person in your photo and the AI will seamlessly erase them and fill the area with natural content. Perfect for removing passersby, tourists, or strangers from your shots.',
            fileTooLarge: 'Image is too large. Please use a file under 15MB (JPG, PNG, or WebP).',
            notImageFile: 'Please upload an image file.',
            noImageInResponse: 'No result image was returned. Please try again later.',
            downloadName: 'person-removed.png'
        },
        'background-blur': {
            name: 'Background Blur',
            desc: 'Blur image background with AI in one click to highlight the subject',
            fullDesc: 'AI automatically detects the foreground subject (person/object), keeps the subject sharp and applies a Gaussian blur to the background for a Portrait Mode effect. Ideal for portraits and product close-ups.',
            fileTooLarge: 'Image is too large. Please use a file under 15MB (JPG, PNG, or WebP).',
            notImageFile: 'Please upload an image file.',
            noImageInResponse: 'No result image was returned. Please try again later.',
            downloadName: 'background-blur.png'
        },
        'white-background': {
            name: 'White Background',
            desc: 'Replace image background with white using AI',
            fullDesc: 'AI-powered white background replacement with one click. Precisely detects subject outline, preserves fine details like hair, outputs image with clean white background. Ideal for product photos and ID pictures.',
            fileTooLarge: 'Image is too large. Please use a file under 15MB (JPG, PNG, or WebP).',
            notImageFile: 'Please upload an image file.',
            noImageInResponse: 'No result image was returned. Please try again later.',
            downloadName: 'white-background.png'
        },
        'blue-background': {
            name: 'Blue Background',
            desc: 'Replace image background with blue using AI',
            fullDesc: 'AI-powered blue background replacement with one click. Precisely detects subject outline, preserves fine details like hair, outputs image with clean blue background. Ideal for passport photos and ID pictures.',
            fileTooLarge: 'Image is too large. Please use a file under 15MB (JPG, PNG, or WebP).',
            notImageFile: 'Please upload an image file.',
            noImageInResponse: 'No result image was returned. Please try again later.',
            downloadName: 'blue-background.png'
        },
        'face-swap': {
            name: 'Photo Face Swap',
            desc: 'Swap a face between two photos online with AI',
            fullDesc: 'Swap faces between two photos online for free with AI. Upload a target photo and a clear source face, then generate a natural-looking face replacement that follows the target pose, lighting, and composition.',
            fileTooLarge: 'Image is too large. Please use a file under 15MB (JPG, PNG, or WebP).',
            notImageFile: 'Please upload an image file.',
            targetImage: 'Target Photo',
            sourceImage: 'Source Face',
            effectImageLabel: 'Result',
            processButton: 'Swap Face',
            targetPreviewAlt: 'Target photo preview for AI face swap',
            sourcePreviewAlt: 'Source face preview for AI face swap',
            processingAlt: 'AI face swap processing preview',
            resultBeforeAlt: 'Target photo before face swap',
            resultAfterAlt: 'Photo after AI face swap',
            downloadName: 'face-swap-result.png',
            step1Title: 'Upload Photos',
            step1Desc: 'Upload target photo and source face photo',
            step2Title: 'Photo Face Swap',
            step2Desc: 'Click process, AI swaps the face automatically',
            step3Title: 'Download',
            step3Desc: 'Preview and download the result',
            featuresKicker: 'Natural face replacement',
            featuresTitle: 'Swap Faces Between Photos with AI',
            featuresIntro: 'Use a target photo for the pose and composition, then provide a clear source face for a focused photo face swap.',
            features: [
                { title: 'Create a Natural-Looking Face Swap', desc: 'AI blends the source identity into the target photo while following its pose, framing, lighting, and overall visual style.', cta: 'Create a Photo Face Swap Free' },
                { title: 'Keep the Target Photo Composition', desc: 'Use a portrait, selfie, character image, or creative scene as the target while keeping its background and composition.', cta: 'Try Photo Face Swap Free' },
                { title: 'Use a Clear Source Face', desc: 'Upload a front-facing, well-lit source image with visible facial details to help the model create a more consistent replacement.', cta: 'Upload and Swap Free' }
            ],
            useCasesKicker: 'Creative photo ideas',
            useCasesTitle: 'Popular Uses for Online Photo Face Swap',
            useCasesIntro: 'Create playful and creative photo edits using one target image and one source face image.',
            useCases: [
                { title: 'Selfie and Profile Photo Face Swaps', desc: 'Replace a face in a selfie or portrait while preserving the target pose, background, and framing. Explore profile-photo concepts and personal portrait ideas with a clear source face.', cta: 'Create a Portrait Face Swap Free', imageAlt: 'AI face swap example for selfies and profile photos' },
                { title: 'Memes and Social Reaction Images', desc: 'Turn familiar photos into personalized memes, playful reaction images, and shareable social content. A clear target expression helps keep the final image easy to recognize.', cta: 'Make a Meme Face Swap Free', imageAlt: 'Creative meme and social reaction image use case' },
                { title: 'Cosplay, Characters, and Creative Stories', desc: 'Try a face in a costume, fantasy portrait, illustrated character, or themed scene. Use face swapping to explore character concepts and create visual stories from images you may edit.', cta: 'Try a Character Face Swap Free', imageAlt: 'Cosplay and character face swap use case' }
            ],
            howToKicker: 'Three simple steps',
            howToTitle: 'How to Swap Faces in Photos Online with AI',
            howToIntro: 'Choose a target photo, add a clear source face, and let AI generate the face-swapped result.',
            faqTitle: 'Photo Face Swap FAQ',
            faqs: [
                { q: 'How to swap a face between two photos online?', a: 'Upload the photo whose pose and composition you want to keep as the target, then upload the identity you want to use as the source face and start processing.' },
                { q: 'What is the difference between the target photo and source face?', a: 'The target photo supplies the pose, background, and composition. The source face supplies the facial identity used for the replacement.' },
                { q: 'How do I choose a good source image for face swapping?', a: 'Use a clear, well-lit image with an unobstructed face. A source angle and expression similar to the target can produce a more consistent result.' },
                { q: 'Can I use AI face swap for selfies, memes, or cosplay photos?', a: 'Yes. These are common creative uses when you own or have permission to edit the uploaded images.' },
                { q: 'Why does a face swap sometimes look less realistic?', a: 'Large differences in face angle, lighting, expression, resolution, or heavy occlusion can make blending more difficult. Try clearer and more compatible source photos.' },
                { q: 'Which image formats and file sizes are supported?', a: 'JPG, PNG, and WebP images are supported, with a maximum file size of 15MB per image.' },
                { q: 'Can I swap a face in a video on this page?', a: 'No. This page processes still images and returns an image result.' }
            ]
        },
        'image-enhancer': {
            name: 'Image Enhancer',
            desc: 'Enhance image clarity in one click with AI',
            fullDesc: 'Upscale images to 4K resolution with enhanced details. Uses advanced AI algorithms to enhance details, making blurry images sharp and clear.',
            fileTooLarge: 'Image is too large. Please use a file under 15MB (JPG, PNG, or WebP).',
            notImageFile: 'Please upload an image file.',
            downloadName: 'image-enhanced.png',
            targetResolution: 'Target resolution',
            outputFormat: 'Output format',
            resolutions: {
                '2k': '2K',
                '4k': '4K',
                '8k': '8K'
            },
            formats: {
                JPEG: 'JPEG',
                PNG: 'PNG',
                WEBP: 'WEBP'
            },
            processFailed: 'Processing failed. Try another image or output format.'
        },
        'video-enhancer': {
            name: 'Video Enhancer',
            desc: 'Enhance video quality with AI upscaling',
            fullDesc: 'Enhance video quality to HD/4K with AI frame interpolation and sharpening.',
            notVideoFile: 'Please upload a video file (e.g. MP4, MOV, AVI).',
            fileTooLarge: 'Video is too large. Please use a file under 100MB.'
        },
        'cartoon-video-style-converter': {
            name: 'Cartoon Style Converter',
            desc: 'Convert videos into cartoon style',
            fullDesc: 'Upload a video and AI will convert it into a cartoon style while preserving the main motion, framing, and scene rhythm.',
            notVideoFile: 'Please upload a valid video file.',
            fileTooLarge: 'Video is too large. Please select a video under 100MB.',
            downloadName: 'cartoon-style-video.mp4'
        },
        'anime-video-style-converter': {
            name: 'Anime Style Converter',
            desc: 'Convert videos into anime style',
            fullDesc: 'Upload a video and AI will convert it into an anime style while preserving subject motion and shot pacing.',
            notVideoFile: 'Please upload a valid video file.',
            fileTooLarge: 'Video is too large. Please select a video under 100MB.',
            downloadName: 'anime-style-video.mp4'
        },
        'oil-painting-video-style-converter': {
            name: 'Oil Painting Style Converter',
            desc: 'Convert videos into oil painting style',
            fullDesc: 'Upload a video and AI will convert it into an oil painting style with richer color layers and painterly texture.',
            notVideoFile: 'Please upload a valid video file.',
            fileTooLarge: 'Video is too large. Please select a video under 100MB.',
            downloadName: 'oil-painting-style-video.mp4'
        },
        'cyberpunk-video-style-converter': {
            name: 'Cyberpunk Style Converter',
            desc: 'Convert videos into cyberpunk style',
            fullDesc: 'Upload a video and AI will convert it into a high-contrast cyberpunk style with neon futuristic visuals.',
            notVideoFile: 'Please upload a valid video file.',
            fileTooLarge: 'Video is too large. Please select a video under 100MB.',
            downloadName: 'cyberpunk-style-video.mp4'
        },
        'photo-restore': {
            name: 'Photo Restoration',
            desc: 'Restore old, blurry or damaged photos with AI technology',
            fullDesc: 'Restore old, blurry or damaged photos with AI technology. Supports denoising, sharpening, and filling missing parts to bring precious memories back to life.',
            notImageFile: 'Please upload a valid image file.',
            fileTooLarge: 'Image too large, please select an image under 15MB.',
            downloadName: 'photo-restored.png'
        },
        'blurry-photo-repair': {
            name: 'Fix Blurry Images',
            desc: 'Repair blurry images and recover clearer details with AI',
            fullDesc: 'Repair blurry images with AI. Enhance sharpness, recover facial and texture details, and make soft photos clearer for sharing or archiving.',
            notImageFile: 'Please upload a valid image file.',
            fileTooLarge: 'Image too large, please select an image under 15MB.',
            downloadName: 'blurry-image-fixed.png'
        },
        'cartoon-digital-human': {
            name: 'AI Cartoon Character Generator',
            desc: 'Turn a portrait into cartoon style',
            fullDesc: 'Generate an anime-style cartoon digital human from a portrait. Preserve the person’s recognizable features while creating a polished avatar with clean linework and vivid colors.',
            notImageFile: 'Please upload a valid image file.',
            fileTooLarge: 'Image too large, please select an image under 15MB.',
            downloadName: 'cartoon-digital-human.png'
        },
        'manga-digital-human': {
            name: 'AI Manga Style Character Generator',
            desc: 'Turn a portrait into manga style',
            fullDesc: 'Generate a manga-style digital human from a portrait. Preserve the person’s recognizable features while creating a clean comic look with expressive linework and polished shading.',
            notImageFile: 'Please upload a valid image file.',
            fileTooLarge: 'Image too large, please select an image under 15MB.',
            downloadName: 'manga-digital-human.png'
        },
        'oil-painting-digital-human': {
            name: 'AI Oil Painting Portrait Generator',
            desc: 'Turn a portrait into oil painting style',
            fullDesc: 'Generate an oil painting style digital human from a portrait. Preserve recognizable features while creating a refined painterly portrait with rich color and brush texture.',
            notImageFile: 'Please upload a valid image file.',
            fileTooLarge: 'Image too large, please select an image under 15MB.',
            downloadName: 'oil-painting-digital-human.png'
        },
        'id-photo-generator': {
            name: 'ID Photo Generator',
            desc: 'Generate a standard ID photo from a portrait',
            fullDesc: 'Generate a clean, professional ID photo from a portrait. AI adjusts the subject into a neat document-photo look suitable for profile and ID-style use.',
            notImageFile: 'Please upload a valid image file.',
            fileTooLarge: 'Image too large, please select an image under 15MB.',
            downloadName: 'id-photo.png'
        },
        'ai-change-clothes': {
            name: 'AI Clothes Changer',
            desc: 'Upload outfit and person images, one-click outfit change',
            fullDesc: 'Upload the outfit image first, then upload the person image. AI transfers the selected outfit onto the portrait while preserving the person, pose, and natural image details.',
            demoTitle: 'Demo',
            notImageFile: 'Please upload a valid image file.',
            fileTooLarge: 'Image too large, please select an image under 15MB.',
            firstImageLabel: 'Outfit image',
            uploadFirstImage: 'Upload outfit image',
            changeFirstImage: 'Change outfit image',
            secondImageLabel: 'Person image',
            uploadSecondImage: 'Upload person image',
            changeSecondImage: 'Change person image',
            uploadingSecondImage: 'Uploading person image...',
            downloadName: 'ai-outfit-changed.png'
        },
        'handwritten-erase': {
            name: 'AI Handwriting Remover',
            desc: 'Remove handwriting from test papers and documents with AI',
            fullDesc: 'Remove handwriting from test papers, homework, workbooks, and scanned documents online for free while preserving printed questions and the original layout. Supports rotation, cropping, and dewarping.',
            featuresKicker: 'Document handwriting removal',
            featuresTitle: 'Remove Handwriting and Restore Clean Documents',
            featuresIntro: 'Clean handwritten answers, contract revisions, review notes, and scanned-document marks while preserving printed text and the original layout.',
            features: [
                { title: 'Remove Student Answers from Test Papers', desc: 'Detect handwritten answers, calculations, and annotations on completed test papers automatically.', cta: 'Clean Test Paper Answers Free' },
                { title: 'Erase Handwriting from Contracts', desc: 'Clean handwritten additions, circles, changed amounts, arrows, and review notes while preserving printed clauses, tables, and layout.', cta: 'Clean Contract Handwriting Online' },
                { title: 'Prepare and Reprint Tests for Teaching', desc: 'Clean student answers and teacher annotations for lessons, test preparation, and document archiving.', cta: 'Try the Teacher Test Paper Cleaner' },
                { title: 'Clean Handwritten Marks from Scanned Documents', desc: 'Remove ticks, arrows, circles, margin notes, and review marks from scanned forms, inspection reports, and office documents.', cta: 'Clean Scanned Document Marks' }
            ],
            useCasesKicker: 'For students and teachers',
            useCasesTitle: 'Education Use Cases for AI Handwriting Removal',
            useCases: [
                { title: 'Test Answer Removal', desc: 'Erase student answers and calculations from test papers.' },
                { title: 'Mistake Review', desc: 'Restore completed papers for another round of practice.' },
                { title: 'Workbook Cleaning', desc: 'Remove handwritten content from homework and worksheets.' },
                { title: 'Teaching and Test Preparation', desc: 'Create clean papers for lessons, reprinting, and archiving.' },
                { title: 'Scanned Paper Correction', desc: 'Rotate, crop, and dewarp skewed or curved document images.' },
                { title: 'Contract and Note Cleaning', desc: 'Remove handwriting and annotations from general documents.' }
            ],
            howToKicker: 'Three simple steps',
            howToTitle: 'How to Remove Handwritten Answers from Test Papers Online',
            howToIntro: 'Upload a test paper or document, set rotation, cropping, and dewarping options, then download the cleaned result.',
            steps: {
                upload: { title: 'Upload a Test Paper or Document', desc: 'Upload a JPG, PNG, or WebP test paper, homework sheet, or scanned document under 15MB.' },
                process: { title: 'Configure and Remove Handwriting', desc: 'Choose document direction and enable cropping or dewarping as needed, then start processing.' },
                download: { title: 'Review and Download', desc: 'Compare the before and after images, download the clean document, or process another image.' }
            },
            faqTitle: 'AI Test Paper Answer Remover FAQ',
            faqs: [
                { q: 'What tool can I use to remove handwritten answers from test papers?', a: 'The Miral AI handwriting remover detects handwritten answers, calculations, and annotations while preserving printed questions and the original layout where possible.' },
                { q: 'Can AI remove handwriting while preserving printed text?', a: 'It can restore a clean paper while preserving printed text when handwriting does not heavily overlap the printed content.' },
                { q: 'Can teachers clean and reprint test papers?', a: 'Yes. It is suitable for lesson preparation, classroom explanations, test creation, and document archiving.' },
                { q: 'Can students reset answered papers for revision?', a: 'Yes. Cleaned test papers and worksheets can be reused for mistake review and further practice.' },
                { q: 'How do I erase handwritten notes, pen marks, and red-ink annotations?', a: 'Upload the document image and run the handwriting remover. It can process different handwriting colors and writing tools, although results depend on clarity and overlap with printed text.' },
                { q: 'How do I fix a skewed or curved scan before removing handwriting?', a: 'Deskew or rotate a tilted scan first. Use cropping for excess background and dewarping only for genuinely curved pages before processing the handwriting.' },
                { q: 'Which image formats are supported?', a: 'JPG, PNG, and WebP images under 15MB are supported. PDF files are not supported on this page.' }
            ],
            docDirection: 'Rotation',
            docDirections: {
                none: 'No Rotation',
                rotate90: '90° Clockwise',
                rotate180: '180° Clockwise',
                rotate270: '270° Clockwise',
                auto: 'Auto Detect'
            },
            crop: 'Crop Edges',
            dewarp: 'Dewarp',
            notImageFile: 'Please upload a valid image file',
            fileTooLarge: 'Image too large, please select an image under 15MB',
            noImageInResponse: 'Processing failed, please try again',
            downloadName: 'handwriting-erased.png'
        },
        category: {
            image: 'Image Tools',
            video: 'Video Tools',
            document: 'Document Tools'
        },
        categoryModal: {
            title: 'Select Tool Category'
        },
        convert: {
            success: 'Conversion Complete!',
            zipHint: 'The result is packaged as a ZIP file containing multiple images',
            fileTooLarge: 'File too large, please select a file under 50MB',
            multiImageHint: 'Supports uploading multiple images and merging into one PDF',
            addMore: 'Add more',
            demoTitle: 'Conversion Preview',
            sourceLabel: 'Source',
            targetLabel: 'Output'
        },
        'pdf-to-word': {
            name: 'PDF to Word',
            desc: 'Convert PDF files to editable Word documents',
            fullDesc: 'Intelligently convert PDF files to editable Word documents, accurately preserving layout, tables, images, and more. Supports mixed Chinese and English text.'
        },
        'image-to-word': {
            name: 'Image to Word',
            desc: 'Convert text in images to Word documents',
            fullDesc: 'Intelligently recognize text, tables, and other content in images and convert them to Word documents, preserving the original layout format. Supports stamp extraction and handwritten text recognition.'
        },
        'pdf-to-excel': {
            name: 'PDF to Excel',
            desc: 'Convert PDF tables to editable Excel files',
            fullDesc: 'Intelligently recognize table content in PDF files and convert them to editable Excel files, accurately preserving table structure and data.'
        },
        'pdf-to-ppt': {
            name: 'PDF to PPT',
            desc: 'Convert PDF files to editable PPT presentations',
            fullDesc: 'Intelligently convert PDF files to editable PPT presentations, preserving original layout, images, and text content.'
        },
        'pdf-to-image': {
            name: 'PDF to Image',
            desc: 'Convert each PDF page to high-quality images',
            fullDesc: 'Convert each page of a PDF file to high-quality images. Supports batch conversion of multi-page PDFs, with results packaged as a ZIP download.'
        },
        'word-to-pdf': {
            name: 'Word to PDF',
            desc: 'Convert Word documents to PDF files',
            fullDesc: 'Quickly convert Word documents to PDF files, preserving original layout, fonts, and images to ensure format consistency.'
        },
        'excel-to-pdf': {
            name: 'Excel to PDF',
            desc: 'Convert Excel spreadsheets to PDF files',
            fullDesc: 'Convert Excel spreadsheets to PDF files, preserving table structure and data layout for easy sharing and printing.'
        },
        'image-to-pdf': {
            name: 'Image to PDF',
            desc: 'Merge multiple images into a single PDF file',
            fullDesc: 'Merge multiple images into a single PDF file. Supports common image formats like JPG, PNG, and BMP for unified management and sharing.'
        },
        'word-to-image': {
            name: 'Word to Image',
            desc: 'Convert each Word document page to an image',
            fullDesc: 'Convert each page of a Word document to high-quality images. Supports batch conversion of multi-page documents, with results packaged as a ZIP download.'
        }
    },
    plans: {
        basic: {
            name: 'Basic',
            features: [
                'All credits delivered at once',
                'Generate up to 2,600 AI images',
                'Generate 520 AI videos',
                'Generate up to 480 AI music tracks',
                'No watermarks',
                'Commercial license'
            ]
        },
        pro: {
            name: 'Pro',
            features: [
                'All credits delivered at once',
                'Generate up to 10,600 AI images',
                'Generate up to 2,120 AI videos',
                'Generate up to 1,920 AI music tracks',
                'All premium models',
                'Priority queue',
                'Priority support',
                'Privacy mode & DPA compliance'
            ]
        },
        ultimate: {
            name: 'Ultimate',
            features: [
                'All credits delivered at once',
                'Generate up to 36,600 AI images',
                'Generate up to 7,320 AI videos',
                'Generate up to 6,720 AI music tracks',
                'All premium models',
                'Dedicated support',
                'Privacy mode & DPA compliance'
            ]
        }
    },
    faq: {
        categories: {
            all: 'All',
            general: 'General',
            pricing: 'Pricing',
            models: 'Models',
            features: 'Features'
        },
        items: [
            {
                q: 'What is Miral?',
                a: 'Miral is an all-in-one AI creation platform integrating 29+ top-tier AI models, supporting image generation, video creation, music production, and professional editing tools. No need to switch between platforms - one account gives you access to all major models including FLUX, Midjourney, Sora, Veo, Kling, and more.'
            },
            {
                q: 'Which AI models are supported?',
                a: 'We support 29+ top-tier AI models, including image models (FLUX 2 Max, Midjourney, Seedream, GPT-Image-1, Nano Banana, etc.), video models (Veo 3.1, Sora 2, Kling 2.6, Seedance, Wan 2.5, etc.), and AI music generation models. All models are continuously updated.'
            },
            {
                q: 'How does the credit system work?',
                a: 'We use a unified credit system. Image generation starts at 2 credits, video generation at 10 credits, and music at 10 credits per track. Premium models may consume more credits. Subscribers enjoy lower credit rates and can also purchase credit packs separately.'
            },
            {
                q: 'Can I generate images, videos, and music?',
                a: 'Yes! Miral supports text-to-image, image editing, style transfer, text-to-video, image-to-video, AI music creation, and more - meeting all creative needs from personal projects to commercial work.'
            },
            {
                q: 'How fast is the generation?',
                a: 'Most image generation completes within 30 seconds, video generation takes about 1-6 minutes. We continuously optimize our infrastructure to ensure fast and stable generation.'
            },
            {
                q: 'Can I use Miral for commercial purposes?',
                a: 'Yes. All paid plans include commercial licenses, allowing you to use generated content for commercial projects, marketing materials, social media, and more.'
            },
            {
                q: 'Is API access available?',
                a: 'Yes, the Ultimate plan includes API access. Through our comprehensive API, you can integrate AI image, video, and music generation directly into your applications.'
            },
            {
                q: 'Can I generate music with AI?',
                a: 'Absolutely! Our AI music generator supports various music styles. Simply describe what you want to generate original music, perfect for video soundtracks, podcast background music, and more.'
            },
            {
                q: 'How do you handle data privacy and security?',
                a: 'We strictly adhere to GDPR compliance standards. All data is encrypted and not used for AI training. Users can delete their accounts and all data at any time.'
            },
            {
                q: 'Can others see my work?',
                a: 'By default, your work is only visible to you. Pro and Ultimate users can enable privacy mode to ensure complete privacy.'
            },
            {
                q: 'How can I delete my account and data?',
                a: 'You can request account deletion in your account settings at any time. We will delete all your data and generated content within 30 days.'
            },
            {
                q: 'Can I get support if I encounter issues?',
                a: 'Of course! You can contact our support team at miral_support@miralvis.com. Pro users get priority support, and Ultimate users get dedicated support.'
            }
        ]
    },
    testimonials: {
        items: [
            {
                name: 'Alex Chen',
                role: 'Digital Marketing Director',
                tag: 'Save 90% Time',
                content: 'Miral has become our visual content hub. Generate product images with Midjourney, create promotional videos with Veo, then edit everything in Miral - all without switching platforms.'
            },
            {
                name: 'Sarah Rodriguez',
                role: 'E-commerce Owner',
                tag: '40% Higher Conversion',
                content: 'Accessing 29+ models in one place is amazing. I use Seedream for product photos, Seedance for video ads, and the upscaling tools for catalogs. Conversion increased by 40%!'
            },
            {
                name: 'David Kim',
                role: 'Content Creator',
                tag: '500K+ Followers',
                content: 'I create images with FLUX and Nano Banana, then turn them into viral videos with Kling and Sora. The credit system is fair - pay as you go. My followers love the diverse content!'
            },
            {
                name: 'Emma Thompson',
                role: 'Graphic Designer',
                tag: 'Professional Grade',
                content: 'As a designer, I was skeptical about AI platforms. But Miral\'s rich model library and precise editing tools are truly impressive - from concept sketches to final products, it\'s all easy.'
            },
            {
                name: 'James Wilson',
                role: 'Video Producer',
                tag: '10x Faster Workflow',
                content: 'The video models here are incredible - Veo is cinematic, Seedance is fast, and Wan\'s character animation is natural. All models share one credit system - saves time and money.'
            },
            {
                name: 'Lisa Park',
                role: 'Creative Agency Owner',
                tag: 'Team\'s Top Choice',
                content: 'Our entire team has switched to Miral. API integration is smooth, and the variety of models means we always find the right tool. This is the best AI platform available.'
            }
        ]
    },
    langModal: {
        title: 'Select Language'
    },
    home: {
        searchModel: 'Search model...',
        newModels: 'New Models',
        otherModels: 'Other Models',
        selectModel: 'Select Model',
        promptPlaceholderImage: 'Describe the image you want to create...',
        promptPlaceholderVideo: 'Describe the video you want to create...',
        generate: 'Generate',
        chatDisabledGenerateHint: 'Please enter a prompt',
        compactChatPlaceholder: 'Enter your prompt to generate stunning AI images, videos and original music',
        hero: {
            title: 'Miral – All-in-One AI Image, Video & Music Creator',
            subtitle: 'Powered by versatile AI models, Miral supports all-in-one image editing, video generation and AI music creation. Edit photos, make cinematic portrait videos and create custom background music for personal & commercial creation.',
            createVideo: 'Create Video',
            createImage: 'Create Image'
        },
        stats: {
            models: 'Top AI Models',
            works: 'Works Generated',
            tools: 'Professional Tools',
            platforms: 'Partner Platforms'
        },
        generatorNew: {
            promptPlaceholder: 'Describe the video you want to generate...',
            promptPlaceholderImage: 'Describe the image you want to generate...',
            generating: 'Generating...',
            noHistory: 'Results will appear here after generation',
            generationFailed: 'Generation failed',
            historyTitle: 'History',
            myAssets: 'My Assets'
        },
        quickTools: {
            title: 'Quick AI Tools'
        },
        exploreMore: {
            title: 'Explore More AI Features'
        },
        musicPresets: [
            { label: 'Upbeat Pop Anthem', value: 'Upbeat Pop Anthem' },
            { label: 'Chill Lo-fi Beat', value: 'Chill Lo-fi Beat' },
            { label: 'Cinematic Epic Score', value: 'Cinematic Epic Score' },
            { label: 'Acoustic Folk Song', value: 'Acoustic Folk Song' },
            { label: 'Electronic Dance Track', value: 'Electronic Dance Track' },
            { label: 'Jazz Lounge Vibe', value: 'Jazz Lounge Vibe' },
            { label: 'Rock Power Ballad', value: 'Rock Power Ballad' },
            { label: 'Ambient Meditation', value: 'Ambient Meditation' }
        ],
        musicPresetsPlaceholder: 'Select a music preset',
        platform: {
            tag: 'Platform',
            title: 'AI Toolbox That Makes Creation Simple',
            subtitle: 'All-in-one image generation, video creation, music production, and professional tools powered by industry-leading AI models.',
            tabs: {
                image: 'AI Images',
                video: 'AI Videos',
                music: 'AI Music',
                tools: 'AI Toolbox'
            },
            image: {
                title: 'Generate and Edit Stunning Images with Top Global AI Models',
                desc: 'Text-to-image, precision editing, style transfer, and HD upscaling. Powered by FLUX, Midjourney, Seedream, GPT-Image-1, and Nano Banana.',
                explore: 'Explore Image Models →'
            },
            video: {
                title: 'Create Cinematic Videos with AI',
                desc: 'From text-to-video to image animation, powered by Veo, Sora, Kling, Seedance, and Wan models. Generate videos with synced audio and professional camera work.',
                explore: 'Explore Video Models →'
            },
            music: {
                title: 'AI-Powered Original Music Creation',
                desc: 'Generate original music from descriptions, supporting various styles and durations. Perfect for video soundtracks, podcast background music, and more.',
                explore: 'Explore AI Music →'
            },
            tools: {
                title: 'Professional AI Toolbox',
                desc: 'Watermark removal, photo restoration, HD upscaling, video enhancement, and more professional tools for all your post-processing needs.',
                explore: 'View All Tools →'
            }
        },
        models: {
            tag: 'Models',
            title: 'One-Stop Integration of Global Top AI Models',
            subtitle: 'One platform integrating all mainstream AI models. No more switching between multiple accounts and subscriptions.',
            imageModels: 'Image Models',
            videoModels: 'Video Models',
            musicModels: 'AI Music',
            musicDesc: 'Generate original music from descriptions',
            filterAll: 'All',
            credits: 'Credits',
            viewAll: 'View All →'
        },
        features: {
            tag: 'Core Features',
            title: 'Create Stunning Images, Videos, and Music',
            subtitle: 'From text-to-image, text-to-video to AI music creation, plus precision editing and HD upscaling — all-in-one creation.',
            items: {
                textToImage: {
                    tag: 'Text to Image',
                    title: 'Text to Image',
                    desc: 'Input a description, witness the magic. Whether hyper-realistic portraits or fantasy landscapes, use Midjourney, Seedream, Nano Banana and other models to generate visual masterpieces with simple prompts.',
                    cta: 'Image Generation',
                    imageAlt: 'Generate visual masterpieces with simple prompts using Midjourney, Seedream, Nano Banana and other models'
                },
                imageEdit: {
                    tag: 'Image Editing & Style Transfer',
                    title: 'Image Editing & Style Transfer',
                    desc: 'Use AI to precisely reshape images. Whether changing styles, modifying objects, replacing backgrounds, or editing text, all with high consistency.',
                    cta: 'Image Editing',
                    beforeAlt: 'Before image editing and style transfer',
                    afterAlt: 'After image editing and style transfer'
                },
                textToVideo: {
                    tag: 'Text to Video',
                    title: 'Text to Video',
                    desc: 'Just input prompts to generate cinematic videos with synced audio, professional camera work, and realistic motion. Choose from Veo, Sora, Kling, Seedance, and Wan models.',
                    cta: 'Video Generation'
                },
                imageToVideo: {
                    tag: 'Image to Video',
                    title: 'Image to Video',
                    desc: 'Turn static images into cinematic videos. Whether product photos, illustrations, or AI-generated images, bring them to life with natural motion and voiceover.',
                    cta: 'Image Animation'
                },
                upscale: {
                    tag: 'HD Upscaling',
                    title: 'HD Upscaling',
                    desc: 'Use AI to enhance image and video quality. Support lossless HD upscaling and enhance video resolution to 4K professional level.',
                    cta: 'Upscale Now',
                    imageAlt: 'Use AI to enhance image and video quality'
                },
                templates: {
                    tag: '40+ Image Templates',
                    title: '40+ Image Templates',
                    desc: 'Massive templates to spark inspiration: 3D models, Ghibli style, designer toys, meme generator, magazine covers, and more — upload a photo, instant results.',
                    cta: 'Browse Templates',
                    imageAlt: 'Image template example'
                }
            }
        },
        gallery: {
            tag: 'Gallery',
            title: 'Explore Infinite Possibilities',
            subtitle: 'See what creators are building with Miral — from hyper-realistic images to cinematic videos, inspiration at your fingertips.',
            images: {
                alt1: 'Midjourney Generated Image Example',
                alt2: 'Seedream Generated Image Example',
                alt3: 'GPT-Image-1 Generated Image Example',
                alt4: 'Flux Generated Image Example',
                alt5: 'Flux Pro Generated Image Example',
                alt6: 'Midjourney Generated Image Example',
                alt7: 'Seedream Generated Image Example',
                alt8: 'GPT-Image-1 Generated Image Example'
            }
        },
        whyChoose: {
            tag: 'Why Choose Miral',
            title: 'All-in-One Creation, Everything You Need',
            subtitle: 'One-stop platform bringing together the world\'s top AI image, video, and music creation models.',
            items: {
                allModels: {
                    title: 'All Models Integrated, One is Enough',
                    desc: 'One-stop access to 29+ top AI models from OpenAI, Google, Alibaba, ByteDance, and more. No need to switch between tools or manage multiple subscriptions.'
                },
                fast: {
                    title: 'Lightning Fast',
                    desc: 'Most image generation completes within 30 seconds, video generation takes about 1-6 minutes. Optimized infrastructure ensures no long waits.'
                },
                credits: {
                    title: 'Simple Credit System',
                    desc: 'Pay as you go, transparent pricing. Start with free credits — no subscription needed to begin creating.'
                },
                api: {
                    title: 'Developer API',
                    desc: 'Integrate AI image, video, and music generation directly into your applications through our comprehensive API. Build your product on top AI models.'
                }
            }
        },
        testimonials: {
            tag: 'User Stories',
            title: 'Trusted by Creators Worldwide',
            subtitle: 'Join thousands of professionals and creators using Miral to generate images, create videos, and power their creative workflows.'
        },
        faq: {
            tag: 'Support',
            title: 'Frequently Asked Questions',
            subtitle: 'A comprehensive guide to the platform, supported models, pricing plans, and features.'
        },
        cta: {
            title: 'Start Your AI Creation Journey Now',
            subtitle: 'Join thousands of creators, designers, and businesses using Miral to realize their creativity with the world\'s top AI models.',
            createImage: 'Create Image →',
            createVideo: 'Create Video →',
            note: 'New users get free credits upon registration. No credit card required.'
        },
        apps: {
            title: "Apps",
            quickTitle: "Quick AI Apps",
        more: "More",
        keywords: {
            viralVideo: "Social short-form viral clips",
            tiktokAds: "Short-video ad creatives",
            productShowcase: "Ecommerce product demos",
            aiAvatar: "Talking digital presenters",
            homeModernKitchen: "Interior design visuals"
        },
            social: 'Social Media',
            posters: 'Posters',
            interior: 'Home',
            entertainment: 'Entertainment',
            lifestyle: 'Lifestyle',
            comic: 'Comic',
            items: {
                viralVideo: 'Viral Video',
                celebrityVideo: 'Celebrity Video',
                productShowcase: 'Product Showcase',
                tiktokAds: 'TikTok Ads',
                aiMeme: 'AI Meme',
                aiAvatar: 'AI Avatar',
                logoAnimation: 'Logo Animation',
                socialShorts: 'Social Shorts',
                brandStory: 'Brand Story',
                tutorialClip: 'Tutorial Clip',
                musicVideo: 'AI Music Video',
                animeScene: 'Anime Scene',
                movieTrailer: 'Movie Trailer',
                gameCinematic: 'Game Cinematic',
                visualPoetry: 'Visual Poetry',
                natureDoc: 'Nature Documentary',
                cyberpunkCity: 'Cyberpunk City',
                underwaterWorld: 'Underwater World',
                timelapseArt: 'Timelapse Art',
                dailyVlog: 'Daily Vlog',
                cookingShow: 'Cooking Show',
                fitnessCoach: 'Fitness Coach',
                travelDiary: 'Travel Diary',
                fashionShow: 'Fashion Show',
                petParadise: 'Pet Paradise',
                weddingMoment: 'Wedding Moment',
                yogaFlow: 'Yoga Flow',
                homeDecor: 'Home Decor',
                sunsetRun: 'Sunset Run',
                instagramReels: 'Instagram Reels',
                youtubeIntro: 'YouTube Intro',
                linkedinPromo: 'LinkedIn Promo',
                aiThumbnail: 'AI Thumbnail',
                podcastClip: 'Podcast Clip',
                horrorShort: 'Horror Short',
                danceVideo: 'Dance Video',
                aiComic: 'AI Comic',
                magicShow: 'Magic Show',
                fantasyWorld: 'Fantasy World',
                diyCraft: 'DIY Craft',
                morningRoutine: 'Morning Routine',
                babyGrowth: 'Baby Growth',
                streetFood: 'Street Food',
                bookTrailer: 'Book Trailer',
                socialLuxuryBag: 'Luxury Bag Drop',
                socialFashionVote: 'Fashion Vote',
                socialSneakerDrop: 'Urban Luxe Sneakers',
                socialTropicalCocktail: 'Weekend Cocktail',
                socialCityBillboard: 'City Billboard Ad',
                socialStreetwearDrop: 'Streetwear Drop',
                socialBoxingGloves: 'Boxing Gloves Ad',
                homeEclecticLiving: 'Eclectic Living Room',
                homeFarmhouseKitchen: 'Farmhouse Kitchen',
                homeModernKitchen: 'Modern Minimal Kitchen',
                homeVictorianStairs: 'Victorian Staircase',
                homeScandiLiving: 'Scandinavian Living Room',
                homeMediterraneanPatio: 'Mediterranean Patio',
                homeBohoSunroom: 'Bohemian Sunroom',
                homeEclecticBedroom: 'Eclectic Bedroom',
                comicPortrait: 'Superhero Comic',
                animeCharacter: 'Mecha Anime',
                mangaScene: 'Rainy Night Manga',
                comicOilPainting: 'Slice of Life Comic',
                comicCover: 'Energy Hero Comic',
                animePortrait: 'Rooftop Leap Comic',
                comicCouple: 'Young Hero Comic',
                mangaWarrior: 'Sorcerer Comic'
            }
        }
    },
    musicTags: {
        pop: 'Pop',
        electronic: 'Electronic',
        classical: 'Classical',
        jazz: 'Jazz'
    },
    music: {
        breadcrumb: {
            home: 'Home',
            aiMusic: 'AI Music'
        },
        model: {
            label: 'Model',
            aiMusicName: 'AI Music',
            desc: 'Generate original music from descriptions, supporting various styles and durations.',
            tagMusic: 'Music Generation',
            tagLyrics: 'Lyrics Creation'
        },
        mode: {
            describe: 'Describe',
            lyrics: 'Write Lyrics'
        },
        form: {
            musicDesc: 'Music Description',
            musicDescPlaceholder: 'Describe the music style, emotion and scene you want...\n\nExample: An upbeat electronic music with futuristic synth melodies, suitable for tech product promotional videos',
            optimize: 'Optimize',
            songTitle: 'Song Title',
            songTitlePlaceholder: 'Enter song title...',
            lyricsDescLabel: 'Lyrics Description',
            lyricsDescPlaceholder: 'Write your lyrics description here...\n\nExample:\n[Intro]\n...\n[Verse]\n...\n[Chorus]\n...',
            styleTags: 'Style Tags',
            styleTagsPlaceholder: 'Click tags below to add (multi-select)'
        },
        tags: {
            sections: [
                {label: 'Verse', value: '[Verse]\n'},
                {label: 'Chorus', value: '[Chorus]\n'},
                {label: 'Bridge', value: '[Bridge]\n'},
                {label: 'Intro', value: '[Intro]\n'},
                {label: 'Outro', value: '[Outro]\n'}
            ],
            styles: [
                {label: 'Pop', value: 'Pop'},
                {label: 'Rock', value: 'Rock'},
                {label: 'Jazz', value: 'Jazz'},
                {label: 'Classical', value: 'Classical'},
                {label: 'Electronic', value: 'Electronic'},
                {label: 'R&B', value: 'R&B'},
                {label: 'Hip-Hop', value: 'Hip-Hop'},
                {label: 'Country', value: 'Country'},
                {label: 'Folk', value: 'Folk'},
                {label: 'Ambient', value: 'Ambient'},
                {label: 'Cinematic', value: 'Cinematic'},
                {label: 'Lo-fi', value: 'Lo-fi'},
                {label: 'Metal', value: 'Metal'},
                {label: 'Reggae', value: 'Reggae'},
                {label: 'Blues', value: 'Blues'},
                {label: 'Soul', value: 'Soul'},
                {label: 'Funk', value: 'Funk'},
                {label: 'Indie', value: 'Indie'}
            ]
        },
        options: {
            duration: 'Duration',
            instrumental: 'Instrumental',
            instrumentalDescOn: 'Generate accompaniment only, no vocals',
            instrumentalDescOff: 'Include vocal performance'
        },
        errors: {
            titleRequired: 'Song title is required',
            lyricsDescRequired: 'Lyrics description is required'
        },
        footer: {
            creditsRequired: 'Credits Required:',
            creditsLeft: 'Remaining:',
            generate: 'Generate Music'
        },
        preview: {
            generating: 'Generating music...',
            generatedTitle: 'Generated Music',
            emptyTitle: 'AI Music Generator',
            emptySubtitle: 'Create original music with AI. Describe the style or enter lyrics, and generate your own song in seconds.',
            emptyTags: ['Pop', 'Jazz', 'Cinematic', 'Lo-fi', 'Rock'],
            track: 'Track',
            play: 'Play',
            pause: 'Pause',
            mute: 'Mute',
            unmute: 'Unmute',
            download: 'Download',
            showLyrics: 'Show lyrics',
            hideLyrics: 'Hide lyrics',
            generateFailed: 'Generation failed',
            requestFailed: 'Request failed, please try again',
            downloadMp3: 'Download MP3',
            downloadWav: 'Download WAV',
            regenerate: 'Regenerate',
            noHistory: 'No history yet'
        },
        intro: {
            title: 'AI Music Generator',
            desc: 'Using advanced AI technology, simply input a description or lyrics to generate high-quality original music. Supports multiple music styles, suitable for video soundtracks, advertisements, podcasts, and more.',
            tagMusic: 'Music Generation',
            tagLyrics: 'Lyrics Creation',
            tagStyles: 'Multiple Styles',
            tagCommercial: 'Commercial License'
        },
        features: {
            badge: 'Core Features',
            title: 'What can AI Music Generator do for you?',
            items: {
                styles: {
                    icon: '🎵',
                    title: 'Multiple Styles',
                    desc: 'Supports Pop, Rock, Electronic, Jazz, Classical, Hip-Hop and dozens of music styles to meet various creative needs.'
                },
                lyrics: {
                    icon: '📝',
                    title: 'Lyrics Creation',
                    desc: 'Input lyrics to generate complete songs with section markers (Verse, Chorus, etc.), AI automatically arranges and produces music.'
                },
                vocals: {
                    icon: '🎤',
                    title: 'Vocal Synthesis',
                    desc: 'Supports male and female vocals with various timbres, AI sings your lyrics with natural and smooth results.'
                },
                instrumental: {
                    icon: '🎹',
                    title: 'Instrumental Mode',
                    desc: 'Generate high-quality instrumental accompaniment, suitable for video soundtracks, podcast background music, and more.'
                },
                fast: {
                    icon: '⚡',
                    title: 'Fast Generation',
                    desc: 'Advanced AI models ensure quick music production, most music can be generated within 30 seconds.'
                },
                commercial: {
                    icon: '💼',
                    title: 'Commercial License',
                    desc: 'All generated music can be used for commercial purposes, including videos, advertisements, podcasts, and more.'
                }
            }
        },
        faq: {
            title: 'Frequently Asked Questions',
            items: {
                howItWorks: {
                    q: 'How does the AI Music Generator work?',
                    a: 'Our AI Music Generator uses advanced deep learning models to create original music based on your text descriptions or lyrics. Simply input the music style, emotion, and scene description, and AI will automatically compose a complete musical piece.'
                },
                commercial: {
                    q: 'Can generated music be used for commercial purposes?',
                    a: 'Yes, all music generated using our platform can be used for commercial purposes, including YouTube videos, advertisements, podcasts, games, and more.'
                },
                styles: {
                    q: 'What music styles are supported?',
                    a: 'We support Pop, Rock, Electronic, Jazz, Classical, Hip-Hop, R&B, Country, Metal, Folk, and dozens of other music styles. You can also mix multiple styles to create unique music.'
                },
                credits: {
                    q: 'How many credits does each generation cost?',
                    a: 'Depending on the model selected, each generation costs 8-10 credits. You can get better credit rates through subscription plans.'
                },
                download: {
                    q: 'Can I download the generated music?',
                    a: 'Yes, generated music supports both MP3 and WAV formats for download. You can choose the appropriate format based on your needs.'
                }
            }
        },
        demoTracks: {
            summerBreeze: {title: 'Summer Breeze', style: 'Pop / Upbeat', duration: '2:00'},
            spaceJourney: {title: 'Space Journey', style: 'Electronic / Futuristic', duration: '1:30'},
            rainWalk: {title: 'Walking in Rain', style: 'Jazz / Laid-back', duration: '2:30'},
            mountainDawn: {title: 'Mountain Dawn', style: 'Classical / Serene', duration: '3:00'}
        }
    },
    pricing: {
        title: 'Unlimited Inspiration, Choose the Plan That Fits You Best',
        subtitle: 'Unlock all AI models, batch generate images, videos, and music.',
        promo: 'Limited Time Offer — Save 30% on Yearly Plans',
        monthly: 'Monthly',
        yearly: 'Yearly',
        yearlyNote: 'Annual plan — credits delivered at once, single payment more economical',
        popular: 'Most Popular',
        currentPlan: 'Current Plan',
        currentPlanBtn: 'Current Plan',
        upgrade: 'Upgrade',
        unavailable: 'Unavailable',
        upgradeSuccess: 'Upgrade successful!',
        upgradeFailed: 'Upgrade failed',
        upgradeModal: {
            title: 'Confirm upgrade',
            item1: 'We will charge the price difference to your card.',
            item2: 'After payment succeeds, extra balance will be added automatically.',
            item3: 'The new plan takes effect after payment succeeds.',
            tip: 'Tip: Make sure your payment method is valid. Balance updates within seconds after payment.',
            cancel: 'Cancel',
            confirm: 'Confirm upgrade'
        },
        subscribe: 'Subscribe Now',
        processing: 'Processing...',
        creditsPer: 'credits /',
        extraCredits: 'extra credits',
        creditsRate: '100 credits = $',
        perMonth: 'month',
        perYear: 'year',
        yearlyBilling: 'Billed yearly',
        saveVsMonthly: 'Save vs monthly:',
        planDesc: {
            basic: 'Perfect for getting started',
            pro: 'Best for creators and professionals',
            ultimate: 'For teams and power users'
        },
        creditsPack: {
            title: 'Buy Credit Pack',
            subtitle: 'One-time purchase, no subscription',
            buy: 'Buy Credits',
            oneTime: 'One-time purchase',
            permanent: 'Credits never expire',
            tip: 'Tip: Subscriptions are better value',
            tipItems: ['Lower credit rates (save 40-60%)', '15% off all credit packs']
        },
        security: {
            noTraining: 'Not used for AI training',
            encrypted: 'Encrypted storage',
            gdpr: 'GDPR compliant',
            delete: 'Self-service account deletion'
        },
        dataSafety: 'Learn about our data security commitment →',
        allPlansInclude: 'All Plans Include',
        includes: {
            models: 'Premium AI Models',
            fast: 'Fast Generation',
            privacy: '100% Privacy',
            commercial: 'Commercial Use'
        },
        creditsInfo: {
            title: 'Credits Guide',
            subtitle: 'View credit consumption for all models',
            model: 'Model',
            type: 'Type',
            cost: 'Credit Cost',
            speed: 'Speed',
            image: 'Image',
            video: 'Video'
        },
        questions: 'Questions?',
        contact: 'Need help?',
        contactUs: 'Contact Us',
        faq: {
            items: [
                {
                    q: 'What can I create with credits?',
                    a: 'Credits can be used to generate AI images, videos, and music. Image generation starts at 2 credits, video generation at 10 credits, and music at 10 credits per track. Premium models may consume more credits.'
                },
                {
                    q: 'Can I cancel anytime?',
                    a: 'Yes, you can cancel your subscription at any time. You can continue using the service until the end of your current billing period.'
                },
                {
                    q: 'What if I run out of credits?',
                    a: 'You can purchase one-time credit packs anytime (no subscription needed). Subscribers get 15% off credit packs. You can also upgrade your plan for better rates on monthly quotas.'
                },
                {
                    q: 'Is there a refund policy?',
                    a: 'Yes. For first-time purchases of one-time packages or first subscriptions, you can request a refund within 7 calendar days if credit usage is below 3%.'
                }
            ]
        }
    },
    modelDetail: {
        breadcrumb: {
            home: 'Home',
            models: 'Models'
        },
        model: 'Model',
        modelVersion: 'Model Version',
        standard: 'Standard',
        pro: 'Pro',
        standardDesc: 'Standard quality, fast generation',
        proDesc: 'High quality, supports high resolution',
        credits: 'credits',
        imagePrompt: 'Image Prompt',
        imagePromptPlaceholder: 'Describe the image you want to generate...',
        videoPrompt: 'Video Prompt',
        videoPromptPlaceholder: 'Describe the video you want to generate...',
        referenceImage: 'Reference Image',
        aspectRatio: 'Aspect Ratio',
        thinkingLevel: 'Thinking Level',
        thinkingMinimal: 'Low latency',
        thinkingHigh: 'High fidelity',
        referenceImageFormats: 'PNG, JPG, JPEG, WEBP',
        uploadImageHint: 'PNG, JPG, JPEG, WEBP',
        nanoBanana2EmptyPreview: 'Nano Banana 2 official image output preview',
        characters: 'characters',
        imageSize: 'Image Size',
        auto: 'Auto',
        resolution: 'Resolution',
        duration: 'Duration',
        seconds: 'seconds',
        creditsRequired: 'Credits Required:',
        creditsRemaining: 'Remaining:',
        remaining: 'Remaining:',
        generate: 'Generate',
        getMoreCredits: 'Get more credits',
        generating: 'Generating...',
        demoPrompt: 'Demo Prompt',
        modelLabel: 'Model:',
        version: 'Version:',
        size: 'Size:',
        download: 'Download',
        regenerate: 'Regenerate',
        noHistory: 'No generation history',
        features: {
            badge: 'Core Features',
            title: 'What can this model do?',
            items: {
                realistic: {
                    icon: '📷',
                    title: 'Cinematic Realism',
                    desc: 'Create high-fidelity realistic images with natural skin tones, rich material textures, and believable cinematic lighting.'
                },
                artistic: {
                    icon: '🎨',
                    title: 'Artistic Style',
                    desc: 'Create artistic images with various painting styles.'
                },
                portrait: {
                    icon: '👤',
                    title: 'Portrait',
                    desc: 'Professional portrait photography with natural skin tones.'
                },
                landscape: {icon: '🏔️', title: 'Landscape', desc: 'Stunning landscape and nature photography.'},
                product: {icon: '📦', title: 'Product', desc: 'High-quality product photography for e-commerce.'},
                fast: {icon: '⚡', title: 'Fast Generation', desc: 'Most images generated within 10-30 seconds.'},
                highRes: {icon: '🖼️', title: 'High Resolution', desc: 'Support up to 4K resolution output.'},
                cinematic: {
                    icon: '🎬',
                    title: 'Cinematic',
                    desc: 'Create cinematic videos with professional camera work.'
                },
                audioSync: {icon: '🔊', title: 'Audio Sync', desc: 'Native audio-visual synchronization for videos.'},
                lipSync: {icon: '👄', title: 'Lip Sync', desc: 'Accurate lip synchronization for character videos.'},
                animation: {icon: '🎭', title: 'Animation', desc: 'Smooth character animation and motion.'},
                longVideo: {icon: '⏱️', title: 'Long Video', desc: 'Support for longer video durations.'},
                privacy: {
                    icon: '🔒',
                    title: 'Privacy & security',
                    desc: 'All data is encrypted in transit and not used for AI training. Your creations belong to you.'
                }
            }
        },
        whyChoose: {
            items: [
                'Smart creation powered by {name}',
                'Complete complex creative tasks quickly and efficiently',
                'Generated content can be used commercially',
                'Continuous updates and improving capabilities',
                'Unified credit system, pay as you go'
            ]
        },
        faq: {
            title: 'Frequently Asked Questions',
            imageType: 'images',
            videoType: 'videos',
            imageFormats: 'PNG, JPEG, and WebP output formats are supported; choose what fits your workflow.',
            videoFormats: 'Videos are delivered as MP4 with 480p and 720p options and multiple aspect ratios.',
            items: [
                {
                    q: 'How does {name} work?',
                    a: 'Upload a reference or enter a text prompt—{name} generates high-quality {type} based on your input. The process is simple and needs no expert skills.'
                },
                {
                    q: 'Can I use generated {type} commercially?',
                    a: 'Yes. Content from {name} may be used commercially, including marketing, social media, and product use.'
                },
                {
                    q: 'How many credits per generation?',
                    a: 'Each generation with {name} uses {credits} credits. Subscribers get better credit rates.'
                },
                {
                    q: 'How fast is generation?',
                    a: 'Typical speed for {name} is {speed}. We keep optimizing for reliable, fast results.'
                },
                {q: 'What output formats are supported?', a: ''}
            ]
        },
        qwenImage20Pro: {
            negativePromptLabel: 'Negative prompt (optional)',
            negativePromptPlaceholder: 'Describe what you do not want to appear (e.g., low clarity, deformed hands, etc.)',
            customWidth: 'Width',
            customHeight: 'Height',
            sizeHint: 'Range: 512×512 to 2048×2048',
            sizeErrorRequired: 'Please enter width and height',
            sizeErrorInteger: 'Width and height must be integers',
            sizeErrorRange: 'Resolution must be between 512×512 and 2048×2048',
            promptEnhanceTitle: 'Prompt Enhancement',
            promptEnhanceDesc: 'Enhance prompt details for richer outputs',
            watermarkTitle: 'Watermark',
            watermarkDesc: 'Add a watermark to the generated images',
            demoPromptText: 'Among snowy mountains, a little boy in ski gear and goggles glides happily on his skis; snow crystals drift along his trail, with endless snow-covered ridges behind him.',
            faqSizeSupportQ: 'Which sizes are supported?',
            faqSizeSupportA: 'Enter width and height within 512~2048 (e.g., 2048*2048).',
            faqMaxCountQ: 'How many images can be generated at most?',
            faqMaxCountA: 'Up to 4 images (n=1..4).',
            faqLinkUsageQ: 'How do I use the image links after generation?',
            faqLinkUsageA: 'It first downloads the temporary URL returned by DashScope, uploads it to our server, and returns a long-lasting accessible URL.'
        },
        zImageTurbo: {
            promptExtendTitle: 'Prompt Enhancement',
            promptExtendDesc: 'Enhance prompt details for richer outputs',
            customWidth: 'Width',
            customHeight: 'Height',
            sizeHint: 'Range: 512×512 to 2048×2048',
            sizeErrorRequired: 'Please enter width and height',
            sizeErrorInteger: 'Width and height must be integers',
            sizeErrorRange: 'Resolution must be between 512×512 and 2048×2048',
            seedLabel: 'Seed',
            seedErrorRequired: 'Please enter a seed',
            seedErrorInteger: 'Seed must be an integer',
            seedErrorRange: 'Seed must be between 0 and 2147483647',
            tagQuality: 'High quality',
            tagOfficial: 'Official direct',
            tagHighRes: 'High resolution',
            tagSeed: 'Seed control',
            tagPromptExtend: 'Prompt Enhancement',
            feature1Title: 'High-quality output',
            feature1Desc: 'Generate high-resolution images and upload them for long-term access URLs.',
            feature2Title: 'Custom resolution',
            feature2Desc: 'Enter width and height within 512–2048.',
            feature3Title: 'Controllable generation',
            feature3Desc: 'Supports seed and prompt enhancement for reproducibility and tuning.',
            demoPromptText: 'On fine golden sand, a clear trail of footprints leads deeper into the frame; the edges show damp, grainy sand, the surface glitters in the sunlight, drawing the eye toward a distant lighthouse.',
            faqSizeSupportQ: 'Which sizes are supported?',
            faqSizeSupportA: 'Enter width and height within 512–2048 (e.g., 1024*1536).',
            faqSeedQ: 'What is the seed used for?',
            faqSeedA: 'With the same prompt and parameters, a seed helps reproduce similar results.',
            faqPromptExtendQ: 'What is Prompt Enhancement?',
            faqPromptExtendA: 'When enabled, it enhances prompt details for richer outputs.'
        }
    },
    modelIntro: {
        common: {
            videoMode: 'Video Mode',
            textToVideo: 'Text to Video',
            imageToVideo: 'Image to Video',
            referenceImage: 'Reference Image',
            referenceAudio: 'Reference Audio',
            negativePrompt: 'Negative Prompt',
            duration: 'Duration',
            resolution: 'Resolution',
            aspectRatio: 'Aspect Ratio',
            seed: 'Seed',
            generateAudio: 'Generate Audio',
            watermark: 'Add Watermark',
            endFrame: 'End Frame',
            promptEnhance: 'Prompt Enhance',
            promptExtend: 'Prompt Extend',
            imageSize: 'Image Size',
            imageCount: 'Image Count',
            style: 'Style',
            sizeMode: 'Size Mode',
            width: 'Width',
            height: 'Height',
            optional: 'Optional',
            uploading: 'Uploading...',
            clickToUpload: 'Click to Upload',
            quality: 'Quality',
            qualityAuto: 'Auto',
            qualityLow: 'Low',
            qualityMedium: 'Medium',
            qualityHigh: 'High',
            multipleOf64Hint: 'Width and height must be multiples of 64.'
        },
        seegen: {
            aspectAdaptive: 'Auto',
            genMode: 'Generation mode',
            modeStand: 'Standard',
            modeSpeed: 'Fast'
        },
        pollodance: {
            variantLabel: 'Model variant',
            card20: '2.0',
            card20Fast: '2.0 FAST',
            card20Ref: '2.0 REF',
            card20FastRef: '2.0 FAST REF',
            opt20Desc: 'Advanced motion control, cinematic style transfer & industrial-grade generation.',
            opt20FastDesc: 'High-speed generation with low latency.',
            opt20RefDesc: 'Strong reference control: style transfer & subject tracking.',
            opt20FastRefDesc: 'Fast generation plus precise reference control.',
            refImages: 'Reference images',
            refVideo: 'Reference video',
            refAudio: 'Reference audio',
            webSearch: 'Web search'
        },
        nanoBanana: {
            version: 'Model Version',
            title: 'Nano Banana Pro AI Image Generator',
            desc: 'Nano Banana is a high-performance AI image generation model that supports realistic style image generation, excelling at portraits and natural scenes. Available in Standard and Pro versions to meet different needs.',
            v25Type: 'Low Latency',
            v25TypeBadge: 'Fast',
            v25TypeDesc: 'Fixed 1024px resolution, fast generation speed',
            v31Type: 'High Fidelity',
            v31TypeBadge: 'Quality',
            v31TypeDesc: 'Supports 1K / 2K / 4K multiple resolutions',
            demoPrompt: 'A cinematic portrait of a woman in golden hour light, with natural skin texture and soft bokeh background',
            multiSize: 'Multiple Sizes',
            multiSizeDesc: 'Supports auto, 1:1, 4:3, 3:4, 16:9, 9:16, 3:2, 2:3 and other image sizes.',
            featuresDesc: 'Nano Banana provides high-quality image generation capabilities with multiple size and resolution options.',
            flexiblePricing: 'Flexible Pricing',
            flexiblePricingDesc: 'Standard 5 credits, Pro 20 credits, choose as needed.',
            commercial: 'Commercial License',
            commercialDesc: 'All generated images can be used for commercial purposes.',
            enterPrompt: 'Please enter a prompt',
            generateFailed: 'Generation failed',
            requestFailed: 'Request failed, please try again',
            faq: [
                {
                    q: 'What\'s the difference between Standard and Pro versions?',
                    a: 'Standard version is suitable for quick generation of standard quality images, consuming 5 credits. Pro version supports higher resolutions (1K/2K/4K) with better image quality, consuming 20 credits.'
                },
                {
                    q: 'How does Nano Banana work?',
                    a: 'Simply enter a text description, and the Nano Banana model will generate high-quality realistic style images based on your prompt.'
                },
                {
                    q: 'What image sizes are supported?',
                    a: 'Supports auto, 1:1 (square), 4:3, 3:4, 16:9 (landscape), 9:16 (portrait), 3:2, 2:3 and other sizes.'
                },
                {
                    q: 'Can generated images be used commercially?',
                    a: 'Yes, all content generated using Nano Banana can be used for commercial purposes.'
                }
            ]
        },
        nanoBanana2: {
            genType: 'Generation Version'
        },
        seedream: {
            title: 'Seedream 4 AI Image Generator',
            desc: 'Seedream 4 is an advanced AI image generation model specializing in artistic and creative imagery. Perfect for illustrations, concept art, and stylized visuals.',
            webSearch: 'Web Search',
            webSearchDesc: 'Enable web search for more accurate reference information',
            watermark: 'Add watermark',
            watermarkDesc: 'Add watermark to generated images',
            sizeModeResolution: 'By resolution',
            sizeModeCustom: 'Custom size',
            customWidth: 'Width',
            customHeight: 'Height',
            sizeHint: 'Area 1024×1024–4096×4096, aspect ratio 1/16–16',
            sizeErrorArea: 'Area must be between 1024×1024 and 4096×4096',
            sizeErrorRatio: 'Aspect ratio must be between 1/16 and 16',
            demoPromptExample: 'Afternoon side light illuminates the camping tent, with the rough texture of the tent canvas clearly visible. A German Shepherd lies inside; its owner squats down to shake hands with it.',
            features: [
                {
                    icon: '🎨',
                    title: 'Artistic Style',
                    desc: 'Generate stunning artistic images with various painting and illustration styles.'
                },
                {icon: '🖼️', title: 'High Resolution', desc: 'Support up to 4K resolution for detailed artwork.'},
                {icon: '⚡', title: 'Fast Generation', desc: 'Most images generated within 15 seconds.'},
                {icon: '🎭', title: 'Style Transfer', desc: 'Apply various artistic styles to your creations.'},
                {icon: '📐', title: 'Multiple Sizes', desc: 'Support various aspect ratios for different needs.'},
                {
                    icon: '💼',
                    title: 'Commercial License',
                    desc: 'All generated images can be used for commercial purposes.'
                }
            ],
            faq: [
                {
                    q: 'What is Seedream 4 best for?',
                    a: 'Seedream 4 excels at generating artistic and creative imagery, including illustrations, concept art, and stylized visuals.'
                },
                {
                    q: 'How many credits does each generation cost?',
                    a: 'Using Seedream 4 costs 8 credits per generation. You can get better credit rates through subscription plans.'
                },
                {
                    q: 'What styles are supported?',
                    a: 'Seedream 4 supports various artistic styles including oil painting, watercolor, digital art, anime, and more.'
                },
                {
                    q: 'Can generated images be used commercially?',
                    a: 'Yes, all content generated using Seedream 4 can be used for commercial purposes.'
                }
            ]
        },
        seedream5: {
            title: 'Seedream 5 AI Image Generator',
            desc: 'Seedream 5 is an advanced AI image generation model specializing in artistic and creative imagery. Perfect for illustrations, concept art, and stylized visuals.',
            webSearch: 'Web Search',
            webSearchDesc: 'Enable web search for more accurate reference information',
            watermark: 'Add watermark',
            watermarkDesc: 'Add watermark to generated images',
            sizeModeResolution: 'By resolution',
            sizeModeCustom: 'Custom size',
            customWidth: 'Width',
            customHeight: 'Height',
            sizeHint: 'Area 2560×1440–3072×3072, aspect ratio 1/16–16',
            sizeErrorArea: 'Area must be between 2560×1440 and 3072×3072',
            sizeErrorRatio: 'Aspect ratio must be between 1/16 and 16',
            demoPromptExample: 'Afternoon side light illuminates the camping tent, with the rough texture of the tent canvas clearly visible. A German Shepherd lies inside; its owner squats down to shake hands with it.',
            features: [
                {
                    icon: '🎨',
                    title: 'Artistic Style',
                    desc: 'Generate stunning artistic images with various painting and illustration styles.'
                },
                {icon: '🖼️', title: 'High Resolution', desc: 'Support 2K and 3K output with rich details.'},
                {icon: '⚡', title: 'Fast Generation', desc: 'Most images generated within 15 seconds.'},
                {icon: '🎭', title: 'Style Transfer', desc: 'Apply various artistic styles to your creations.'},
                {icon: '📐', title: 'Flexible Sizing', desc: 'Supports preset resolutions and custom sizes.'},
                {
                    icon: '💼',
                    title: 'Commercial License',
                    desc: 'All generated images can be used for commercial purposes.'
                }
            ],
            faq: [
                {
                    q: 'What is Seedream 5 best for?',
                    a: 'Seedream 5 excels at generating artistic and creative imagery, including illustrations, concept art, and stylized visuals.'
                },
                {
                    q: 'How many credits does each generation cost?',
                    a: 'Using Seedream 5 costs 10 credits per generation. You can get better credit rates through subscription plans.'
                },
                {
                    q: 'What resolutions are supported?',
                    a: 'Supports 2K and 3K presets, plus custom sizes within the allowed area and aspect ratio ranges.'
                },
                {
                    q: 'Can generated images be used commercially?',
                    a: 'Yes, all content generated using Seedream 5 can be used for commercial purposes.'
                }
            ]
        },
        midjourney: {
            title: 'Midjourney AI Image Generator',
            desc: 'Midjourney is a leading AI image generation model known for its exceptional artistic quality and creative capabilities. Perfect for professional artwork and creative projects.',
            referenceBoxTitle: 'Add reference images for image-to-image',
            referenceBoxSubtitle: 'Supports PNG, JPEG, WEBP (max 100KB). Up to 5 images. Fewer images, more precise results.',
            demoPrompt: 'A mystical floating island in the sky, ancient ruins covered in glowing crystals, waterfalls cascading into clouds below, ethereal lighting, fantasy art style',
            referenceImages: 'Reference images',
            referenceImagesCount: 'Up to 5',
            refImageMaxSize: 'Each image must not exceed 100KB',
            style: 'Style',
            styleRealistic: 'Realistic',
            styleAnime: 'Anime',
            generationSpeed: 'Generation Speed',
            fastDesc: 'Standard speed generation',
            turboDesc: 'Fast generation, priority processing',
            creative: 'Creative',
            highQuality: 'High Quality',
            fastTurbo: 'Fast/Turbo',
            creativeGeneration: 'Creative Generation',
            speed: 'Speed',
            features: [
                {
                    icon: '🎨',
                    title: 'Artistic Excellence',
                    desc: 'Industry-leading artistic quality and creative output.'
                },
                {
                    icon: '🖼️',
                    title: 'High Resolution',
                    desc: 'Generate high-quality images suitable for professional use.'
                },
                {icon: '🎭', title: 'Unique Styles', desc: 'Distinctive artistic styles that set your work apart.'},
                {icon: '⚡', title: 'Fast Generation', desc: 'Most images generated within 20 seconds.'},
                {icon: '📐', title: 'Multiple Sizes', desc: 'Support various aspect ratios and resolutions.'},
                {
                    icon: '💼',
                    title: 'Commercial License',
                    desc: 'All generated images can be used for commercial purposes.'
                }
            ],
            faq: [
                {
                    q: 'What\'s the difference between Fast and Turbo?',
                    a: 'Fast mode costs 10 credits with standard speed. Turbo mode costs 20 credits with faster generation and priority processing.'
                },
                {
                    q: 'How does Midjourney work?',
                    a: 'Simply enter a text description, and Midjourney will generate artistic images based on your prompt.'
                },
                {
                    q: 'What image sizes are supported?',
                    a: 'Supports 1:1 (square), 4:3, 3:4, 16:9 (landscape), 9:16 (portrait), 3:2, 2:3 and other sizes.'
                },
                {
                    q: 'Can generated images be used commercially?',
                    a: 'Yes, all content generated using Midjourney can be used for commercial purposes.'
                }
            ]
        },
        gptImage: {
            title: 'GPT-Image-1 AI Image Generator',
            desc: 'GPT-Image-1 is OpenAI\'s versatile image generation model, capable of creating a wide variety of images from text descriptions. Great for general-purpose image generation.',
            demoPromptExample: 'Tuscan fields at dusk, rolling hills covered in golden wheat, cypress trees and an old stone farmhouse in the distance, the sunset casting a warm red glow across the sky, warm, healing, landscape photography, golden hour.',
            imageCount: 'Image Count',
            promptEnhance: 'Prompt Enhance',
            promptEnhanceDesc: 'Automatically optimize prompts for better generation results',
            count: 'Count',
            multiPurpose: 'Multi-purpose',
            batchGeneration: 'Batch Generation',
            size1024Square: '1024×1024 (square)',
            size1536Landscape: '1536×1024 (landscape)',
            size1024Portrait: '1024×1536 (portrait)',
            threeSizes: 'Three fixed sizes',
            tagQuality: 'High quality',
            tagCommercialShort: 'Commercial use',
            features: [
                {icon: '🎨', title: 'Versatile Generation', desc: 'Create a wide variety of images for any purpose.'},
                {icon: '🖼️', title: 'High Quality', desc: 'Generate high-quality images with accurate details.'},
                {icon: '⚡', title: 'Fast Generation', desc: 'Most images generated within 15 seconds.'},
                {
                    icon: '📝',
                    title: 'Text Understanding',
                    desc: 'Excellent understanding of complex text descriptions.'
                },
                {
                    icon: '📐',
                    title: 'Three fixed sizes',
                    desc: '1024×1024 (square), 1536×1024 (landscape), 1024×1536 (portrait).'
                },
                {
                    icon: '💼',
                    title: 'Commercial License',
                    desc: 'All generated images can be used for commercial purposes.'
                }
            ],
            faq: [
                {
                    q: 'How does GPT-Image-1 work?',
                    a: 'Simply enter a text description, and GPT-Image-1 will generate high-quality images based on your prompt.'
                },
                {
                    q: 'What image sizes are supported?',
                    a: 'Supports three fixed sizes: 1024×1024 (square), 1536×1024 (landscape), and 1024×1536 (portrait).'
                },
                {
                    q: 'Can generated images be used commercially?',
                    a: 'Yes, all content generated using GPT-Image-1 can be used for commercial purposes.'
                }
            ]
        },
        gptImage15: {
            title: 'GPT-Image-1.5 AI Image Generator',
            desc: 'GPT-Image-1.5 is OpenAI\'s versatile image generation model, capable of creating a wide variety of images from text descriptions. Great for general-purpose image generation.',
            demoPromptExample: 'Tuscan fields at dusk, rolling hills covered in golden wheat, cypress trees and an old stone farmhouse in the distance, the sunset casting a warm red glow across the sky, warm, healing, landscape photography, golden hour.',
            imageCount: 'Image Count',
            promptEnhance: 'Prompt Enhance',
            promptEnhanceDesc: 'Automatically optimize prompts for better generation results',
            count: 'Count',
            multiPurpose: 'Multi-purpose',
            batchGeneration: 'Batch Generation',
            size1024Square: '1024×1024 (square)',
            size1536Landscape: '1536×1024 (landscape)',
            size1024Portrait: '1024×1536 (portrait)',
            threeSizes: 'Three fixed sizes',
            tagQuality: 'High quality',
            tagCommercialShort: 'Commercial use',
            features: [
                {icon: '🎨', title: 'Versatile Generation', desc: 'Create a wide variety of images for any purpose.'},
                {icon: '🖼️', title: 'High Quality', desc: 'Generate high-quality images with accurate details.'},
                {icon: '⚡', title: 'Fast Generation', desc: 'Most images generated within 15 seconds.'},
                {
                    icon: '📝',
                    title: 'Text Understanding',
                    desc: 'Excellent understanding of complex text descriptions.'
                },
                {
                    icon: '📐',
                    title: 'Three fixed sizes',
                    desc: '1024×1024 (square), 1536×1024 (landscape), 1024×1536 (portrait).'
                },
                {
                    icon: '💼',
                    title: 'Commercial License',
                    desc: 'All generated images can be used for commercial purposes.'
                }
            ],
            faq: [
                {
                    q: 'How does GPT-Image-1.5 work?',
                    a: 'Simply enter a text description, and GPT-Image-1.5 will generate high-quality images based on your prompt.'
                },
                {
                    q: 'What image sizes are supported?',
                    a: 'Supports three fixed sizes: 1024×1024 (square), 1536×1024 (landscape), and 1024×1536 (portrait).'
                },
                {
                    q: 'Can generated images be used commercially?',
                    a: 'Yes, all content generated using GPT-Image-1.5 can be used for commercial purposes.'
                }
            ]
        },
        fluxKontext: {
            title: 'Flux Kontext AI Image Generator',
            desc: 'A young woman sitting on a rooftop at golden hour, wearing an oversized denim jacket, white headphones around her neck, sipping iced coffee from a clear plastic cup. Her short curly hair blows slightly in the wind as city lights begin to glow in the distance.',
            imageCount: 'Image Count',
            count: 'Count',
            demoPrompt1: 'A young woman sitting on a rooftop at golden hour, wearing an oversized denim jacket, white headphones around her neck, sipping iced coffee from a clear plastic cup. Her short curly hair blows slightly in the wind as city lights begin to glow in the distance.',
            demoPrompt2: 'A man in his 20s sitting on a messy art studio floor, surrounded by unfinished canvases and paint tubes. He wears a white tank top stained with color, and ripped jeans.',
            demoPrompt3: 'A young mother adjusting her baby\'s beanie while seated on a picnic blanket. She wears a cream sweater and long corduroy skirt, barefoot on the grass.',
            highQuality: 'High Quality',
            fastGen: 'Fast Generation',
            multiSize: 'Multiple Sizes',
            outputStyle: 'Output Style',
            outputStyleDesc: {
                auto: 'Default — the model automatically determines the style, no forced look',
                photographic: 'Photographic — realistic photos, natural light and shadows',
                digital_art: 'Digital Art — CG/illustration look, vivid and rich colors',
                anime: 'Anime — Japanese anime/cartoon style, clean lines'
            },
            outputStyleLabel: {
                auto: 'Default',
                photographic: 'Photographic',
                digital_art: 'Digital Art',
                anime: 'Anime'
            },
            features: [
                {icon: '✨', title: 'High Quality Output', desc: 'Generate detailed, high-fidelity images.'},
                {icon: '🎨', title: 'Text to Image', desc: 'Accurately generate images from text descriptions.'},
                {icon: '⚡', title: 'Fast Generation', desc: 'Most images complete in around 15 seconds.'},
                {icon: '📐', title: 'Multiple Sizes', desc: 'Support for 1:1, 3:2, 2:3 aspect ratios.'},
                {icon: '💼', title: 'Commercial License', desc: 'Generated images can be used for commercial purposes.'}
            ],
            faq: [
                {
                    q: 'How does Flux Kontext work?',
                    a: 'Enter a text description; Flux Kontext generates high-quality images and supports single or multiple images per request.'
                },
                {q: 'What image sizes are supported?', a: 'Supports 1:1 (square), 3:2 (landscape), 2:3 (portrait).'},
                {
                    q: 'Can I generate multiple images at once?',
                    a: 'Yes, you can generate 1–3 images, each billed separately.'
                },
                {
                    q: 'Can generated images be used commercially?',
                    a: 'Yes, content generated with Flux Kontext can be used for commercial purposes.'
                }
            ]
        },
        fluxPro11Ultra: {
            title: 'Flux Pro 1.1 Ultra AI Image Generator',
            desc: 'Flux Pro 1.1 Ultra for high-quality text-to-image with multiple aspect ratios and batch generation.',
            imageCount: 'Image Count',
            count: 'Count',
            demoPrompt1: 'A young woman sitting on a rooftop at golden hour, wearing an oversized denim jacket, white headphones around her neck, sipping iced coffee from a clear plastic cup. Her short curly hair blows slightly in the wind as city lights begin to glow in the distance.',
            demoPrompt2: 'A man in his 20s sitting on a messy art studio floor, surrounded by unfinished canvases and paint tubes. He wears a white tank top stained with color, and ripped jeans.',
            demoPrompt3: 'A young mother adjusting her baby\'s beanie while seated on a picnic blanket. She wears a cream sweater and long corduroy skirt, barefoot on the grass.',
            highQuality: 'High Quality',
            fastGen: 'Fast Generation',
            multiSize: 'Multiple Sizes',
            outputStyle: 'Output Style',
            outputStyleDesc: {
                auto: 'Default — the model automatically determines the style, no forced look',
                photographic: 'Photographic — realistic photos, natural light and shadows',
                digital_art: 'Digital Art — CG/illustration look, vivid and rich colors',
                anime: 'Anime — Japanese anime/cartoon style, clean lines'
            },
            outputStyleLabel: {
                auto: 'Default',
                photographic: 'Photographic',
                digital_art: 'Digital Art',
                anime: 'Anime'
            },
            features: [
                {icon: '✨', title: 'High Quality Output', desc: 'Generate detailed, high-fidelity images.'},
                {icon: '🎨', title: 'Text to Image', desc: 'Accurately generate images from text descriptions.'},
                {icon: '⚡', title: 'Fast Generation', desc: 'Most images complete in around 15 seconds.'},
                {
                    icon: '📐',
                    title: 'Multiple Sizes',
                    desc: 'Support for 21:9, 16:9, 4:3, 3:2, 1:1, 2:3, 3:4, 9:16, 9:21.'
                },
                {icon: '💼', title: 'Commercial License', desc: 'Generated images can be used for commercial purposes.'}
            ],
            faq: [
                {
                    q: 'How does Flux Pro 1.1 Ultra work?',
                    a: 'Enter a text description to generate high-quality images; supports 1–4 images per request.'
                },
                {q: 'What image sizes are supported?', a: 'Supports 21:9, 16:9, 4:3, 3:2, 1:1, 2:3, 3:4, 9:16, 9:21.'},
                {
                    q: 'Can I generate multiple images at once?',
                    a: 'Yes, you can generate 1–4 images, each billed separately.'
                },
                {
                    q: 'Can generated images be used commercially?',
                    a: 'Yes, content can be used for commercial purposes.'
                }
            ]
        },
        fluxSchnell: {
            title: 'Flux Schnell AI Image Generator',
            desc: 'Flux Schnell for fast text-to-image with multiple aspect ratios and batch generation.',
            imageCount: 'Image Count',
            count: 'Count',
            demoPrompt1: 'A young woman sitting on a rooftop at golden hour, wearing an oversized denim jacket, white headphones around her neck, sipping iced coffee from a clear plastic cup. Her short curly hair blows slightly in the wind as city lights begin to glow in the distance.',
            demoPrompt2: 'A man in his 20s sitting on a messy art studio floor, surrounded by unfinished canvases and paint tubes. He wears a white tank top stained with color, and ripped jeans.',
            demoPrompt3: 'A young mother adjusting her baby\'s beanie while seated on a picnic blanket. She wears a cream sweater and long corduroy skirt, barefoot on the grass.',
            highQuality: 'High Quality',
            fastGen: 'Fast Generation',
            multiSize: 'Multiple Sizes',
            outputStyle: 'Output Style',
            outputStyleDesc: {
                auto: 'Default — the model automatically determines the style, no forced look',
                photographic: 'Photographic — realistic photos, natural light and shadows',
                digital_art: 'Digital Art — CG/illustration look, vivid and rich colors',
                anime: 'Anime — Japanese anime/cartoon style, clean lines'
            },
            outputStyleLabel: {
                auto: 'Default',
                photographic: 'Photographic',
                digital_art: 'Digital Art',
                anime: 'Anime'
            },
            features: [
                {icon: '✨', title: 'High Quality Output', desc: 'Generate detailed, high-fidelity images.'},
                {icon: '🎨', title: 'Text to Image', desc: 'Accurately generate images from text descriptions.'},
                {icon: '⚡', title: 'Fast Generation', desc: 'Most images complete in around 15 seconds.'},
                {
                    icon: '📐',
                    title: 'Multiple Sizes',
                    desc: 'Support for 21:9, 16:9, 4:3, 3:2, 1:1, 2:3, 3:4, 9:16, 9:21.'
                },
                {icon: '💼', title: 'Commercial License', desc: 'Generated images can be used for commercial purposes.'}
            ],
            faq: [
                {
                    q: 'How does Flux Schnell work?',
                    a: 'Enter a text description to quickly generate high-quality images; supports 1–4 images per request.'
                },
                {q: 'What image sizes are supported?', a: 'Supports 21:9, 16:9, 4:3, 3:2, 1:1, 2:3, 3:4, 9:16, 9:21.'},
                {
                    q: 'Can I generate multiple images at once?',
                    a: 'Yes, you can generate 1–4 images, each billed separately.'
                },
                {
                    q: 'Can generated images be used commercially?',
                    a: 'Yes, content can be used for commercial purposes.'
                }
            ]
        },
        flux2: {
            title: 'FLUX.2 AI Image Generator',
            desc: 'FLUX.2 brings enterprise-grade efficiency and professional precision to text-to-image generation with photorealistic detail, accurate hands, faces, and textures.',
            variant: 'Model Variant',
            variantLabel: 'Model Variant',
            variantDesc: {
                'klein-04': 'Real-time',
                'klein-09': 'Balanced',
                'max': 'Highest quality',
                'pro': 'Production',
                'flex': 'Customizable'
            },
            promptUpsampling: 'Prompt Upsampling',
            promptUpsamplingHint: 'Enhance prompt detail for richer output (not available for Klein models).',
            steps: 'Steps',
            stepsHint: 'Higher steps produce more detail but take longer. Flex variant only.',
            guidance: 'Guidance',
            guidanceHint: 'Controls how closely the output follows the prompt. Flex variant only.',
            tagPhotorealism: 'Photorealism',
            tagMultilingual: 'Multilingual',
            tagVariants: '5 Variants',
            demoPrompt1: 'A young woman sitting on a rooftop at golden hour, wearing an oversized denim jacket, white headphones around her neck, sipping iced coffee from a clear plastic cup. Her short curly hair blows slightly in the wind as city lights begin to glow in the distance.',
            features: [
                {icon: '✨', title: 'Photorealistic Detail', desc: 'Accurate hands, faces, fabrics, logos, and small objects up to 4MP resolution.'},
                {icon: '🎨', title: 'Typography & Design', desc: 'Renders clear, legible typography and adheres to complex layout instructions.'},
                {icon: '🌍', title: 'Multilingual', desc: 'Native language prompt support with state-of-the-art instruction following.'},
                {icon: '🎯', title: '5 Model Variants', desc: 'Klein 4B/9B for speed, Max for quality, Pro for scale, Flex for custom control.'},
                {icon: '⚙️', title: 'Flexible Control', desc: 'Adjustable steps, guidance, size, and safety tolerance for production workflows.'}
            ],
            faq: [
                {
                    q: 'What are the FLUX.2 model variants?',
                    a: 'FLUX.2 offers 5 variants: Klein 4B and 9B (fast, high volume), Max (highest quality with grounding search), Pro (production at scale), and Flex (adjustable steps & guidance).'
                },
                {
                    q: 'What image sizes are supported?',
                    a: 'FLUX.2 uses pixel dimensions (width x height) that must be multiples of 16. Presets include 1:1 (1024x1024), 4:3, 3:4, 16:9, 9:16, 21:9, and 9:21.'
                },
                {
                    q: 'What is Prompt Upsampling?',
                    a: 'When enabled, the model enhances your prompt internally for richer detail. Available for Max, Pro, and Flex variants (not Klein).'
                },
                {
                    q: 'What are Steps and Guidance in Flex mode?',
                    a: 'Steps (1-50) control inference quality — higher means more detail but slower. Guidance (1.5-10) controls prompt adherence — higher means closer to your description.'
                },
                {
                    q: 'Can generated images be used commercially?',
                    a: 'Yes, content can be used for commercial purposes.'
                }
            ]
        },
        seedance: {
            title: 'Seedance AI Video Generator',
            desc: 'Seedance is a next-generation AI video model that supports native audio-visual synchronization, cinematic motion, and emotional expression. Covers text-to-video, image-to-video, and video extension modes.',
            textToVideo: 'Text to Video',
            imageToVideo: 'Image to Video',
            videoExtend: 'Video Extend',
            uploadImage: 'Click to upload reference image',
            uploadHint: 'PNG, JPG, JPEG (max 20MB)',
            endFrame: 'End Frame Image',
            endFrameHint: '(Optional) Upload end frame to control video ending',
            uploadEndFrame: 'Click to upload end frame image',
            uploadVideo: 'Click to upload reference video',
            uploadVideoHint: 'MP4, MOV, WebM (max 100MB)',
            videoPrompt: 'Video Prompt',
            promptPlaceholder: 'Describe the video you want to generate...',
            videoPromptPlaceholder: 'Describe the video you want to generate...',
            negativePrompt: 'Negative Prompt',
            negativePromptPlaceholder: 'Describe what you don\'t want in the video (optional)',
            duration: 'Duration',
            videoDuration: 'Video duration',
            resolution: 'Resolution',
            aspectRatio: 'Aspect Ratio',
            promptEnhance: 'Prompt enhancement',
            promptEnhanceDesc: 'Automatically optimize prompts for better generation results',
            generateAudio: 'Generate Audio',
            audioOn: 'Native audio (voice + sound effects)',
            audioOff: 'Video only, no audio',
            seedValue: 'Seed Value',
            seedHint: 'The seed value is the unique identifier of the overall style. Using the same seed keeps the style consistent, while tweaking other parameters helps refine visual details.',
            seedPlaceholder: '-1 (random)',
            characters: 'characters',
            creditsRequired: 'Credits Required:',
            creditsRemaining: 'Remaining:',
            generate: 'Generate',
            generating: 'Generating...',
            demoPrompt: 'Demo Prompt',
            demoPromptExample: 'A soft and cute white kitten dances joyfully on tiptoes, its fluffy body swaying gently with tiny pink paws lifted. On a soft carpet under warm yellow lighting, healing cartoon style, exquisite details, soft and gentle colors.',
            modelLabel: 'Model:',
            durationLabel: 'Duration:',
            techSpecsTitle: 'Technical Specifications',
            techSpecsDesc: 'Seedance supports native audio-visual synchronization, cinematic motion, and emotional expression. Covers text-to-video, image-to-video, and video extension modes.',
            t2vTitle: 'Text to Video (T2V)',
            t2vDesc: 'Transform prompts into cinematic video scenes',
            i2vTitle: 'Image to Video (I2V)',
            i2vDesc: 'Animate a single image using AI',
            input: 'Input:',
            textPrompt: 'Text prompt',
            imagePrompt: 'Image + prompt',
            audio: 'Audio:',
            nativeAudio: 'Native audio generation',
            bestFor: 'Best for:',
            t2vBestFor: 'Perfect for cinematic content creation, advertising, and social media videos.',
            i2vBestFor: 'Best for portrait animation, product showcases, and creative content.',
            featuresDesc: 'Whether you\'re a designer, marketer, content creator, or casual user, Seedance helps you quickly create high-quality AI content.',
            features: [
                {
                    icon: '🎬',
                    title: 'Native Audio-Visual Generation',
                    desc: 'Synchronously generate video and audio in one go, delivering cinematic quality. Natural lip sync and dialogue dubbing.'
                },
                {
                    icon: '😊',
                    title: 'Emotion-Driven Expression',
                    desc: 'New emotion-aware performance for more realistic facial expressions. Subtle expressions include hesitation, sadness, tension, or emotional restraint.'
                },
                {
                    icon: '🎥',
                    title: 'Director-Level Camera Control',
                    desc: 'Supports push, pull, pan, orbit, and tracking camera movements. First and last frame guidance for smooth transitions.'
                },
                {
                    icon: '📱',
                    title: 'Multi-Modal Input',
                    desc: 'Supports text-to-video, image-to-video, and other flexible creative workflows.'
                },
                {
                    icon: '⚡',
                    title: 'Fast Generation',
                    desc: 'Optimized inference engine ensures quick production, most videos complete within minutes.'
                },
                {
                    icon: '💼',
                    title: 'Commercial License',
                    desc: 'All generated videos can be used for commercial purposes, suitable for advertising, social media, and more.'
                }
            ],
            enterPrompt: 'Please enter a prompt',
            imageRequired: 'Image-to-video mode requires a reference image',
            videoRequired: 'Video extend mode requires a reference video',
            generateFailed: 'Generation failed',
            requestFailed: 'Request failed, please try again',
            faq: [
                {
                    q: 'How does Seedance work?',
                    a: 'You can upload a reference image or enter a text description directly, and the Seedance model will generate high-quality video content based on your instructions, with synchronized audio. The process is simple and intuitive, requiring no professional skills.'
                },
                {
                    q: 'Can generated videos be used commercially?',
                    a: 'Yes, all content generated using Seedance can be used for commercial purposes, including marketing materials, social media, product showcases, and more.'
                },
                {
                    q: 'How many credits does each generation cost?',
                    a: 'Using Seedance costs 18 credits per generation. You can get better credit rates through subscription plans.'
                },
                {
                    q: 'How fast is generation?',
                    a: 'Seedance\'s average generation speed is about 1.5 minutes. We continuously optimize our infrastructure to ensure fast and stable generation.'
                },
                {
                    q: 'What output formats are supported?',
                    a: 'Videos are output in MP4 format, supporting 480p, 720p, and 1080p resolutions, with durations of 5 or 10 seconds, and multiple aspect ratios.'
                }
            ]
        },
        veo: {
            title: 'Veo 3.1 AI Video Generator',
            desc: 'Google Veo 3.1 is a state-of-the-art AI video model supporting native audio generation, ultra-high resolution, and long video creation. Perfect for professional video production.',
            fastType: 'Fast Type',
            fastTypeBadge: 'Fast speed, lower cost',
            fastTypeDesc: '(Supports 16:9 reference images)',
            qualityType: 'Quality Type',
            qualityTypeBadge: 'Richer details',
            qualityTypeDesc: 'Smoother motion. End frame is optional for image mode to control the last frame.',
            imageMode: 'Generation Mode',
            startEndFrames: 'Start/End Frames',
            referenceImage: 'Reference Image',
            startFrame: 'Start Frame',
            startFrameHint: 'Set the first frame. Video animates from this frame.',
            uploadStartFrame: 'Click to upload start frame',
            endFrame: 'End Frame',
            endFrameHint: 'Set the last frame. Video ends at this frame.',
            uploadEndFrame: 'Click to upload end frame',
            negativePrompt: 'Negative Prompt',
            negativePromptPlaceholder: 'Describe what you don\'t want in the video...',
            features: [
                {
                    icon: '🎬',
                    title: 'Native Audio Generation',
                    desc: 'Synchronously generate video and audio, including dialogue and sound effects.'
                },
                {
                    icon: '📺',
                    title: 'Ultra HD Resolution',
                    desc: 'Support up to 4K resolution output for professional video production.'
                },
                {
                    icon: '⏱️',
                    title: 'Long Video Support',
                    desc: 'Generate videos up to 2 minutes long, suitable for various creative needs.'
                },
                {icon: '🎥', title: 'Cinematic Motion', desc: 'Professional camera movements and smooth transitions.'},
                {icon: '⚡', title: 'Fast Generation', desc: 'Optimized inference engine for quick production.'},
                {
                    icon: '💼',
                    title: 'Commercial License',
                    desc: 'All generated videos can be used for commercial purposes.'
                }
            ],
            faq: [
                {
                    q: 'What\'s the difference between Fast and Quality types?',
                    a: 'Fast type is quicker and more cost-effective, suitable for rapid iteration. Quality type produces richer details and smoother motion, ideal for final output.'
                },
                {
                    q: 'How does Veo 3.1 work?',
                    a: 'Enter a text description or upload a reference image, and Veo 3.1 will generate high-quality video content based on your instructions, optionally with synchronized audio.'
                },
                {
                    q: 'How many credits does each generation cost?',
                    a: 'Using Veo 3.1 costs 30 credits per generation. You can get better credit rates through subscription plans.'
                },
                {
                    q: 'What resolutions and durations are supported?',
                    a: 'Supports 720p and 1080p resolutions, with durations of 5s, 10s, and up to 2 minutes for longer videos.'
                }
            ]
        },
        veo31: {
            genType: 'Generation Type',
            genTypeFast: 'Fast',
            genTypeQuality: 'Quality',
            endFrame: 'End Frame'
        },
        veo30: {
            title: 'Veo 3.0 AI Video Generator',
            desc: 'Google Veo 3.0 is an advanced AI video model supporting text-to-video and image-to-video, with 4s/6s/8s duration and 720p/1080p output.',
            fastType: 'Fast Type',
            fastTypeBadge: 'Faster, lower cost',
            fastTypeDesc: '(Supports 16:9 reference image)',
            qualityType: 'Quality Type',
            qualityTypeBadge: 'Richer details',
            qualityTypeDesc: 'Smoother motion. End frame in image mode is optional to control the last frame.',
            imageMode: 'Image Mode',
            startEndFrames: 'Start/End Frame',
            referenceImage: 'Reference Image',
            referenceImageHint: 'Upload a reference image; the video will be generated based on it.',
            uploadReferenceImage: 'Click to upload reference image',
            startFrame: 'Start Frame',
            startFrameHint: 'Set the first frame. Video animates from this frame.',
            uploadStartFrame: 'Click to upload start frame',
            endFrame: 'End Frame',
            endFrameHint: 'Set the last frame. Video ends at this frame.',
            uploadEndFrame: 'Click to upload end frame',
            negativePrompt: 'Negative Prompt',
            negativePromptPlaceholder: 'Describe what you don\'t want in the video...',
            seedRangeError: 'Seed must be an integer between 0 and 2147483647.',
            duration: 'Duration',
            resolution: 'Resolution',
            demoPrompt: 'A teenage girl sketching in a notebook at a café window, rain tapping on the glass...',
            features: [
                {
                    icon: '🎬',
                    title: 'Native Audio Generation',
                    desc: 'Synchronously generate video and audio, including dialogue and sound effects.'
                },
                {
                    icon: '📺',
                    title: 'HD Resolution',
                    desc: 'Support 720p and 1080p output for professional video production.'
                },
                {icon: '⏱️', title: 'Multiple Durations', desc: 'Support 4s, 6s, and 8s video generation.'},
                {icon: '🎥', title: 'Cinematic Motion', desc: 'Professional camera movements and smooth transitions.'},
                {icon: '⚡', title: 'Fast Generation', desc: 'Optimized inference engine for quick production.'},
                {
                    icon: '💼',
                    title: 'Commercial License',
                    desc: 'All generated videos can be used for commercial purposes.'
                }
            ],
            faq: [
                {
                    q: 'What\'s the difference between Fast and Quality types?',
                    a: 'Fast type is quicker and more cost-effective, suitable for rapid iteration. Quality type produces richer details and smoother motion, ideal for final output.'
                },
                {
                    q: 'How does Veo 3.0 work?',
                    a: 'Enter a text description or upload a reference image, and Veo 3.0 will generate high-quality video content based on your instructions, optionally with synchronized audio.'
                },
                {
                    q: 'How many credits does each generation cost?',
                    a: 'Using Veo 3.0 costs 25 credits per generation. You can get better credit rates through subscription plans.'
                },
                {
                    q: 'What resolutions and durations are supported?',
                    a: 'Supports 720p and 1080p resolutions, with durations of 4s, 6s, or 8s.'
                }
            ]
        },
        veo31fast: {
            title: 'Veo 3.1 Fast AI Video Generator',
            desc: 'Google Veo 3.1 Fast for quicker generation, supporting text-to-video and image-to-video with optional tail frame, 4s/6s/8s duration and 720p/1080p/4K output.',
            referenceImage: 'Reference Image',
            referenceImageHint: 'Upload a reference image; the video will be generated based on it.',
            uploadReferenceImage: 'Click to upload reference image',
            endFrame: 'Tail Frame',
            endFrameHint: 'Optional. Set the image for the last frame of the video to control the ending.',
            uploadEndFrame: 'Click to upload tail frame',
            duration: 'Duration',
            resolution: 'Resolution',
            seedRangeError: 'Seed must be an integer between 0 and 2147483647.',
            demoPrompt: 'A teenage girl sketching in a notebook at a café window, rain tapping on the glass...',
            features: [
                {icon: '⚡', title: 'Fast Generation', desc: 'Optimized for quicker output.'},
                {icon: '📺', title: '4K Resolution', desc: 'Support 720p, 1080p, and 4K output.'},
                {icon: '⏱️', title: 'Multiple Durations', desc: 'Support 4s, 6s, and 8s video.'},
                {
                    icon: '🖼️',
                    title: 'Optional Tail Frame',
                    desc: 'Image-to-video can upload a tail frame to control the ending.'
                },
                {icon: '🎥', title: 'Cinematic Motion', desc: 'Professional camera movements and smooth transitions.'},
                {
                    icon: '💼',
                    title: 'Commercial License',
                    desc: 'All generated videos can be used for commercial purposes.'
                }
            ],
            faq: [
                {
                    q: 'What\'s the difference between Veo 3.1 Fast and Veo 3.1?',
                    a: 'Veo 3.1 Fast is optimized for speed and lower credit cost, with 4K and optional tail frame support.'
                },
                {
                    q: 'What is the tail frame?',
                    a: 'For image-to-video, you can upload a tail frame image so the video ends on that frame, giving you control over the ending.'
                },
                {
                    q: 'How many credits does each generation cost?',
                    a: 'Using Veo 3.1 Fast costs 20 credits per generation.'
                },
                {
                    q: 'What resolutions and durations are supported?',
                    a: 'Supports 720p, 1080p, and 4K resolutions, with durations of 4s, 6s, or 8s.'
                }
            ]
        },
        kling: {
            title: 'Kling 2.6 AI Video Generator',
            desc: 'Kling 2.6 is a high-performance AI video model supporting text-to-video and image-to-video, with excellent motion quality and fast generation speed.',
            features: [
                {
                    icon: '🎬',
                    title: 'High Quality Motion',
                    desc: 'Smooth and natural motion with professional quality output.'
                },
                {icon: '📱', title: 'Multiple Aspect Ratios', desc: 'Support 1:1, 16:9, 9:16 and other aspect ratios.'},
                {
                    icon: '🔊',
                    title: 'Audio Generation',
                    desc: 'Optional native audio generation for complete video experience.'
                },
                {icon: '⚡', title: 'Fast Generation', desc: 'Most videos generated within 2 minutes.'},
                {icon: '🖼️', title: 'Image to Video', desc: 'Animate static images with AI-powered motion.'},
                {
                    icon: '💼',
                    title: 'Commercial License',
                    desc: 'All generated videos can be used for commercial purposes.'
                }
            ],
            faq: [
                {
                    q: 'How does Kling 2.6 work?',
                    a: 'Enter a text description or upload a reference image, and Kling 2.6 will generate high-quality video content based on your instructions.'
                },
                {
                    q: 'How many credits does each generation cost?',
                    a: 'Using Kling 2.6 costs 28 credits per generation. You can get better credit rates through subscription plans.'
                },
                {
                    q: 'What resolutions and durations are supported?',
                    a: 'Supports 720p and 1080p resolutions, with durations of 5s and 10s.'
                },
                {
                    q: 'Can I use generated videos commercially?',
                    a: 'Yes, all content generated using Kling 2.6 can be used for commercial purposes.'
                }
            ]
        },
        kling3: {
            title: 'Kling 3.0 AI Video Generator',
            desc: 'Kling 3.0 is a high-performance AI video model supporting text-to-video and image-to-video, with excellent motion quality and fast generation speed.',
            features: [
                {
                    icon: '🎬',
                    title: 'High Quality Motion',
                    desc: 'Smooth and natural motion with professional quality output.'
                },
                {icon: '📱', title: 'Multiple Aspect Ratios', desc: 'Support 1:1, 16:9, 9:16 and other aspect ratios.'},
                {
                    icon: '🔊',
                    title: 'Audio Generation',
                    desc: 'Optional native audio generation for complete video experience.'
                },
                {icon: '⚡', title: 'Fast Generation', desc: 'Most videos generated within 2 minutes.'},
                {icon: '🖼️', title: 'Image to Video', desc: 'Animate static images with AI-powered motion.'},
                {
                    icon: '💼',
                    title: 'Commercial License',
                    desc: 'All generated videos can be used for commercial purposes.'
                }
            ],
            faq: [
                {
                    q: 'How does Kling 3.0 work?',
                    a: 'Enter a text description or upload a reference image, and Kling 3.0 will generate high-quality video content based on your instructions.'
                },
                {
                    q: 'How many credits does each generation cost?',
                    a: 'Using Kling 3.0 costs 28 credits per generation. You can get better credit rates through subscription plans.'
                },
                {
                    q: 'What resolutions and durations are supported?',
                    a: 'Supports 720p and 1080p resolutions, with durations of 5s and 10s.'
                },
                {
                    q: 'Can I use generated videos commercially?',
                    a: 'Yes, all content generated using Kling 3.0 can be used for commercial purposes.'
                }
            ]
        },
        sora: {
            title: 'Sora 2 AI Video Generator',
            desc: 'Sora 2 is OpenAI\'s advanced AI video model, capable of generating high-quality videos with realistic motion and cinematic quality.',
            demoPromptExample: '@sama OpenAI\'s CEO, Sam, is introducing this cabinet product, saying it\'s the same as his own and very useful.',
            landscape: 'Landscape',
            portrait: 'Portrait',
            removeWatermark: 'Remove Watermark',
            enabled: 'Enabled',
            disabled: 'Disabled',
            noWatermark: 'No Watermark',
            cinematic: 'Cinematic Quality',
            restrictedAccess: 'Restricted Access',
            '60secDuration': '4s / 8s / 12s Duration',
            photorealistic: 'Photorealistic',
            physicsSimulation: 'Physics Simulation',
            features: [
                {
                    icon: '🎬',
                    title: 'Cinematic Quality',
                    desc: 'Generate videos with professional cinematic look and feel.'
                },
                {
                    icon: '🎥',
                    title: 'Realistic Motion',
                    desc: 'Natural and realistic motion for characters and scenes.'
                },
                {icon: '⏱️', title: 'Flexible Duration', desc: 'Support various video lengths for different needs.'},
                {icon: '⚡', title: 'Fast Generation', desc: 'Optimized for quick video production.'},
                {icon: '🖼️', title: 'Multi-Modal Input', desc: 'Support text-to-video and image-to-video modes.'},
                {
                    icon: '💼',
                    title: 'Commercial License',
                    desc: 'All generated videos can be used for commercial purposes.'
                }
            ],
            faq: [
                {
                    q: 'How does Sora 2 work?',
                    a: 'Enter a text description or upload a reference image, and Sora 2 will generate high-quality video content based on your instructions.'
                },
                {
                    q: 'How many credits does each generation cost?',
                    a: 'Using Sora 2 costs 15 credits per generation. You can get better credit rates through subscription plans.'
                },
                {
                    q: 'What makes Sora 2 special?',
                    a: 'Sora 2 excels at generating realistic motion and cinematic quality videos, making it ideal for professional content creation.'
                },
                {
                    q: 'Can I use generated videos commercially?',
                    a: 'Yes, all content generated using Sora 2 can be used for commercial purposes.'
                }
            ]
        },
        wan: {
            title: 'Wan AI Video Generator',
            desc: 'Wan is a versatile AI video model supporting text-to-video and image-to-video with excellent quality and speed.',
            multiFormat: 'Multiple Formats',
            smoothMotion: 'Smooth Motion',
            referenceAudio: 'Reference Audio',
            uploadAudio: 'Click to upload reference audio',
            uploadAudioHint: 'MP3, WAV, M4A (optional, drives video soundtrack)',
            features: [
                {
                    icon: '🎬',
                    title: 'High Quality Output',
                    desc: 'Generate professional quality videos from text or images.'
                },
                {icon: '⚡', title: 'Fast Generation', desc: 'Quick video production for efficient workflow.'},
                {icon: '📱', title: 'Multiple Formats', desc: 'Support various aspect ratios and resolutions.'},
                {icon: '🖼️', title: 'Image Animation', desc: 'Bring static images to life with AI motion.'},
                {icon: '🎥', title: 'Smooth Motion', desc: 'Natural and fluid motion in generated videos.'},
                {
                    icon: '💼',
                    title: 'Commercial License',
                    desc: 'All generated videos can be used for commercial purposes.'
                }
            ],
            faq: [
                {
                    q: 'How does Wan work?',
                    a: 'Enter a text description or upload a reference image, and Wan will generate high-quality video content based on your instructions.'
                },
                {
                    q: 'Which Wan version should I use?',
                    a: 'Wan 2.5 and 2.6 offer the latest features and best quality. Wan 2.2 is a cost-effective option for simpler projects.'
                },
                {
                    q: 'How many credits does each generation cost?',
                    a: 'Wan 2.6 costs 70 credits, Wan 2.5 costs 60 credits, and Wan 2.2 costs 10 credits per generation.'
                },
                {
                    q: 'Can I use generated videos commercially?',
                    a: 'Yes, all content generated using Wan can be used for commercial purposes.'
                }
            ]
        },
        wan25: {
            title: 'Wan 2.5 AI Video Generator',
            desc: 'Wan 2.5 is a versatile AI video model supporting text-to-video and image-to-video with excellent quality and speed.',
            features: [
                {
                    icon: '🎬',
                    title: 'High Quality Output',
                    desc: 'Generate professional quality videos from text or images.'
                },
                {icon: '⚡', title: 'Fast Generation', desc: 'Quick video production for efficient workflow.'},
                {icon: '📱', title: 'Multiple Formats', desc: 'Support various aspect ratios and resolutions.'},
                {icon: '🖼️', title: 'Image Animation', desc: 'Bring static images to life with AI motion.'},
                {icon: '🎥', title: 'Smooth Motion', desc: 'Natural and fluid motion in generated videos.'},
                {
                    icon: '💼',
                    title: 'Commercial License',
                    desc: 'All generated videos can be used for commercial purposes.'
                }
            ],
            faq: [
                {
                    q: 'How does Wan 2.5 work?',
                    a: 'Enter a text description or upload a reference image, and Wan 2.5 will generate high-quality video content based on your instructions.'
                },
                {
                    q: 'What is the difference between Wan 2.5 and Wan 2.6?',
                    a: 'Wan 2.6 offers further improvements in quality and stability; Wan 2.5 is cost-effective and suitable for most use cases.'
                },
                {q: 'How many credits does each generation cost?', a: 'Wan 2.5 costs 60 credits per generation.'},
                {
                    q: 'Can I use generated videos commercially?',
                    a: 'Yes, all content generated using Wan 2.5 can be used for commercial purposes.'
                }
            ]
        },
        wan26: {
            title: 'Wan 2.6 AI Video Generator',
            desc: 'Wan 2.6 is an enhanced AI video model with improved quality and stability, supporting text-to-video and image-to-video.',
            features: [
                {
                    icon: '🎬',
                    title: 'High Quality Output',
                    desc: 'Generate professional quality videos from text or images with enhanced quality.'
                },
                {icon: '⚡', title: 'Fast Generation', desc: 'Quick video production for efficient workflow.'},
                {icon: '📱', title: 'Multiple Formats', desc: 'Support various aspect ratios and resolutions.'},
                {icon: '🖼️', title: 'Image Animation', desc: 'Bring static images to life with AI motion.'},
                {icon: '🎥', title: 'Smooth Motion', desc: 'Natural and fluid motion in generated videos.'},
                {
                    icon: '💼',
                    title: 'Commercial License',
                    desc: 'All generated videos can be used for commercial purposes.'
                }
            ],
            faq: [
                {
                    q: 'What is the difference between Wan 2.6 and Wan 2.5?',
                    a: 'Wan 2.6 offers further improvements in quality and stability for higher-quality output.'
                },
                {
                    q: 'How does Wan 2.6 work?',
                    a: 'Enter a text description or upload a reference image, and Wan 2.6 will generate high-quality video content based on your instructions.'
                },
                {q: 'How many credits does each generation cost?', a: 'Wan 2.6 costs 70 credits per generation.'},
                {
                    q: 'Can I use generated videos commercially?',
                    a: 'Yes, all content generated using Wan 2.6 can be used for commercial purposes.'
                }
            ]
        },
        wan22: {
            title: 'Wan 2.2 Classic AI Video Generator',
            desc: 'Wan 2.2 is a classic AI video model for text-to-video and image-to-video, focused on stable output and strong cost efficiency.',
            demoPromptExample: 'A girl with little freckles and messy red hair sitting on a rooftop during sunset, denim jacket slightly worn, holding a Polaroid camera, city skyline glowing in soft hues behind her.',
            resolutionBadge: '720p',
            classicVersion: 'Classic Version',
            stableReliable: 'Stable & Reliable',
            costEffective: 'Cost-effective',
            features: [
                {
                    icon: '🎬',
                    title: 'Text/Image to Video',
                    desc: 'Supports both text-to-video and image-to-video for daily creation and batch testing.'
                },
                {icon: '⚡', title: 'Stable Results', desc: 'Mature classic model with predictable output quality.'},
                {icon: '💰', title: 'Budget Friendly', desc: 'Lower credit usage for high-frequency workflows.'},
                {icon: '📐', title: 'Common Ratios', desc: 'Supports common aspect ratios like 16:9 and 9:16.'},
                {icon: '🎥', title: 'Clean Output', desc: 'Delivers clear and stable video quality.'},
                {icon: '💼', title: 'Commercial License', desc: 'Generated content can be used commercially.'}
            ],
            faq: [
                {
                    q: 'What is the difference between Wan 2.2 and Wan 2.5?',
                    a: 'Wan 2.2 is better for cost-sensitive, high-volume scenarios; Wan 2.5/2.6 provide stronger capabilities and quality.'
                },
                {
                    q: 'How does Wan 2.2 work?',
                    a: 'Enter a prompt or upload a reference image, and the model generates video based on your instruction.'
                },
                {
                    q: 'Can generated videos be used commercially?',
                    a: 'Yes, Wan 2.2 outputs can be used for commercial purposes.'
                }
            ]
        },
        kling25: {
            title: 'Kling 2.5 AI Video Generator',
            desc: 'Kling 2.5 is a standard AI video model supporting text-to-video and image-to-video with stable quality and good value.',
            standard: 'Standard',
            reliable: 'Reliable',
            costEffective: 'Cost-effective',
            standardQuality: 'Standard Quality',
            textToVideo: 'Text to Video',
            imageToVideo: 'Image to Video',
            referenceImage: 'Reference Image',
            referenceImageHint: 'Click to upload or drag and drop',
            referenceImageFormats: 'Supports PNG, JPG, JPEG, WEBP (<=10MB)',
            endFrame: 'End Frame',
            endFrameOptional: 'Optional',
            endFrameFormats: 'PNG, JPG, JPEG',
            endFrameHint: 'Constrain the ending frame; best when matching reference image aspect ratio',
            videoPrompt: 'Video Prompt',
            promptPlaceholder: 'Describe the video you want to generate...',
            negativePrompt: 'Negative Prompt',
            negativePromptPlaceholder: 'Describe what should be excluded...',
            duration: 'Duration',
            aspectRatio: 'Aspect Ratio',
            uploading: 'Uploading...',
            clickToUploadReference: 'Click to upload reference image',
            clickToUploadEndFrame: 'Click to upload end frame image',
            remove: 'Remove',
            creditsRequired: 'Credits Required:',
            remaining: 'Remaining:',
            generate: 'Generate',
            generating: 'Generating...',
            demoPrompt: 'Demo Prompt',
            demoPromptExample: 'Use the uploaded sci-fi alley image as the first frame. Keep the same alley, neon signs, reflections and the hooded woman walking away. Slowly move the camera forward down the alley...',
            model: 'Model:',
            durationLabel: 'Duration:',
            introTitle: 'Create High-quality AI Videos with Kling 2.5 Standard',
            featuresBadge: 'Core Features',
            featuresTitle: 'What can {name} do?',
            faqTitle: 'FAQ',
            errorPromptRequired: 'Please enter a prompt',
            errorImageRequired: 'Reference image is required in image-to-video mode',
            errorGenerationFailed: 'Generation failed',
            errorRequestFailed: 'Request failed, please try again',
            errorUploadFailed: 'Upload failed, please try again',
            features: [
                {
                    icon: '🎬',
                    title: 'Text/Image to Video',
                    desc: 'Supports both text-to-video and image-to-video with 5s/10s duration options.'
                },
                {icon: '⚡', title: 'Reliable Output', desc: 'A mature standard model with stable performance.'},
                {icon: '💰', title: 'Great Value', desc: 'Lower credit consumption than higher-tier models.'},
                {icon: '📐', title: 'Multi Ratio', desc: 'Supports 1:1, 16:9, and 9:16.'},
                {icon: '💼', title: 'Commercial License', desc: 'Generated content can be used commercially.'}
            ],
            faq: [
                {
                    q: 'What is the difference between Kling 2.5 and Kling 2.6?',
                    a: 'Kling 2.5 is optimized for cost and throughput, while Kling 2.6 provides stronger overall capabilities.'
                },
                {
                    q: 'How does Kling 2.5 work?',
                    a: 'Enter a prompt or upload a reference image, and Kling 2.5 generates the video accordingly.'
                },
                {q: 'Can generated videos be used commercially?', a: 'Yes, Kling 2.5 outputs can be used commercially.'}
            ]
        },
        viduq3pro: {
            title: 'Vidu Q3 Pro AI Video',
            desc: 'Vidu Q3 Pro supports text-to-video and image-to-video with resolution, 1–16s length, aspect ratios, and optional audio.',
            imageUrlHint: 'Only HTTPS image URLs are accepted (upload returns a public URL). Image aspect ratio must be between 1:4 and 4:1.',
            lengthLabel: 'Duration (seconds)',
            optional: 'Optional',
            tagHighQuality: 'High quality',
            tagLength: '1–16 seconds',
            tagResolution: 'Up to 2K',
            demoPromptExample: 'A seaside promenade at sunrise, joggers, gulls over the water, a sailboat in the distance.',
            features: [
                {icon: '🎬', title: 'Text & image', desc: 'Generate from a prompt or a reference image.'},
                {icon: '📐', title: 'Aspect ratios', desc: 'Text mode: 16:9, 9:16, 1:1, 4:3, 3:4.'},
                {icon: '⏱️', title: 'Flexible length', desc: 'Choose from 1 to 16 seconds.'},
                {icon: '🎵', title: 'Optional audio', desc: 'Enable natural-sounding audio for the clip.'},
                {icon: '🎲', title: 'Seed control', desc: 'Optional seed for more reproducible results.'}
            ],
            faq: [
                {q: 'What does image-to-video require?', a: 'A public HTTPS image URL (JPG/PNG). Aspect ratio must be stricter than 1:4 or 4:1.'},
                {q: 'How do text and image modes differ?', a: 'Text mode uses aspect ratio; image mode uses your image URL and does not send text-only aspect fields.'},
                {q: 'How are credits calculated?', a: 'Per the credits shown on the page, based on duration, resolution, and audio settings.'}
            ]
        },
        wanAnimate: {
            title: 'Wan Animate',
            desc: 'Drive character animation from a reference image and motion video. Standard or professional quality.',
            animateMode: 'Animation Mode',
            modeAnimate: 'Image-to-Action',
            modeReplace: 'Video Character Swap',
            referenceVideo: 'Reference Video',
            quality: 'Quality Mode',
            refImageLabel: 'Reference image',
            refImageHint: 'Character or subject to animate (JPG/PNG/JPEG/BMP/WEBP, max 5MB, 200–4096px sides, aspect 1:3–3:1).',
            refVideoLabel: 'Reference video',
            refVideoHint: 'Motion reference (MP4/AVI/MOV, 2–30s, max 200MB, 200–2048px sides, aspect 1:3–3:1).',
            animateModeLabel: 'Animation mode',
            btnAnimate: 'Animate',
            animateModeBadgeAnimate: 'Motion',
            animateModeBadgeReplace: 'Replace',
            btnAnimateDesc: 'Combine the character from the image with motion from the video.',
            btnReplace: 'Replace',
            btnReplaceDesc: 'Replace the character in the video with the character from the image.',
            qualityLabel: 'Quality mode',
            qualityStd: 'Standard',
            qualityPro: 'Professional',
            watermarkLabel: 'Watermark',
            uploadVideoRequired: 'Please upload a reference video.',
            uploadImage: 'Upload image',
            uploadVideo: 'Upload video',
            uploading: 'Uploading…',
            imageUploadHint: 'JPG, PNG, JPEG, BMP, WEBP · max 5MB',
            videoUploadHint: 'MP4, AVI, MOV · 2–30s · max 200MB',
            uploadImageRequired: 'Please upload a reference image.',
            errImageFileTooLarge: 'Image file is too large (max 5MB).',
            errImageDimensions: 'Image width and height must be between 200 and 4096 px.',
            errImageAspect: 'Image aspect ratio must be between 1:3 and 3:1.',
            errImageInvalid: 'Invalid or unreadable image file.',
            errVideoFileTooLarge: 'Video file is too large (max 200MB).',
            errVideoDuration: 'Video duration must be between 2 and 30 seconds.',
            errVideoDimensions: 'Video width and height must be between 200 and 2048 px.',
            errVideoAspect: 'Video aspect ratio must be between 1:3 and 3:1.',
            errVideoInvalid: 'Invalid or unreadable video file.',
            defaultModelName: 'Wan Animate',
            demoEmptyHint: 'Upload a character image and a motion video, and use Wan Animate to create stunning character animations.',
            demoEmptyTitle: 'Character Animation',
            demoStepCharacter: 'Character',
            demoStepMotion: 'Motion',
            demoStepAnimate: 'Animate',
            faqCredits: 'Standard mode uses fewer credits per generation than professional mode. See the credits line above.',
            characterAnimation: 'Character animation',
            faceSwap: 'Face swap',
            motionTransfer: 'Motion transfer',
            identityReplacement: 'Identity replacement',
            motionAccuracy: 'High motion fidelity',
            features: [
                {icon: '🎭', title: 'Two modes', desc: 'Animate motion transfer or full character replacement.'},
                {icon: '📐', title: 'DashScope official', desc: 'Powered by Wan 2.2 Animate on Alibaba Cloud.'},
                {icon: '⚡', title: 'Std / Pro', desc: 'Choose standard or professional quality per task.'},
                {icon: '💧', title: 'Optional watermark', desc: 'Toggle watermark on the output.'}
            ],
            faq: [
                {q: 'What inputs are required?', a: 'A public HTTPS image URL and video URL after upload. Images and videos must meet size and aspect ratio limits.'},
                {q: 'What is the difference between Animate and Replace?', a: 'Animate applies motion from the video to your image character. Replace swaps the character in the video with your image character.'},
                {q: 'How are credits calculated?', a: 'Professional mode costs more than standard mode per generation, as shown on the page.'}
            ]
        },
        hailuo: {
            title: 'Hailuo 2.3 AI Video Generator',
            desc: 'Hailuo 2.3 is a next-generation AI video model designed for creative, high-quality video generation.',
            demoPromptExample: 'A cinematic shot of waves crashing on a rocky shore at sunset, golden light reflecting on the water...',
            highQuality: 'High Quality',
            highQualityOutput: 'High-quality Output',
            features: [
                {icon: '🎬', title: 'Text to Video', desc: 'Generate high-quality videos directly from text prompts.'},
                {
                    icon: '✨',
                    title: 'Prompt Enhancement',
                    desc: 'Prompt enhancement helps improve consistency and quality.'
                },
                {icon: '🌊', title: 'Creative Style', desc: 'Great for creative and artistic video content.'},
                {icon: '⚡', title: 'Fast Generation', desc: 'Optimized pipeline for quicker turnaround.'},
                {icon: '🎨', title: 'Visual Quality', desc: 'Produces detailed and stable visual output.'},
                {icon: '💼', title: 'Commercial License', desc: 'Generated content can be used commercially.'}
            ],
            faq: [
                {
                    q: 'How does Hailuo 2.3 work?',
                    a: 'Enter a prompt or upload a reference image and the model generates the corresponding video.'
                },
                {
                    q: 'What is prompt enhancement?',
                    a: 'Prompt enhancement rewrites and enriches prompts for better generation quality.'
                },
                {
                    q: 'Can generated videos be used commercially?',
                    a: 'Yes, Hailuo 2.3 outputs can be used commercially.'
                },
                {
                    q: 'How many credits does each generation cost?',
                    a: 'Each generation is billed by current model credit rules.'
                }
            ]
        },
        runway: {
            title: 'Runway AI Video Generator',
            desc: 'Runway is a professional AI video model with flexible controls for ratio, duration, and seed.',
            demoPromptExample: 'At dusk, the silhouettes of cranes at a Singaporean construction site are set against a brilliant sunset. Several construction workers wearing hard hats are packing up their tools, getting ready to leave...',
            professional: 'Professional',
            multiOption: 'Multiple Options',
            highQuality: 'High Quality',
            multiFormat: 'Multiple Ratios',
            reproducibleSeed: 'Reproducible Seed',
            features: [
                {
                    icon: '🎬',
                    title: 'Image to Video',
                    desc: 'Upload a reference image and prompt to generate high-quality videos quickly.'
                },
                {icon: '📐', title: 'Multiple Ratios', desc: 'Supports 16:9, 9:16, 1:1, 4:3, 3:4, and 21:9.'},
                {icon: '🎲', title: 'Seed Control', desc: 'Use seed to reproduce similar generation results.'},
                {
                    icon: '⚡',
                    title: 'Professional Output',
                    desc: 'Consistent output suitable for pro and commercial workflows.'
                },
                {icon: '🖼️', title: 'Image Animation', desc: 'Turn static images into dynamic video shots.'},
                {icon: '💼', title: 'Commercial License', desc: 'Generated content can be used commercially.'}
            ],
            faq: [
                {
                    q: 'How does Runway work?',
                    a: 'Upload a reference image and enter a prompt; the model generates the corresponding video.'
                },
                {q: 'Which aspect ratios are supported?', a: '16:9, 9:16, 1:1, 4:3, 3:4, and 21:9 are supported.'},
                {q: 'Can generated videos be used commercially?', a: 'Yes, Runway outputs can be used commercially.'}
            ]
        }
    },
    privacy: {
        title: 'Privacy Policy',
        lastUpdated: 'Last updated: January 15, 2025',
        navTerms: 'Terms of Service →',
        navTrust: 'Trust & Safety →',
        sections: [
            {
                title: '1. Information Collection',
                paragraphs: ['We collect information you provide when registering and using our services, including email address, username, and payment information.', 'We also automatically collect usage data such as IP address, browser type, access time, and features used.']
            },
            {
                title: '2. Information Use',
                paragraphs: ['We use the collected information to provide, maintain, and improve our services, process transactions, send service-related notifications, and prevent fraud and abuse.', 'We do not sell your personal information to third parties.']
            },
            {
                title: '3. AI Generated Content',
                paragraphs: ['Images you upload and prompts you enter are used solely to generate the content you request and are not used to train AI models.', 'Generated content is temporarily stored on our servers for you to download, then deleted according to our data retention policy.']
            },
            {
                title: '4. Data Security',
                paragraphs: ['We employ industry-standard security measures to protect your personal information, including SSL encryption, access controls, and regular security audits.', 'While we do our best to protect your data, no internet transmission method is 100% secure.']
            },
            {
                title: '5. Cookie Usage',
                paragraphs: ['We use cookies and similar technologies to improve user experience, analyze usage, and provide personalized content.', 'You can manage cookie preferences through your browser settings. Disabling cookies may affect certain features.']
            },
            {
                title: '6. Third-Party Services',
                paragraphs: ['We may use third-party service providers to assist us in providing services, such as payment processing, data analytics, and customer support.', 'These third-party service providers only access your personal information to the extent necessary to perform services for us.']
            },
            {
                title: '7. Your Rights',
                paragraphs: ['You have the right to access, correct, or delete your personal information. You also have the right to request that we restrict processing of your data or transfer your data to another service.', 'To exercise these rights, please contact us at miral_support@miralvis.com. We will respond to your request within 30 days.']
            },
            {
                title: '8. GDPR Compliance',
                paragraphs: ['For users in the European Economic Area, we comply with the requirements of the General Data Protection Regulation (GDPR). Our legal basis for processing your data includes contract performance, legitimate interests, and your consent.']
            },
            {
                title: '9. Contact Us',
                paragraphs: ['If you have any questions or concerns about our privacy policy, please contact our data protection team at miral_support@miralvis.com.']
            }
        ]
    },
    terms: {
        title: 'Terms of Service',
        lastUpdated: 'Last updated: January 15, 2025',
        navPrivacy: 'Privacy Policy →',
        navTrust: 'Trust & Safety →',
        sections: [
            {
                title: '1. Service Overview',
                paragraphs: ['Miral (hereinafter referred to as "the Platform") is an AI platform integrating image, video, and music creation. These Terms of Service (hereinafter referred to as "Terms") govern the conditions and rules for your use of the Platform.', 'By using the Platform, you agree to be bound by these Terms. If you do not agree to these Terms, please do not use the Platform.']
            },
            {
                title: '2. Account Registration',
                paragraphs: ['You must be at least 18 years old to register an account. You need to provide accurate and complete registration information and are responsible for maintaining account security.', 'You are responsible for all activities conducted through your account. If you discover any unauthorized use, please notify us immediately.']
            },
            {
                title: '3. Service Usage',
                paragraphs: ['The Platform provides credit-based AI content generation services. Credits can be obtained through subscription or one-time purchase. Different AI models and features consume different amounts of credits.', 'You agree not to use the Platform for any illegal, harmful, or infringing purposes. Generating illegal, pornographic, violent, or rights-infringing content is prohibited.']
            },
            {
                title: '4. Intellectual Property',
                paragraphs: ['Intellectual property rights for content you generate through the Platform belong to you, subject to the terms of use of each AI model provider.', 'The Platform\'s trademarks, logos, interface designs, and software code are protected by intellectual property laws and may not be used without authorization.']
            },
            {
                title: '5. Payment and Refunds',
                paragraphs: ['All payments are in US dollars. Subscription fees are charged monthly or annually, depending on your chosen plan.', 'For first-time purchases of one-time packages or first subscriptions, refunds can be requested within 7 calendar days if credit usage is below 3%.']
            },
            {
                title: '6. Disclaimer',
                paragraphs: ['The Platform provides services "as is" and makes no express or implied warranties regarding the availability, accuracy, or suitability of the services.', 'AI-generated content may be inaccurate or imperfect. Users should judge the applicability of generated content themselves.']
            },
            {
                title: '7. Limitation of Liability',
                paragraphs: ['To the maximum extent permitted by law, the Platform is not liable for any direct, indirect, incidental, or consequential damages resulting from the use or inability to use the services.', 'The Platform\'s total liability does not exceed the total fees you paid in the past 12 months.']
            },
            {
                title: '8. Terms Modification',
                paragraphs: ['We reserve the right to modify these Terms at any time. Modified Terms become effective when posted on this page.', 'Continued use of the Platform indicates acceptance of the modified Terms. Significant changes will be notified via email or Platform notification.']
            },
            {
                title: '9. Contact Us',
                paragraphs: ['If you have any questions about these Terms, please contact us at miral_support@miralvis.com.']
            }
        ]
    },
    trustSafety: {
        tag: '🛡️ Trust & Safety',
        title: 'Your Data Security is Our Top Priority',
        subtitle: 'Learn how we protect your privacy and data security.',
        badges: [
            {
                icon: '🛡️',
                title: 'No AI Training',
                desc: 'Your uploaded content and generated works are never used to train any AI models.'
            },
            {
                icon: '🔒',
                title: 'End-to-End Encryption',
                desc: 'All data transfers use TLS 1.3 encryption, stored data uses AES-256 encryption.'
            },
            {
                icon: '✓',
                title: 'GDPR Compliant',
                desc: 'Fully compliant with EU General Data Protection Regulation requirements.'
            },
            {
                icon: '🗑️',
                title: 'Self Data Control',
                desc: 'You can export or delete all your data at any time, including account deletion.'
            }
        ],
        sections: [
            {
                title: 'Data Processing Transparency',
                paragraphs: ['We are completely transparent about how we handle data. Images and videos you upload are used only to generate the content you request and are deleted from servers within 24 hours after processing.', 'Generated content is stored in your account, and you can download or delete it at any time. We do not share your content without your consent.']
            },
            {
                title: 'Secure Infrastructure',
                paragraphs: ['Our services are deployed on world-leading cloud infrastructure with multi-layer security protection. All servers are located in SOC 2 and ISO 27001 certified data centers.', 'We conduct regular security audits and penetration tests to ensure system security. All employees receive strict security training.']
            },
            {
                title: 'Content Safety',
                paragraphs: ['We deploy advanced content safety systems that automatically detect and block harmful content generation. This includes but is not limited to violent, pornographic, and infringing content.', 'If you discover any violating content, please report it to us at abuse@miral.org.']
            },
            {
                title: 'Compliance & Certification',
                paragraphs: ['We comply with major global data protection regulations, including GDPR (EU), CCPA (California), and LGPD (Brazil).', 'Our payment processing complies with PCI DSS standards, ensuring your payment information is secure.']
            }
        ],
        ctaTitle: 'Security Concerns?',
        ctaDesc: 'Our security team is ready to answer your questions',
        ctaButton: 'Contact Security Team',
        navTerms: 'Terms of Service →',
        navPrivacy: 'Privacy Policy →'
    },
    gallery: {
        tag: 'Creation History',
        title: 'My Creations',
        subtitle: 'View all your AI creation history.',
        loginRequired: 'Please login to view your creation history',
        empty: 'No creations yet',
        loadMore: 'Load More',
        filters: {
            all: 'All',
            pending: 'Processing',
            finish: 'Finished',
            failed: 'Failed'
        },
        usePrompt: 'Generate with this prompt',
        download: 'Download',
        status: {
            pending: 'Processing',
            finish: 'Finished',
            failed: 'Failed'
        }
    },
    inspiration: {
        title: 'Inspiration',
        subtitle: 'See what creators are building with Miral — from hyper-realistic images to cinematic videos, inspiration at your fingertips.',
        filters: {
            all: 'All',
            image: 'Image',
            video: 'Video',
            portrait: 'Portrait',
            landscape: 'Landscape',
            fantasy: 'Fantasy',
            anime: 'Anime'
        }
    },
    profile: {
        joinTime: 'Joined',
        tabs: {
            account: 'Account',
            billing: 'Billing',
            privacy: 'Data & Privacy'
        },
        balance: {
            title: 'Balance Overview',
            available: 'Available Credits'
        },
        subscription: {
            currentPlan: 'Current Plan',
            status: 'Status',
            activated: 'Activated',
            cancelled: 'Cancels at end of current period',
            pending: 'Processing',
            failed: 'Payment Failed',
            expiryDate: 'Valid Until',
            permanent: 'Permanent',
            upgradePlan: 'Upgrade or Change Plan',
            cancelPlan: 'Cancel Subscription',
            cancelNote: 'Your subscription remains active until the end of the current billing period',
            cancelWarning: 'Your subscription will be cancelled. You can continue to use all features until',
            restorePlan: 'Resume Subscription'
        },
        upgrade: {
            title: 'Upgrade',
            desc: 'Get unlimited access and exclusive benefits',
            btn: 'View Plans'
        },
        billing: {
            title: 'Payment History',
            subtitle: 'View your payment records and download invoices',
            empty: 'No billing records yet',
            creditsPack: 'Credits Pack',
            oneTime: 'One-time',
            monthly: 'Monthly',
            yearly: 'Yearly',
            refresh: 'Refresh',
            plan: 'Plan',
            date: 'Date',
            amount: 'Amount',
            invoice: 'Invoice',
            download: 'Download',
            invoiceModal: {
                title: 'Invoice Details',
                orderInfo: 'Order Information',
                invoiceInfo: 'Invoice Information',
                plan: 'Plan',
                date: 'Payment Date',
                amount: 'Amount',
                paymentId: 'Order ID',
                close: 'Close',
                download: 'Download Invoice',
                fullName: 'Full Name',
                fullNamePlaceholder: 'Enter your full name',
                email: 'Email',
                emailPlaceholder: 'Enter your email',
                company: 'Company',
                companyPlaceholder: 'Company legal name',
                taxId: 'Tax ID',
                taxIdPlaceholder: 'Enter tax ID',
                addressLine1: 'Address Line 1',
                addressLine1Placeholder: 'Street address',
                addressLine2: 'Address Line 2',
                addressLine2Placeholder: 'Apt, suite, etc. (optional)',
                city: 'City',
                cityPlaceholder: 'City',
                province: 'Province',
                provincePlaceholder: 'Province',
                postalCode: 'Postal Code',
                postalCodePlaceholder: 'Postal code',
                country: 'Country',
                countryPlaceholder: 'Country',
                invoiceRemarks: 'Remarks',
                invoiceRemarksPlaceholder: 'Invoice remarks',
                optional: 'optional',
                required: 'This field is required'
            }
        },
        privacy: {
            title: 'Privacy Settings',
            cardTitle: 'Your Data is Protected',
            cardSubtitle: 'Our commitment to your data privacy and security',
            item1: 'Your data is never used for AI model training',
            item2: 'Data transmission and storage are fully encrypted',
            item3: 'Generated works are automatically deleted after storage period',
            item4: 'No feedback loops, no secondary use of derived data',
            item5: 'Strict compliance with data protection regulations'
        },
        support: {
            title: 'Need Help?',
            desc: 'Our support team is here to help',
            btn: 'Contact Support',
            note: 'miral_support@miralvis.com · Response within 24 hours'
        }
    },
    payment: {
        success: {
            title: 'Payment Successful',
            message: 'Thank you for your purchase! Your order has been processed successfully and credits have been added to your account.',
            goHome: 'Go to Home',
            viewProfile: 'View Profile'
        },
        cancel: {
            title: 'Payment Cancelled',
            message: 'Your payment has been cancelled. If you have any questions, please feel free to contact our support team.',
            tryAgain: 'Try Again',
            goHome: 'Go to Home'
        }
    },
    seo: {
        default: {
            title: 'Miral - AI Image, Video & Music Generator',
            description: 'Miral is an all-in-one AI creation platform supporting top AI models like Seedream 4, Midjourney, GPT Image, Veo 3, and Sora 2. Create stunning images, videos, and music effortlessly.',
            keywords: 'AI image generator, AI video generator, AI music generator, text to image, text to video, Seedream, Midjourney, Veo, Sora, Miral'
        },
        home: {
            title: 'Miral: AI Image, Video & Music Generator',
            description: 'Create high-quality AI images, videos, and music on Miral with leading models including Seedream 5, Midjourney, Veo 3.1, Sora 2, and more in one platform.'
        },
        pricing: {
            title: 'Pricing - Miral AI Creation Platform',
            description: 'Miral offers flexible pricing plans for all your creative needs. Buy credits, pay as you go, no subscription required.'
        },
        profile: {
            title: 'Profile - Miral',
            description: 'Manage your Miral account, view order history and creation records.'
        },
        models: {
            title: 'AI Models - Miral',
            description: 'Explore top AI models on Miral platform, including image, video, and music generation models.',
            wan25: {
                title: 'Wan 2.5 - Powerful AI Video Model',
                description: 'Wan 2.5 delivers next-level AI video generation. Create realistic, smooth videos with advanced motion and detail, perfect for creators and businesses.'
            },
            wan26: {
                title: 'Wan 2.6 - Enhanced AI Video Generator',
                description: 'Upgrade your video creation with Wan 2.6. This advanced AI model generates ultra-realistic videos with improved motion, detail, and speed for professional content.'
            },
            wan22: {
                title: 'Wan 2.2 - Fast AI Video Generator',
                description: 'Wan 2.2 is a fast, reliable AI video model. Generate high-quality videos quickly, ideal for creators needing quick, professional content production.'
            },
            wanAnimate: {
                title: 'Wan Animate - Character Animation - Miral',
                description: 'Animate characters with reference image and motion video via Alibaba Wan 2.2 Animate.'
            },
            veo30: {
                title: 'Veo 3.0 - Leading AI Video Model',
                description: 'Veo 3.0 is a top-tier AI video generator. Create lifelike, cinematic videos with advanced AI, perfect for professional content creation and marketing.'
            },
            veo31: {
                title: 'Veo 3.1 - Top AI Video Generation',
                description: 'Veo 3.1 is a leading AI video model for stunning, lifelike videos. Create cinematic clips, animations, and content with unmatched quality and speed.'
            },
            kling26: {
                title: 'Kling 2.6 - Premium AI Video Model',
                description: 'Kling 2.6 brings professional AI video generation to life. Generate high-quality, smooth videos with advanced AI for creators, marketers, and businesses.'
            },
            kling3: {
                title: 'Kling 3 - AI Video Generator - Miral',
                description: 'Generate high-quality AI videos with Kling 3 model.'
            },
            kling25: {
                title: 'Kling 2.5 - Reliable AI Video Model',
                description: 'Kling 2.5 offers powerful AI video generation for creators. Make high-quality videos with smooth motion and detail, perfect for content and marketing.'
            },
            seedance: {
                title: 'Seedance AI - Advanced AI Video Generator',
                description: 'Generate high-quality AI videos with Seedance AI. Create stunning clips, animations, and cinematic content with cutting-edge AI models for fast, professional results.'
            },
            sora2: {
                title: 'Sora 2 AI Video Generator – Text & Image to Video | Miral',
                description: 'Create Sora 2 AI videos from text or images on Miral. Try it with free credits and choose 4–12 seconds, 720p or 1080p, and 16:9 or 9:16 formats.'
            },
            hailuo23: {
                title: 'Hailuo 2.3 - Smart AI Video Generator',
                description: 'Hailuo 2.3 delivers intelligent AI video generation. Create high-quality, creative videos with advanced AI for content creators and businesses.'
            },
            viduq3pro: {
                title: 'Vidu Q3 Pro - AI Video Generator - Miral',
                description: 'Create text-to-video and image-to-video with Vidu Q3 Pro, multiple resolutions and lengths.'
            },
            runway: {
                title: 'Runway - AI Video Creation Platform',
                description: 'Runway is a leading AI video platform for creators. Edit, generate, and enhance videos with powerful AI tools, perfect for professional content production.'
            },
            nanobanana: {
                title: 'Nano Banana - AI Image Generator - Miral',
                description: 'Quickly generate creative images with Nano Banana model.'
            },
            seedream4: {
                title: 'Seedream 4 - AI Image Generator',
                description: 'Create stunning, high-resolution AI images with Seedream 4. Generate photorealistic art, illustrations, and designs with advanced AI for professional creative work.'
            },
            seedream5: {
                title: 'Seedream 5 - ByteDance AI Image Generator - Miral',
                description: 'Generate high-quality AI images with ByteDance Seedream 5 model.'
            },
            midjourney: {
                title: 'Midjourney - AI Art Generator',
                description: 'Midjourney is a leading AI art generator. Create breathtaking images, art, and designs from text prompts, perfect for artists, designers, and content creators.'
            },
            gptimage1: {
                title: 'GPT-Image-1 - OpenAI AI Image Model',
                description: 'GPT-Image-1 by OpenAI generates high-quality AI images from text. Create realistic, creative visuals for design, marketing, and content creation.'
            },
            gptimage15: {
                title: 'GPT Image 1.5 - OpenAI AI Image Generator - Miral',
                description: 'Generate high-quality AI images with OpenAI GPT Image 1.5 model.'
            },
            fluxpro11ultra: {
                title: 'Flux Pro 1.1 Ultra - Premium AI Image Generator',
                description: 'Flux Pro 1.1 Ultra delivers ultra-high-quality AI image generation. Create photorealistic, detailed images with advanced AI for professional design and art.'
            },
            fluxschnell: {
                title: 'Flux Schnell - Fast AI Image Generator',
                description: 'Flux Schnell is a lightning-fast AI image generator. Create high-quality images quickly, ideal for creators needing fast, professional visual content.'
            },
            flux1: {
                title: 'FLUX.1 AI Image Generator Free Online | Miral',
                description: 'Use the FLUX.1 AI image generator for free with Flux Pro 1.1 Ultra or Flux Schnell, nine aspect ratios, and multiple visual styles. Sign up to receive free credits and start generating images instantly.',
                heroHeadline: 'FLUX.1 AI Image Generator',
                heroIntro: 'Use the FLUX.1 AI image generator for free. Sign up to receive free credits and choose between high-quality output with Flux Pro 1.1 Ultra and fast multi-style creation with Flux Schnell.',
                eyebrow: 'Black Forest Labs · FLUX.1',
                sectionKicker: 'FLUX.1',
                ctaTag: 'FLUX.1 · Miral',
                badges: ['Text to Image', '9 Aspect Ratios', 'Pro and Schnell', 'Photographic / Digital Art / Anime'],
                previewLabel: 'Flux Pro 1.1 Ultra',
                previewMeta: ['1:1', '16:9', '9:16', '9 Ratios'],
                previewTitle: 'Choose between polished quality and fast creative exploration',
                previewDesc: 'Use Pro 1.1 Ultra for detailed visuals or Schnell to explore photographic, digital art, and anime directions quickly.',
                keyFeaturesTitle: 'Create High-Quality Visuals with the FLUX.1 Text to Image Generator',
                keyFeaturesIntro: 'Explore Flux Pro 1.1 Ultra and Flux Schnell features for prompt understanding, output speed, visual styles, and flexible aspect ratios.',
                exploreTitle: 'Explore More AI Image Models',
                mainFeaturesTitle: 'Key FLUX.1 Features',
                generatedImageLabel: 'Generated Image',
                versionLabel: 'Version',
                featureLabel: 'Key Features',
                useCaseLabel: 'Best For',
                controlsTitle: 'Choose the Right Model, Ratio, and Visual Style',
                controlsIntro: 'Use Flux Pro 1.1 Ultra for polished final images or Flux Schnell for faster exploration, then match the aspect ratio and style to the intended channel.',
                galleryTitle: 'More FLUX.1 Image Examples',
                discussionTitle: 'Common FLUX.1 Selection Questions',
                communityTitle: 'Popular Ways to Create with FLUX.1',
                tutorialPrompt: 'A quiet glasshouse bookstore beside the sea at sunrise, warm reading lamps, pale oak shelves, soft reflections on the floor, realistic interior photography.',
                qualityBenefits: [
                    'Render materials, lighting, and spatial depth with a more polished finish.',
                    'Follow detailed prompts that combine subject, composition, camera, and style.',
                    'Explore photographic, digital art, and anime directions from clear text instructions.'
                ],
                features: [
                    { name: 'High-Quality FLUX.1 Text to Image', short: 'Turn written prompts into detailed, professional visuals.', desc: 'Flux Pro 1.1 Ultra is suited to work where image detail, materials, lighting, and overall finish matter. Clearly describing the subject, composition, camera, and style helps steer the image toward your project direction.', demo: { type: 'table', rows: [
                        { prompt: 'Boutique desert hotel exterior at blue hour, rammed earth walls, warm window glow, native grasses, long shadows, realistic architectural photography.' },
                        { prompt: 'Editorial food photography of handmade ravioli on a matte black plate, basil oil, linen napkin, directional window light, shallow depth of field.' }
                    ] } },
                    { name: 'Fast Generation with Flux Schnell', short: 'Create quick drafts, test prompts, and explore ideas rapidly.', desc: 'Flux Schnell is a strong fit for workflows that need fast composition, style, or concept testing. Generate a draft, review the direction, then refine the prompt for another iteration.', prompt: 'A modular cardboard trade show booth concept for an eco startup, simple product plinths, recycled paper textures, bright exhibition lighting, clean layout.' },
                    { name: 'Nine Image Aspect Ratios', short: 'Cover ultra-wide, landscape, square, portrait, and tall formats.', desc: 'Flux Pro 1.1 Ultra and Flux Schnell both support 21:9, 16:9, 4:3, 3:2, 1:1, 2:3, 3:4, 9:16, and 9:21 for banners, product images, social content, posters, and mobile visuals.', prompt: 'A 21:9 panoramic alpine observatory above a sea of clouds, glass viewing deck, early morning light, tiny hikers for scale, cinematic matte painting.' },
                    { name: 'Multiple Visual Styles in Schnell', short: 'Choose Auto, Photographic, Digital Art, or Anime.', desc: 'Flux Schnell offers Auto, Photographic, Digital Art, and Anime style directions, making it easy to switch between photo-real, illustrated, and anime visuals without changing models.', demo: { type: 'table', rows: [
                        { prompt: 'Photographic style: a bicycle mechanic adjusting a vintage racing bike in a sunlit garage, grease-stained hands, realistic chrome reflections.' },
                        { prompt: 'Anime style: a cozy cat cafe inside a sky train, pastel sunset clouds outside the windows, expressive characters, clean line art.' }
                    ] } },
                    { name: 'Flexible Creative Use Cases', short: 'Create product, marketing, portrait, concept, and social visuals.', desc: 'The FLUX.1 family supports polished product and brand imagery as well as fast campaign concepts, portraits, environment designs, and platform-specific aspect ratios.', prompt: 'Sustainable sneaker launch visual with recycled fabric texture, floating lace details, moss-green gradient background, bold empty space for social ad copy.' }
                ],
                showcaseKicker: 'Prompt examples',
                showcaseTitle: 'FLUX.1 Prompt Examples for Better AI Images',
                showcaseIntro: 'Use these FLUX.1 prompts as a starting point. Clearly describe the subject, composition, lighting, camera, materials, color palette, and visual style.',
                variantsKicker: 'Model guide',
                variantsTitle: 'Flux Pro 1.1 Ultra vs Flux Schnell',
                variantsIntro: 'Choose a FLUX.1 model based on the quality, speed, and style control your project needs.',
                variants: [
                    { name: 'Flux Pro 1.1 Ultra', tag: 'High Quality', desc: 'Designed for detailed, realistic, polished text-to-image work with nine supported aspect ratios.', bestFor: 'Best for product photography, campaign hero images, and polished final visuals' },
                    { name: 'Flux Schnell', tag: 'Fast', desc: 'Designed for rapid iteration with nine aspect ratios and Auto, Photographic, Digital Art, and Anime styles.', bestFor: 'Best for drafts, prompt testing, social content, and fast exploration' }
                ],
                useCasesKicker: 'Made for real work',
                useCasesTitle: 'Popular FLUX.1 Use Cases',
                useCases: [
                    { name: 'FLUX.1 for Product Photography', desc: 'Create product hero images, lifestyle scenes, and e-commerce visual concepts.' },
                    { name: 'FLUX.1 for Marketing and Advertising', desc: 'Generate social ads, campaign banners, and branded marketing visuals.' },
                    { name: 'FLUX.1 for Photorealistic Portraits', desc: 'Create photo-like portraits with controlled lighting, backgrounds, and composition.' },
                    { name: 'FLUX.1 for Digital Art', desc: 'Use Schnell to explore illustration, fantasy, and digital art directions quickly.' },
                    { name: 'FLUX.1 for Anime Images', desc: 'Use the Schnell Anime style for characters and anime scenes.' },
                    { name: 'FLUX.1 for Concept Art', desc: 'Explore cinematic environments, game scenes, characters, and visual worlds.' },
                    { name: 'FLUX.1 for Social Media Images', desc: 'Use nine aspect ratios for landscape, square, and portrait platform content.' },
                    { name: 'FLUX.1 for Posters and Banners', desc: 'Choose a suitable ratio for events, promotions, and mobile page layout concepts.' }
                ],
                howToKicker: 'Three simple steps',
                howToTitle: 'How to Use the FLUX.1 AI Image Generator Online for Free',
                howToIntro: 'Sign up to receive free credits and use Flux Pro 1.1 Ultra or Flux Schnell online on Miral.',
                howToSteps: [
                    { title: 'Enter a Detailed Prompt', desc: 'Describe the subject, setting, composition, lighting, camera, materials, colors, and target style.' },
                    { title: 'Choose Model and Ratio', desc: 'Pick Pro 1.1 Ultra for polished quality or Schnell for fast exploration, then set an aspect ratio and Schnell style.' },
                    { title: 'Generate and Refine', desc: 'Generate the image, review and download it, or adjust the prompt, ratio, or style for another version.' }
                ],
                howToCta: 'Use FLUX.1 AI Image Generator for Free',
                faqTitle: 'Frequently Asked Questions About FLUX.1',
                faqs: [
                    { q: 'What is the FLUX.1 AI image generator?', a: 'FLUX.1 is an image generation model family from Black Forest Labs. On Miral, use Flux Pro 1.1 Ultra and Flux Schnell to turn text prompts into product, marketing, portrait, anime, and concept art images.' },
                    { q: 'Can I use the FLUX.1 AI image generator for free?', a: 'Yes. Sign up to receive free credits and start creating high-quality images with the FLUX.1 AI image generator immediately. Generating images uses the corresponding credits.' },
                    { q: 'What is the difference between Flux Pro 1.1 Ultra and Flux Schnell?', a: 'Flux Pro 1.1 Ultra is suited to polished final images where detail and finish matter. Flux Schnell is suited to fast drafts, prompt testing, and multi-style exploration, with Auto, Photographic, Digital Art, and Anime styles.' },
                    { q: 'What image aspect ratios does FLUX.1 support?', a: 'Flux Pro 1.1 Ultra and Flux Schnell on Miral support 21:9, 16:9, 4:3, 3:2, 1:1, 2:3, 3:4, 9:16, and 9:21, for a total of nine aspect ratios.' },
                    { q: 'What tool can I use to create fast photographic, digital art or anime drafts?', a: 'Flux Schnell supports Auto, Photographic, Digital Art, and Anime for fast prompt testing, photo-real imagery, digital illustration, and anime visuals.' },
                    { q: 'How do I use the FLUX.1 AI image generator online?', a: 'Enter a text prompt, choose Flux Pro 1.1 Ultra or Flux Schnell, and set an aspect ratio. With Schnell, you can also select a visual style before clicking Generate.' },
                    { q: 'How to fix FLUX.1 images that do not match my prompt?', a: 'Describe the subject, setting, composition, lighting, camera, materials, color palette, and target style more explicitly. Use the FLUX.1 prompt examples on this page as a starting point and adapt them to your project.' },
                    { q: 'FLUX.1 vs FLUX.2: which should I use?', a: 'Choose FLUX.1 for polished output with Flux Pro 1.1 Ultra or fast multi-style creation with Flux Schnell. Choose the FLUX.2 page on Miral when you need its Klein, Max, Pro, and Flex variants.' },
                    { q: 'FLUX.1 vs Midjourney: which should I use?', a: 'FLUX.1 is a strong fit for explicit aspect ratios, the fast Schnell workflow, or polished Pro 1.1 Ultra output. Midjourney may suit users who prefer its artistic styles, reference-image workflow, and creative process.' }
                ],
                ctaTitle: 'Use FLUX.1 for Free on Miral!',
                ctaDesc: 'Sign up to receive free credits. Choose Flux Pro 1.1 Ultra or Flux Schnell and create images with the ratio and style your project needs.'
            },
            flux2: {
                title: 'FLUX.2 - AI Image Generator - Miral',
                description: 'Generate professional-quality AI images with FLUX.2 model — 5 variants for speed, quality, and control.'
            },
            zimageturbo: {
                title: 'Z Image Turbo - AI Image Generator - Miral',
                description: 'Generate high-resolution images with the Z Image Turbo model.'
            }
        },
        tools: {
            title: 'AI Image Tools - Miral',
            description: 'Miral provides various AI image processing tools including watermark removal, background removal, image enhancement, and more.',
            watermarkRemover: {
                title: 'Free AI Watermark Remover Online | Miral',
                description: 'Remove watermarks, logos, timestamps, text, and draft marks from photos online with AI. Preserve image details and export clean JPG, PNG, or WebP results.'
            },
            backgroundRemover: {
                title: 'Free AI Background Remover Online - Transparent PNG | Miral',
                description: 'Remove image backgrounds online for free with AI. Create clean portrait and product cutouts, preserve hair and fine edges, and download a transparent PNG from JPG, PNG, or WebP files.'
            },
            imageEraser: {
                title: 'AI Image Eraser - Remove Objects from Photos',
                description: 'Erase unwanted objects, people, watermarks, and text from photos with AI. Brush over the area and the AI seamlessly removes it, filling the gap with natural content. Perfect for cleaning up images.'
            },
            objectRemover: {
                title: 'AI Object Remover Online - Remove Objects from Photos | Miral',
                description: 'Remove unwanted objects, people, signs, wires, and background distractions from photos online. Brush over an area and let AI rebuild a clean, natural background.'
            },
            aiPersonRemover: {
                title: 'AI People Remover - Remove People from Photos',
                description: 'Remove people from photos with AI. Brush over any person and the AI seamlessly erases them, filling the area with natural content. Perfect for removing passersby and strangers from your shots.'
            },
            'whiteBackground': {
                title: 'AI White Background - Replace Image Background with White',
                description: 'Replace image backgrounds with pure white automatically using AI. Ideal for e-commerce product photos, ID pictures, and catalog images.'
            },
            'blueBackground': {
                title: 'AI Blue Background - Replace Image Background with Blue',
                description: 'Replace image backgrounds with pure blue automatically using AI. Ideal for passport photos, ID pictures, and official documents.'
            },
            faceSwap: {
                title: 'Photo Face Swap Online - Swap Faces Between Photos | Miral',
                description: 'Swap a face between two photos online with AI. Upload a target photo and a clear source face to create a natural-looking face replacement for portraits and creative edits.'
            },
            imageEnhancer: {
                title: 'AI Image Enhancer - Upscale & Enhance Photos',
                description: 'Enhance and upscale images with AI. Sharpen details, fix blurriness, boost resolution, and restore old photos for high-quality, professional results.'
            },
            docCropEnhance: {
                title: 'AI Document Crop and Correction Online | Miral',
                description: 'Crop and correct documents, test papers, homework, and textbook photos online. Fix skew, perspective, curved pages, and shadows for clear, sharp scans.'
            },
            handwrittenErase: {
                title: 'Free AI Handwriting Remover for Test Papers | Miral',
                description: 'Remove handwritten answers from test papers, homework, and workbooks online while preserving printed questions. Rotate, crop, and dewarp document scans.'
            }
        },
        imageModels: {
            title: 'AI Image Models - Miral',
            description: 'Explore top AI image models on Miral and generate stunning images from text prompts.',
            relatedModelsTitle: 'Explore More AI Image Models',
            demoPrompt: 'Text Prompt',
            demoOutput: 'Generated Image',
            demoPlaceholder: 'Sample image — coming soon',
            promptLabel: 'Create with',
            usePrompt: 'Use this prompt →',
            imagePlaceholder: 'Example AI Image',
            replaceImageHint: 'Generated from the prompt shown beside this image',
            flux1: {
                title: 'FLUX.1 AI Image Generator Free Online | Miral',
                description: 'Create high-quality AI images online with FLUX.1 using Flux Pro 1.1 Ultra or Flux Schnell. Explore nine aspect ratios, visual styles, and free credits.',
                heroHeadline: 'FLUX.1 AI Image Generator',
                heroIntro: 'Use the FLUX.1 AI image generator from Black Forest Labs for free on Miral AI. Sign up to receive free credits and choose between the high-quality output of Flux Pro 1.1 Ultra and the fast, multi-style creation of Flux Schnell.',
                eyebrow: 'Black Forest Labs · FLUX.1',
                sectionKicker: 'FLUX.1',
                ctaTag: 'FLUX.1 · Miral',
                badges: ['Text to Image', '9 Aspect Ratios', 'Pro and Schnell', 'Photographic / Digital Art / Anime'],
                previewLabel: 'Flux Pro 1.1 Ultra',
                previewMeta: ['1:1', '16:9', '9:16', '9 Ratios'],
                previewTitle: 'Choose between polished quality and fast creative exploration',
                previewDesc: 'Use Pro 1.1 Ultra for detailed visuals or Schnell to explore photographic, digital art, and anime directions quickly.',
                keyFeaturesTitle: 'Create High-Quality Visuals with the FLUX.1 Text to Image Generator',
                keyFeaturesIntro: 'Explore Flux Pro 1.1 Ultra and Flux Schnell features for prompt understanding, output speed, visual styles, and flexible aspect ratios.',
                exploreTitle: 'Explore More AI Image Models',
                mainFeaturesTitle: 'Key FLUX.1 Features',
                generatedImageLabel: 'Generated Image',
                versionLabel: 'Version',
                featureLabel: 'Key Features',
                useCaseLabel: 'Best For',
                controlsTitle: 'Choose the Right Model, Ratio, and Visual Style',
                controlsIntro: 'Use Flux Pro 1.1 Ultra for polished final images or Flux Schnell for faster exploration, then match the aspect ratio and style to the intended channel.',
                galleryTitle: 'More FLUX.1 Image Examples',
                discussionTitle: 'Common FLUX.1 Selection Questions',
                communityTitle: 'Popular Ways to Create with FLUX.1',
                tutorialPrompt: 'A quiet glasshouse bookstore beside the sea at sunrise, warm reading lamps, pale oak shelves, soft reflections on the floor, realistic interior photography.',
                qualityBenefits: [
                    'Render materials, lighting, and spatial depth with a more polished finish.',
                    'Follow detailed prompts that combine subject, composition, camera, and style.',
                    'Explore photographic, digital art, and anime directions from clear text instructions.'
                ],
                features: [
                    { name: 'High-Quality FLUX.1 Text to Image', short: 'Turn written prompts into detailed, professional visuals.', desc: 'Flux Pro 1.1 Ultra is suited to work where image detail, materials, lighting, and overall finish matter. Clearly describing the subject, composition, camera, and style helps steer the image toward your project direction.', demo: { type: 'table', rows: [
                        { prompt: 'Boutique desert hotel exterior at blue hour, rammed earth walls, warm window glow, native grasses, long shadows, realistic architectural photography.', image: require('@/assets/images/flux1/b9d1e267-bb35-4d5c-a196-fae49460749d.webp') },
                        { prompt: 'Editorial food photography of handmade ravioli on a matte black plate, basil oil, linen napkin, directional window light, shallow depth of field.', image: require('@/assets/images/flux1/2ab9dde4-0420-4594-b875-a8465741b767.webp') }
                    ] } },
                    { name: 'Fast Generation with Flux Schnell', short: 'Create quick drafts, test prompts, and explore ideas rapidly.', desc: 'Flux Schnell is a strong fit for workflows that need fast composition, style, or concept testing. Generate a draft, review the direction, then refine the prompt for another iteration.', prompt: 'A modular cardboard trade show booth concept for an eco startup, simple product plinths, recycled paper textures, bright exhibition lighting, clean layout.', image: require('@/assets/images/flux1/b8ffe8cb-1d2f-4bfc-897f-1068861614f9.webp') },
                    { name: 'Nine Image Aspect Ratios', short: 'Cover ultra-wide, landscape, square, portrait, and tall formats.', desc: 'Flux Pro 1.1 Ultra and Flux Schnell both support 21:9, 16:9, 4:3, 3:2, 1:1, 2:3, 3:4, 9:16, and 9:21 for banners, product images, social content, posters, and mobile visuals.', prompt: 'A 21:9 panoramic alpine observatory above a sea of clouds, glass viewing deck, early morning light, tiny hikers for scale, cinematic matte painting.', image: require('@/assets/images/flux1/a5efd8d2-571d-406d-9a01-f30581d4ea3b.webp') },
                    { name: 'Multiple Visual Styles in Schnell', short: 'Choose Auto, Photographic, Digital Art, or Anime.', desc: 'Flux Schnell offers Auto, Photographic, Digital Art, and Anime style directions, making it easy to switch between photo-real, illustrated, and anime visuals without changing models.', demo: { type: 'table', rows: [
                        { prompt: 'Photographic style: a bicycle mechanic adjusting a vintage racing bike in a sunlit garage, grease-stained hands, realistic chrome reflections.', image: require('@/assets/images/flux1/2b870b40-a436-42b9-980f-538e303cdfce.webp') },
                        { prompt: 'Anime style: a cozy cat cafe inside a sky train, pastel sunset clouds outside the windows, expressive characters, clean line art.', image: require('@/assets/images/flux1/faded76c-4da1-49bb-98dc-10b8276f7da8.webp') }
                    ] } },
                    { name: 'Flexible Creative Use Cases', short: 'Create product, marketing, portrait, concept, and social visuals.', desc: 'The FLUX.1 family supports polished product and brand imagery as well as fast campaign concepts, portraits, environment designs, and platform-specific aspect ratios.', prompt: 'Sustainable sneaker launch visual with recycled fabric texture, floating lace details, moss-green gradient background, bold empty space for social ad copy.', image: require('@/assets/images/flux1/0dfa0b4b-7722-40f4-9bc0-7bbf9bb1c000.webp') }
                ],
                showcaseKicker: 'Prompt examples',
                showcaseTitle: 'FLUX.1 Prompt Examples for Better AI Images',
                showcaseIntro: 'Use these FLUX.1 prompts as a starting point. Clearly describe the subject, composition, lighting, camera, materials, color palette, and visual style.',
                variantsKicker: 'Model guide',
                variantsTitle: 'Flux Pro 1.1 Ultra vs Flux Schnell',
                variantsIntro: 'Choose a FLUX.1 model based on the quality, speed, and style control your project needs.',
                variants: [
                    { name: 'Flux Pro 1.1 Ultra', tag: 'High Quality', desc: 'Designed for detailed, realistic, polished text-to-image work with nine supported aspect ratios.', bestFor: 'Best for product photography, campaign hero images, and polished final visuals' },
                    { name: 'Flux Schnell', tag: 'Fast', desc: 'Designed for rapid iteration with nine aspect ratios and Auto, Photographic, Digital Art, and Anime styles.', bestFor: 'Best for drafts, prompt testing, social content, and fast exploration' }
                ],
                useCasesKicker: 'Made for real work',
                useCasesTitle: 'Popular FLUX.1 Use Cases',
                useCases: [
                    { name: 'FLUX.1 for Product Photography', desc: 'Create product hero images, lifestyle scenes, and e-commerce visual concepts.' },
                    { name: 'FLUX.1 for Marketing and Advertising', desc: 'Generate social ads, campaign banners, and branded marketing visuals.' },
                    { name: 'FLUX.1 for Photorealistic Portraits', desc: 'Create photo-like portraits with controlled lighting, backgrounds, and composition.' },
                    { name: 'FLUX.1 for Digital Art', desc: 'Use Schnell to explore illustration, fantasy, and digital art directions quickly.' },
                    { name: 'FLUX.1 for Anime Images', desc: 'Use the Schnell Anime style for characters and anime scenes.' },
                    { name: 'FLUX.1 for Concept Art', desc: 'Explore cinematic environments, game scenes, characters, and visual worlds.' },
                    { name: 'FLUX.1 for Social Media Images', desc: 'Use nine aspect ratios for landscape, square, and portrait platform content.' },
                    { name: 'FLUX.1 for Posters and Banners', desc: 'Choose a suitable ratio for events, promotions, and mobile page layout concepts.' }
                ],
                howToKicker: 'Three simple steps',
                howToTitle: 'How to Use the FLUX.1 AI Image Generator Online for Free',
                howToIntro: 'Sign up to receive free credits and use Flux Pro 1.1 Ultra or Flux Schnell online on Miral.',
                howToSteps: [
                    { title: 'Enter a Detailed Prompt', desc: 'Describe the subject, setting, composition, lighting, camera, materials, colors, and target style.' },
                    { title: 'Choose Model and Ratio', desc: 'Pick Pro 1.1 Ultra for polished quality or Schnell for fast exploration, then set an aspect ratio and Schnell style.' },
                    { title: 'Generate and Refine', desc: 'Generate the image, review and download it, or adjust the prompt, ratio, or style for another version.' }
                ],
                howToCta: 'Use FLUX.1 AI Image Generator for Free',
                faqTitle: 'Frequently Asked Questions About FLUX.1',
                faqs: [
                    { q: 'What is the FLUX.1 AI image generator?', a: 'FLUX.1 is an image generation model family from Black Forest Labs. On Miral, use Flux Pro 1.1 Ultra and Flux Schnell to turn text prompts into product, marketing, portrait, anime, and concept art images.' },
                    { q: 'Can I use the FLUX.1 AI image generator for free?', a: 'Yes. Sign up to receive free credits and start creating high-quality images with the FLUX.1 AI image generator immediately. Generating images uses the corresponding credits.' },
                    { q: 'What is the difference between Flux Pro 1.1 Ultra and Flux Schnell?', a: 'Flux Pro 1.1 Ultra is suited to polished final images where detail and finish matter. Flux Schnell is suited to fast drafts, prompt testing, and multi-style exploration, with Auto, Photographic, Digital Art, and Anime styles.' },
                    { q: 'What image aspect ratios does FLUX.1 support?', a: 'Flux Pro 1.1 Ultra and Flux Schnell on Miral support 21:9, 16:9, 4:3, 3:2, 1:1, 2:3, 3:4, 9:16, and 9:21, for a total of nine aspect ratios.' },
                    { q: 'What styles does Flux Schnell support?', a: 'Flux Schnell supports Auto, Photographic, Digital Art, and Anime for automatic matching, photo-real imagery, digital illustration, and anime visuals.' },
                    { q: 'How do I use the FLUX.1 AI image generator online?', a: 'Enter a text prompt, choose Flux Pro 1.1 Ultra or Flux Schnell, and set an aspect ratio. With Schnell, you can also select a visual style before clicking Generate.' },
                    { q: 'What are the best FLUX.1 prompt examples?', a: 'Effective FLUX.1 prompts clearly describe the subject, setting, composition, lighting, camera, materials, color palette, and target style. Use the examples on this page as a starting point and adapt them to your project.' },
                    { q: 'FLUX.1 vs FLUX.2: which should I use?', a: 'Choose FLUX.1 for polished output with Flux Pro 1.1 Ultra or fast multi-style creation with Flux Schnell. Choose the FLUX.2 page on Miral when you need its Klein, Max, Pro, and Flex variants.' },
                    { q: 'FLUX.1 vs Midjourney: which should I use?', a: 'FLUX.1 is a strong fit for explicit aspect ratios, the fast Schnell workflow, or polished Pro 1.1 Ultra output. Midjourney may suit users who prefer its artistic styles, reference-image workflow, and creative process.' }
                ],
                ctaTitle: 'Use FLUX.1 for Free on Miral!',
                ctaDesc: 'Sign up to receive free credits. Choose Flux Pro 1.1 Ultra or Flux Schnell and create images with the ratio and style your project needs.'
            },
            flux2: {
                title: 'FLUX.2 AI Image Generator Free Online | Miral',
                description: 'Create photorealistic AI images online with FLUX.2. Choose five model variants for product photos, posters, artwork, and polished marketing visuals.',
                heroHeadline: 'FLUX.2 AI Image Generator',
                heroIntro: 'Use the FLUX.2 AI image generator from Black Forest Labs for free on Miral AI. Sign up to receive free credits and instantly create high-quality photorealistic images, product photography, posters, and marketing visuals.',
                eyebrow: 'Black Forest Labs · FLUX.2',
                sectionKicker: 'FLUX.2',
                ctaTag: 'FLUX.2 · Miral',
                badges: ['Text to Image', 'Photorealistic', 'Precise Typography', 'Multiple Aspect Ratios'],
                previewLabel: 'FLUX.2',
                previewMeta: ['1:1', '1024 × 1024', 'PNG'],
                previewTitle: 'From a precise prompt to a production-ready visual',
                previewDesc: 'Create detailed product shots, campaign concepts, portraits, and text-rich designs in one streamlined workflow.',
                keyFeaturesTitle: 'Create Professional Visuals with the FLUX.2 Text to Image Generator',
                keyFeaturesIntro: 'Explore the key FLUX.2 AI image generator features for accurate prompts, polished detail, realistic output, and dependable visual control.',
                exploreTitle: 'Explore More AI Image Models',
                mainFeaturesTitle: 'Key FLUX.2 Features',
                generatedImageLabel: 'Generated Image',
                versionLabel: 'Version',
                featureLabel: 'Key Features',
                useCaseLabel: 'Best For',
                controlsTitle: 'Choose the Right FLUX.2 Version and Output Settings',
                controlsIntro: 'Use Klein for rapid iteration, Max for the strongest final quality, Pro for production workflows, or Flex for typography and fine detail control.',
                galleryTitle: 'More FLUX.2 Image Examples',
                discussionTitle: 'Common FLUX.2 Model Questions',
                communityTitle: 'Popular Ways to Create with FLUX.2',
                tutorialPrompt: 'Premium campaign photograph of a translucent emerald perfume bottle on pale limestone, soft morning light, realistic glass refraction, refined typography, generous negative space.',
                qualityBenefits: [
                    'Follow detailed prompts with stronger control over subject, composition, lighting, and style.',
                    'Create realistic textures, depth, and polished detail for professional visual work.',
                    'Handle text-rich posters, product labels, and campaign graphics with clearer typography.'
                ],
                features: [
                    { name: 'High-End Image Synthesis', short: 'Delivers enhanced prompt adherence and image quality without added latency.', desc: 'FLUX.2 greatly enhances prompt alignment and even supports long-form inputs like detailed scripts and scene descriptions. It ensures generated images offer greater fidelity without compromising on speed, which reduces the need for iterative adjustments and lets creators reach a finished result faster.', demo: { type: 'table', rows: [
                        { prompt: 'A stunning landscape with vibrant colors and intricate details, showcasing a sunset over a mountain range.',image: require('@/assets/images/flux2/1a2627bd-61e0-406a-9308-19f2883d004e.webp') },
                        { prompt: 'Abstract art for translating between functional languages and low-level languages.' ,image: require('@/assets/images/flux2/sample.webp')},
                        { prompt: 'An anime/cartoony character headshot, detailed and well-made yet looks human-made.' ,image: require('@/assets/images/flux2/57047990-2e26-4b44-bacf-f10bca5ee70d.webp')}
                    ] } },
                    { name: 'Superior Detail & Realism', short: 'Produces lifelike textures, lighting, and depth for studio-grade visuals.', desc: 'FLUX.2 captures fine textures, realistic lighting, and natural depth that make generated images look genuinely photographic. This makes it a strong fit for product shots, portraits, and cinematic visuals where believability matters most.', prompt: 'Studio product photograph of a silver mechanical watch on dark slate, soft side lighting, realistic brushed metal texture, shallow depth of field, subtle reflections, premium editorial composition.' ,image: require('@/assets/images/flux2/b1d818f0-ff1f-4612-b586-62f75e14466c.webp') },
                    { name: 'Strong Prompt Adherence', short: 'Follows complex prompts closely, including specific subjects, styles, and composition.', desc: 'FLUX.2 interprets layered, multi-part prompts with impressive accuracy — handling specific subjects, art styles, color palettes, and compositional instructions in a single generation. This gives creators more control and fewer re-rolls when describing exactly what they want.', prompt: 'A red tram crossing a rainy European square at dusk, three cyclists in the foreground, warm cafe windows on the left, blue hour sky, symmetrical composition, cinematic photography.',image: require('@/assets/images/flux2/2026b767-edcb-4441-b70e-a6d94ae6ebb9.webp') },
                    { name: 'Advanced Typography Handling', short: 'Renders text within images with cleaner spelling and style consistency.', desc: 'FLUX.2 offers improved text generation and control across images, with more accurate font-style consistency. This makes it possible to produce text-based materials and signage for posters, advertisements, comics, and brand graphics with far fewer artifacts.', demo: { type: 'table', rows: [
                        { prompt: 'A beautiful mystical landscape photo with the text "FLUX 2", subtle beauty, incorporate blueberries.' ,image: require('@/assets/images/flux2/c2f47f20-00b4-4cec-b972-e7a69d40be56.webp') },
                        { prompt: 'A black forest gateau cake spelling out the words "FLUX 2 Pro", tasty, food photography.' ,image: require('@/assets/images/flux2/2258b023-29ba-433f-b909-88f542adc3b9.webp') }
                    ] } },
                    { name: 'Fast & Scalable Generation', short: 'Choose from sub-second iteration to maximum-quality output.', desc: 'FLUX.2 spans fast Klein models and production-focused Pro, Max, and Flex variants. This range makes it practical for rapid drafts, batch content production, and final-quality marketing or creative assets.', prompt: 'A clean editorial product photo of a translucent green perfume bottle on limestone, soft morning light, subtle shadows, premium campaign aesthetic.' ,image: require('@/assets/images/flux2/2a4b147b-31c2-4ded-a626-d7e209fb751b.webp')}
                ],
                showcaseKicker: 'Prompt examples',
                showcaseTitle: 'FLUX.2 Prompt Examples for Better AI Images',
                showcaseIntro: 'Use these FLUX.2 prompt examples as a starting point, customize the subject, composition, lighting, and style, then send your prompt directly to the generator.',
                variantsKicker: 'Model guide',
                variantsTitle: 'FLUX.2 Model Comparison: Klein vs Max vs Pro vs Flex',
                variantsIntro: 'Compare FLUX.2 Klein, Max, Pro, and Flex to choose the right AI image model for rapid iteration, final-quality assets, production scale, or fine typography control.',
                variants: [
                    { name: 'FLUX.2 Klein 4B / 9B', tag: 'Fastest', desc: 'Choose FLUX.2 Klein for fast, high-volume image generation, drafts, and rapid prototyping.', bestFor: 'Best for drafts, batches, and quick iteration' },
                    { name: 'FLUX.2 Max', tag: 'Highest quality', desc: 'Choose FLUX.2 Max for final assets, the strongest prompt following, and grounded generation.', bestFor: 'Best for premium campaigns and hero images' },
                    { name: 'FLUX.2 Pro', tag: 'Production', desc: 'Choose FLUX.2 Pro for a production-grade balance of image quality, turnaround time, and scalable output.', bestFor: 'Best for marketing and content production' },
                    { name: 'FLUX.2 Flex', tag: 'Control', desc: 'Choose FLUX.2 Flex for adjustable guidance, typography, text rendering, and preservation of small details.', bestFor: 'Best for posters, labels, and design assets' }
                ],
                useCasesKicker: 'Made for real work',
                useCasesTitle: 'Popular FLUX.2 Use Cases',
                useCases: [
                    { name: 'FLUX.2 for Product Photography', desc: 'Create polished product shots, lifestyle scenes, and e-commerce image variations.' },
                    { name: 'FLUX.2 for Marketing & Advertising', desc: 'Turn campaign concepts into social ads, banners, and consistent brand visuals.' },
                    { name: 'FLUX.2 for Posters & Typography', desc: 'Use FLUX.2 text rendering to produce clearer headlines, labels, posters, and text-based graphics.' },
                    { name: 'FLUX.2 for Photorealistic Portraits', desc: 'Generate detailed AI portraits with controlled lighting, styling, and composition.' },
                    { name: 'FLUX.2 for Concept Art', desc: 'Explore cinematic environments, characters, and visual directions quickly.' },
                    { name: 'FLUX.2 for Editorial Design', desc: 'Create distinctive illustrations and covers for articles and presentations.' }
                ],
                howToKicker: 'Three simple steps',
                howToTitle: 'How to Use the FLUX.2 AI Image Generator Online',
                howToIntro: 'Use the FLUX.2 AI image generator online on Miral to move from a detailed text prompt to a generated image.',
                howToSteps: [
                    { title: 'Enter Your Prompt', desc: 'Describe the subject, composition, lighting, colors, style, and any text you want to appear in the image.' },
                    { title: 'Choose FLUX.2 Settings', desc: 'Open the generator, select Klein, Max, Pro, or Flex, then choose the output size that fits your project.' },
                    { title: 'Generate Your Image', desc: 'Start generation, review the result, and download the image or refine your prompt for another version.' }
                ],
                howToCta: 'Try FLUX.2 AI Image Generator',
                faqTitle: 'Frequently Asked Questions About FLUX.2',
                faqs: [
                    { q: 'What is FLUX.2?', a: 'FLUX.2 is Black Forest Labs\' next-generation text-to-image AI model. It turns written prompts into high-quality, detailed images and is available on Miral for art, design, marketing, and product visual creation directly in your browser.' },
                    { q: 'What tool can I use to create product photography and text-rich marketing visuals?', a: 'FLUX.2 combines prompt coherence, detail, photorealism, and typography handling for professional product photography and text-rich marketing visuals that demand fidelity and accuracy.' },
                    { q: 'Can I use the FLUX.2 AI image generator for free?', a: 'Yes. Sign up to receive free credits and start creating high-quality images with the FLUX.2 AI image generator immediately. Generating images uses the corresponding credits.' },
                    { q: 'How do I use the FLUX.2 AI image generator online?', a: 'Enter a detailed text prompt, choose FLUX.2 Klein, Max, Pro, or Flex, select an image size, and click Generate. FLUX.2 works well for marketing materials, product photography, cinematic concepts, social creatives, and poster designs.' },
                    { q: 'How long does FLUX.2 take to generate?', a: 'Generation time depends on the selected FLUX.2 variant, image size, and current service load. Klein is designed for very fast iteration, while Max, Pro, and Flex prioritize different balances of quality and control.' },
                    { q: 'How to fix a FLUX.2 image that does not follow my prompt?', a: 'Describe the subject, setting, composition, lighting, camera or art style, colors, and any required text more explicitly. Use the FLUX.2 prompt examples on this page as a starting point and customize them for your project.' },
                    { q: 'Which FLUX.2 model should I choose?', a: 'Choose FLUX.2 Klein for rapid drafts and batches, Max for the highest-quality final assets, Pro for production-scale image generation, or Flex when typography and fine control matter most.' },
                    { q: 'FLUX.2 Max vs Pro: what is the difference?', a: 'FLUX.2 Max prioritizes maximum quality, strong prompt following, and grounded generation. FLUX.2 Pro balances production-grade quality, faster turnaround, and scalable output for everyday creative workflows.' },
                    { q: 'FLUX.2 vs Midjourney: which should I use?', a: 'Choose based on workflow rather than a universal winner. FLUX.2 is a strong fit for precise prompt following, typography, product visuals, and API-based production. Midjourney may suit creators who prefer its distinctive artistic workflow and community tools.' }
                ],
                ctaTitle: 'Try FLUX.2 for Free on Miral!',
                ctaDesc: 'Enter your idea above and use the FLUX.2 AI image generator to create detailed images with the model variant that fits your workflow.'
            },
            seedream: {
                title: 'Seedream AI Image Generator Free Online | Miral',
                description: 'Generate high-quality AI images online with Seedream. Get precise prompt understanding, clear text rendering, and detailed 2K-4K output for creative projects.',
                heroHeadline: 'Seedream AI Image Generator',
                heroIntro: 'Use the Seedream AI image generator for free. Sign up to receive free credits and instantly create high-quality product visuals, posters, portraits, and marketing images.',
                eyebrow: 'ByteDance Seed · Seedream AI',
                sectionKicker: 'Seedream AI',
                ctaTag: 'Seedream · Miral',
                badges: ['Text to Image', 'Intent Understanding', '2K / 3K / 4K Output', 'Clear Text Rendering'],
                previewLabel: 'Seedream AI',
                previewMeta: ['1:1', '2K / 3K / 4K', 'Custom Size'],
                previewTitle: 'From creative intent to a precise, high-resolution visual',
                previewDesc: 'Create complex compositions, product shots, portraits, and text-rich designs with refined detail and dependable prompt control.',
                keyFeaturesTitle: 'Create Precise Visuals with the Seedream AI Text to Image Generator',
                keyFeaturesIntro: 'Explore Seedream AI features for deeper intent understanding, complex composition, high-resolution output, realistic detail, and accurate text rendering through text-to-image generation.',
                exploreTitle: 'Explore Seedream AI Models',
                mainFeaturesTitle: 'Key Seedream AI Text-to-Image Features',
                seedream5Desc: 'Use the latest Seedream model for precise prompts, refined realism, text rendering, and high-resolution output.',
                seedream4Desc: 'Open the established Seedream 4 workflow for dependable text-to-image creation and flexible output settings.',
                features: [
                    { name: 'Deeper Prompt Understanding', short: 'Interprets creative intent, spatial relationships, and detailed instructions.', desc: 'Seedream AI goes beyond matching isolated prompt terms. It reasons about the relationships between subjects, layout, attributes, and visual context to produce more coherent results from complex text instructions.', demo: { type: 'table', rows: [
                        { prompt: 'A 3x3 display shelf, front view, with nine different objects arranged by material and color, consistent studio lighting and accurate spatial alignment.', image: require('@/assets/images/seedream/0217834949526105a9f949eb72c2227dac5c405ca3d9cd6c996b9_0.webp') },
                        { prompt: 'Editorial product photo of a watch beside folded linen and a ceramic cup, balanced triangular composition, soft morning light.', image: require('@/assets/images/seedream/021783495149924e4fd4c285bd49f804239cddc30345c48dc6024_0.webp') },
                        { prompt: 'A cinematic market scene with foreground shoppers, a clear central subject, layered depth, and warm light reflected on wet pavement.', image: require('@/assets/images/seedream/994ae318-58d7-4ffa-98e1-ea97553ff0c0.webp') }
                    ] } },
                    { name: 'Complex Composition Control', short: 'Handles multiple subjects, attributes, and structured layouts with greater coherence.', desc: 'The Seedream AI image generator follows multi-part instructions across complex scenes, helping preserve requested object attributes, positions, colors, and relationships in a single composition.', prompt: 'A front-facing editorial scene with three ceramic vases in different shapes on staggered stone platforms, a red sphere behind the tallest vase, soft side lighting, balanced spacing, neutral studio background.', image: require('@/assets/images/seedream/021783495389730ffa263910bfaab0198f27d0234753c494fd2fa_0.webp') },
                    { name: '2K, 3K, and 4K Output', short: 'Select an output resolution based on the detail and dimensions your project needs.', desc: 'Seedream AI supports selectable 2K, 3K, and 4K output on Miral, plus custom image sizes. Choose based on the dimensions and level of detail required for your final use.', prompt: 'A wide cinematic landscape of a futuristic coastal city at sunrise, layered architecture, reflective water, atmospheric depth, intricate building details, panoramic composition.', image: require('@/assets/images/seedream/0217834956211361c17ef9c173e8babb4a0658490f0169e937059_0.webp') },
                    { name: 'Improved Text Rendering', short: 'Creates clearer text for posters, layouts, labels, and presentation graphics.', desc: 'Seedream AI combines visual reasoning with improved text creation, making it useful for posters, presentation graphics, advertisements, packaging concepts, and other layouts where readable text is part of the image.', demo: { type: 'table', rows: [
                        { prompt: 'Minimalist event poster with the headline "DESIGN FOR TOMORROW", bold geometric type, white background, green accent grid.', image: require('@/assets/images/seedream/0217834957232579f663fff68d336b1dca042ed755c42d2babd5a_0.webp') },
                        { prompt: 'Premium coffee package labeled "MIRAL ROAST", concise tasting notes, warm paper texture, studio product photography.', image: require('@/assets/images/seedream/021783495813482572fdc12977fa128088f145c73a50ff1524591_0.webp') }
                    ] } },
                    { name: 'Refined Detail and Realism', short: 'Produces convincing lighting, materials, depth, and product presentation.', desc: 'Seedream AI renders refined textures and coherent lighting for product photography, portraits, editorial visuals, and cinematic concepts where clarity and believable structure matter.', prompt: 'A clean editorial product photo of a translucent green perfume bottle on limestone, soft morning light, subtle shadows, premium campaign aesthetic.', image: require('@/assets/images/seedream/021783495894855ad8f78454eef31552c89ebf2f2559e7d2d47a0_0.webp') }
                ],
                showcaseKicker: 'Prompt examples',
                showcaseTitle: 'Seedream AI Prompt Examples for Better AI Images',
                showcaseIntro: 'Use these Seedream AI prompt examples as a starting point. Describe subjects, spatial relationships, text, lighting, and layout clearly, then send the prompt directly to the generator.',
                variantsKicker: 'Resolution guide',
                variantsTitle: 'Seedream AI Resolution Guide: 2K vs 3K vs 4K',
                variantsIntro: 'Choose a Seedream AI output resolution based on how quickly you want to iterate and how much detail the final asset requires.',
                variants: [
                    { name: '2K', tag: 'Standard output', desc: 'A practical resolution for social content, everyday creative work, and standard digital layouts.', bestFor: 'Best for regular digital content' },
                    { name: '3K', tag: 'More detail', desc: 'Adds more image detail and supports larger layouts for marketing and presentation work.', bestFor: 'Best for marketing and presentation assets' },
                    { name: '4K', tag: 'Maximum detail', desc: 'Use the highest preset when fine textures, text-heavy layouts, or premium delivery quality matter.', bestFor: 'Best for final campaigns and high-resolution output' }
                ],
                useCasesKicker: 'Made for real work',
                useCasesTitle: 'Popular Seedream AI Use Cases',
                useCases: [
                    { name: 'Seedream AI for Product Photography', desc: 'Create polished product shots, lifestyle scenes, and e-commerce image concepts.' },
                    { name: 'Seedream AI for Marketing', desc: 'Turn structured campaign ideas into social ads, banners, and brand visuals.' },
                    { name: 'Seedream AI for Posters and Text', desc: 'Produce poster concepts, presentation graphics, labels, and text-based layouts.' },
                    { name: 'Seedream AI for Complex Compositions', desc: 'Arrange multiple subjects and requested attributes in a coherent visual structure.' },
                    { name: 'Seedream AI for Concept Art', desc: 'Explore cinematic environments, characters, and detailed visual directions.' },
                    { name: 'Seedream AI for Editorial Visuals', desc: 'Create covers, illustrations, infographics, and presentation-ready imagery.' }
                ],
                howToKicker: 'Three simple steps',
                howToTitle: 'How to Use the Seedream AI Image Generator Online for Free',
                howToIntro: 'Sign up to receive free credits and use the Seedream AI image generator online with a clear prompt and the resolution required by your project.',
                howToSteps: [
                    { title: 'Enter Your Creative Intent', desc: 'Describe the subjects, spatial relationships, composition, lighting, style, and required text as clearly as possible.' },
                    { title: 'Choose Resolution and Size', desc: 'Open the generator and select 2K, 3K, 4K, or a supported custom size based on your final use.' },
                    { title: 'Generate and Review', desc: 'Start generation, review the composition and details, then download the result or adjust your prompt.' }
                ],
                howToCta: 'Use Seedream AI Image Generator for Free',
                faqTitle: 'Frequently Asked Questions About Seedream AI',
                faqs: [
                    { q: 'What is the Seedream AI image generator?', a: 'Seedream AI is an intelligent image creation model from ByteDance\'s Seed team. On Miral, it turns detailed text prompts into high-resolution images for design, marketing, product concepts, posters, and editorial visuals.' },
                    { q: 'What tool can I use to create high-resolution posters with clear text?', a: 'Seedream AI combines deeper intent understanding, precise composition, improved text creation, and selectable high-resolution output for posters and other text-rich layouts.' },
                    { q: 'Can I use the Seedream AI image generator for free?', a: 'Yes. Sign up to receive free credits and start creating high-quality images with the Seedream AI image generator immediately. Generating images uses the corresponding credits.' },
                    { q: 'How do I use the Seedream AI image generator online?', a: 'Enter a detailed text prompt, choose 2K, 3K, or 4K output, optionally select a custom size, and click Generate. For better results, describe the subjects, spatial relationships, attributes, lighting, text, and layout clearly.' },
                    { q: 'Does Seedream AI support 2K, 3K, and 4K images?', a: 'Yes. Miral exposes 2K, 3K, and 4K resolution presets for Seedream AI, along with supported custom dimensions for different aspect ratios and delivery needs.' },
                    { q: 'How to fix Seedream images with incorrect text or composition?', a: 'Describe the subject, relationships between objects, composition, lighting, colors, style, and required text more explicitly. Use the Seedream examples on this page as a starting point and state each visual requirement clearly.' },
                    { q: 'Which Seedream AI resolution should I choose?', a: 'Choose 2K for standard digital content, 3K when marketing or presentation layouts need more detail, and 4K when maximum detail is important for large final campaigns, posters, or premium design assets.' },
                    { q: 'Seedream AI vs Midjourney: which should I use?', a: 'Seedream AI is a strong fit for structured prompts, complex compositions, text-rich layouts, and selectable high-resolution output in Miral. Midjourney may suit creators who prefer its distinctive artistic workflow and community tools.' }
                ],
                ctaTitle: 'Use Seedream AI for Free on Miral!',
                ctaDesc: 'Sign up to receive free credits. Describe your idea, choose the right resolution, and use the Seedream AI image generator to create precise, high-resolution visuals.'
            },
            gptImage: {
                title: 'GPT Image AI Image Generator Free Online | Miral',
                description: 'Generate high-quality AI images online with GPT Image and GPT-Image-1.5 on Miral AI. Choose practical sizes and quality levels for posters, products, and portraits.',
                heroHeadline: 'GPT Image AI Image Generator',
                heroIntro: 'Use the GPT Image AI image generator for free on Miral AI. Sign up to receive free credits and instantly create high-quality product images, posters, portraits, and marketing visuals with GPT-Image-1.5.',
                eyebrow: 'OpenAI · GPT-Image-1.5',
                sectionKicker: 'GPT Image',
                ctaTag: 'GPT Image · Miral',
                badges: ['Text to Image', 'Selectable Quality', 'Landscape / Portrait / Square', 'Precise Prompt Understanding'],
                previewLabel: 'GPT-Image-1.5',
                previewMeta: ['1024 × 1024', '1536 × 1024', '1024 × 1536'],
                previewTitle: 'From a written idea to a polished, practical AI image',
                previewDesc: 'Use clear prompts and selectable quality to create product visuals, posters, portraits, and brand content.',
                keyFeaturesTitle: 'Create High-Quality Visuals with the GPT Image AI Image Generator',
                keyFeaturesIntro: 'Explore GPT-Image-1.5 features for prompt understanding, quality control, practical image sizes, and professional visual creation.',
                features: [
                    { name: 'Natural-Language and Multi-Subject Prompts', short: 'Describe subjects, composition, lighting, style, and visual relationships in natural language.', desc: 'The GPT Image AI image generator supports natural-language prompts with multiple subjects, attributes, and composition requirements. Start with a simple prompt or specify each subject\'s position, color, and relationship to create more coherent multi-subject images.', demo: { type: 'table', rows: [
                        { prompt: 'Editorial product photography of a transparent perfume bottle on a pale stone pedestal, soft morning light from the left, clean background, shallow depth of field, premium brand aesthetic.', image: require('@/assets/images/gptImage/perfume-editorial.webp') },
                        { prompt: 'A rainy city street at night, three foreground pedestrians holding umbrellas in different colors, a tram passing in the distance, neon reflected on wet pavement, cinematic wide composition.', image: require('@/assets/images/gptImage/rainy-city-tram.webp') }
                    ] } },
                    { name: 'GPT-Image-1.5 Quality Control', short: 'Choose Auto, Low, Medium, or High based on speed and detail needs.', desc: 'GPT-Image-1.5 offers auto, low, medium, and high quality settings. Use lower quality for fast exploration and higher quality for final product images, posters, or marketing assets.', prompt: 'High-quality food advertisement of a strawberry cake against a black background, crisp cream texture, soft rim light, detailed food photography, commercial composition.', image: require('@/assets/images/gptImage/strawberry-cake.webp') },
                    { name: 'Three Practical Image Sizes', short: 'Create square, landscape, and portrait output.', desc: 'Choose 1024×1024, 1536×1024, or 1024×1536 for social posts, banners and presentation visuals, or portrait posters and mobile content.', prompt: 'A 1024×1536 portrait travel poster with a seaside cliff and lighthouse in morning mist, space for a headline at the top, modern editorial layout.', image: require('@/assets/images/gptImage/lighthouse-travel-poster.webp') },
                    { name: 'Clear Text and Layout Creation', short: 'Create poster, label, and brand concepts that include text.', desc: 'By stating the required copy, placement, typographic mood, and layout relationships clearly, GPT Image can help explore posters, packaging, event graphics, and marketing images with headlines.', demo: { type: 'table', rows: [
                        { prompt: 'Minimalist technology event poster with the headline "CREATE THE FUTURE", bold sans-serif type, deep blue background, green geometric grid, clear centered headline.', image: require('@/assets/images/gptImage/create-the-future.webp') },
                        { prompt: 'Premium coffee package concept with the text "MIRAL ROAST" on the front, warm brown paper texture, clean label, studio product photography.', image: require('@/assets/images/gptImage/miral-roast-package.webp') }
                    ] } },
                    { name: 'Detail and Realism', short: 'Render believable materials, lighting, people, and product details.', desc: 'GPT Image works well for product photography, portraits, interiors, and editorial visuals when the prompt clearly describes materials, camera choices, lighting, and depth of field.', prompt: 'Close editorial portrait of a ceramic artist in natural window light, realistic skin texture, clay dust on their hands, workshop background, shallow depth of field, warm editorial photography.', image: require('@/assets/images/gptImage/ceramic-artist.webp') }
                ],
                showcaseKicker: 'Prompt examples',
                showcaseTitle: 'GPT Image Prompt Examples for Better AI Images',
                showcaseIntro: 'Use these GPT Image prompts as a starting point. Clearly describe the subject, composition, lighting, style, materials, and any required text.',
                variantsKicker: 'Version guide',
                variantsTitle: 'GPT-Image-1.5 vs GPT-Image-1',
                variantsIntro: 'Choose a GPT Image version based on whether you need quality control. Both support practical square, landscape, and portrait sizes.',
                variants: [
                    { name: 'GPT-Image-1.5', tag: 'Recommended', desc: 'Supports 1024×1024, 1536×1024, and 1024×1536 with auto, low, medium, and high quality options.', bestFor: 'Best for everyday and professional work that needs quality control' },
                    { name: 'GPT-Image-1', tag: 'Classic', desc: 'Supports the same three practical image sizes with a simpler set of controls.', bestFor: 'Best for straightforward, general-purpose text-to-image creation' }
                ],
                useCasesKicker: 'Made for real work',
                useCasesTitle: 'Popular GPT Image Use Cases',
                useCases: [
                    { name: 'GPT Image for Product Photography and Mockups', desc: 'Create product hero images, lifestyle scenes, product mockups, and e-commerce visual concepts.' },
                    { name: 'GPT Image for E-commerce Listing Images', desc: 'Explore product listing images, feature graphics, packaging displays, and advertising concepts.' },
                    { name: 'GPT Image for Marketing and Social Media Ads', desc: 'Create social media ads, campaign banners, email banners, and branded marketing visuals.' },
                    { name: 'GPT Image for UI/UX and Website Layouts', desc: 'Generate visual concepts for app interfaces, website layouts, landing pages, and product showcase pages.' },
                    { name: 'GPT Image for Infographics and Visual Reports', desc: 'Explore layout concepts for infographics, visual reports, and presentation graphics; verify all text and data before final use.' },
                    { name: 'GPT Image for Posters and Product Packaging', desc: 'Explore posters, product labels, and packaging designs with headline and layout requirements.' },
                    { name: 'GPT Image for Book Covers and Blog Images', desc: 'Create book covers, editorial illustrations, blog headers, and publishing visual concepts.' },
                    { name: 'GPT Image for Portraits', desc: 'Create editorial portraits with controlled lighting, backgrounds, and styling.' },
                    { name: 'GPT Image for Game Character Concepts', desc: 'Quickly explore game characters, costumes, props, and different artistic directions.' },
                    { name: 'GPT Image for Game Environments', desc: 'Generate game environments, cinematic scenes, and world-building concepts for early creative exploration.' },
                    { name: 'GPT Image for Social Content', desc: 'Generate square, landscape, and portrait images for different platforms.' }
                ],
                howToKicker: 'Three simple steps',
                howToTitle: 'How to Use the GPT Image AI Image Generator Online for Free',
                howToIntro: 'Sign up to receive free credits and use the GPT Image AI image generator online on Miral.',
                howToSteps: [
                    { title: 'Enter a Detailed Prompt', desc: 'Describe the subject, setting, composition, lighting, style, materials, and any required text.' },
                    { title: 'Choose Size and Quality', desc: 'Choose a square, landscape, or portrait size and set GPT-Image-1.5 quality based on your needs.' },
                    { title: 'Generate and Review', desc: 'Start generation, review and download the image, or adjust the prompt and create another version.' }
                ],
                howToCta: 'Use GPT Image AI Image Generator for Free',
                faqTitle: 'Frequently Asked Questions About GPT Image',
                faqs: [
                    { q: 'What is the GPT Image AI image generator?', a: 'GPT Image is OpenAI\'s general-purpose text-to-image model family. On Miral, the GPT Image AI image generator turns written prompts into high-quality images for design, marketing, product concepts, posters, and social content.' },
                    { q: 'Can I use the GPT Image AI image generator for free?', a: 'Yes. Sign up to receive free credits and start creating high-quality images with the GPT Image AI image generator immediately. Generating images uses the corresponding credits.' },
                    { q: 'How do I use the GPT Image AI image generator online?', a: 'Enter a detailed prompt and choose 1024×1024, 1536×1024, or 1024×1536. With GPT-Image-1.5, you can also select auto, low, medium, or high quality before clicking Generate.' },
                    { q: 'What is the difference between GPT-Image-1.5 and GPT-Image-1?', a: 'Both versions support the same three practical image sizes. GPT-Image-1.5 on Miral also provides auto, low, medium, and high quality control, while GPT-Image-1 has a simpler set of parameters.' },
                    { q: 'What image sizes does GPT Image support?', a: 'On Miral, GPT-Image-1 and GPT-Image-1.5 support 1024×1024 square, 1536×1024 landscape, and 1024×1536 portrait images.' },
                    { q: 'Which GPT Image quality should I choose?', a: 'Choose low or medium when testing prompts quickly, high for final product images, posters, or marketing assets, and auto when you are unsure. Quality options apply to GPT-Image-1.5.' },
                    { q: 'How to fix GPT Image results that do not match my prompt?', a: 'Describe the subject, setting, composition, lighting, camera, materials, style, and any required text more explicitly. Use the GPT Image examples on this page as a starting point and adapt them to your project.' },
                    { q: 'Do I need prompt engineering experience to use GPT Image?', a: 'No. Start with a simple natural-language prompt, then add subject positions, composition, lighting, colors, materials, and text requirements as needed. Clearer descriptions generally help the result match your creative intent more closely.' },
                    { q: 'What tool can I use to create e-commerce product images, posters and UI concepts?', a: 'GPT Image can create e-commerce listing images, product mockups, posters, UI/UX concepts, website layouts, infographic layouts, book covers, blog images, email banners, and game concepts. Verify text, data, brand elements, and structural details before final use.' },
                    { q: 'GPT Image vs Midjourney: which should I use?', a: 'GPT Image is a strong fit for clear prompt control, practical image sizes, and direct browser generation. Midjourney may suit users who prefer its artistic styles, reference-image workflow, and creative process.' }
                ],
                ctaTitle: 'Use GPT Image for Free on Miral!',
                ctaDesc: 'Sign up to receive free credits. Describe your idea, choose a size and quality, and use the GPT Image AI image generator to create high-quality visuals.'
            },
            qwenImage2Pro: {
                title: 'Qwen Image 2.0 Pro AI Image Generator Free Online | Miral',
                description: 'Create AI images online with Qwen Image 2.0 Pro. Use negative prompts, prompt enhancement, flexible aspect ratios, and generate up to four images per run.',
                heroHeadline: 'Qwen Image 2.0 Pro AI Image Generator',
                heroIntro: 'Use the Qwen Image 2.0 Pro AI image generator for free on Miral AI. Sign up to receive free credits and quickly create high-quality images with negative prompts, prompt enhancement, and flexible aspect ratios.',
                eyebrow: 'Alibaba Tongyi Qwen · Qwen-Image-2.0-Pro',
                sectionKicker: 'Qwen Image 2.0 Pro',
                ctaTag: 'Qwen Image 2.0 Pro · Miral',
                badges: ['Text to Image', 'Negative Prompt', 'Prompt Enhancement', '1-4 Images / Run', 'Flexible Aspect Ratios'],
                previewLabel: 'Qwen Image 2.0 Pro',
                previewMeta: ['1:1', '2048 × 2048', 'Up to 1-4 Images'],
                previewTitle: 'From a precise prompt with exclusions to polished visuals',
                previewDesc: 'Combine positive prompts with negative prompts and prompt enhancement to generate multiple on-target images in one run.',
                keyFeaturesTitle: 'Create Precise Visuals with the Qwen Image 2.0 Pro Text to Image Generator',
                keyFeaturesIntro: 'Explore the key Qwen Image 2.0 Pro AI image generator features for fine control, negative prompts, prompt enhancement, batch output, and flexible aspect ratios.',
                mainFeaturesTitle: 'Key Qwen Image 2.0 Pro Capabilities',
                promptLabel: 'Positive Prompt',
                negativePromptLabel: 'Negative Prompt',
                shortPromptLabel: 'Short Prompt',
                negativePromptFallback: 'low clarity, distorted details, cluttered composition',
                features: [
                    { name: 'Negative Prompt Control', short: 'Describe what to exclude for cleaner, on-target results.', desc: 'The Qwen Image 2.0 Pro AI image generator supports a dedicated negative prompt, so you can tell the model what to avoid — such as low clarity, deformed hands, or cluttered composition. This gives you finer control over the final image and reduces the need to re-roll repeatedly.', demo: { type: 'table', rows: [
                        { prompt: 'A premium product photo of a glass skincare bottle on wet stone, soft morning light, clean background. (Negative: cluttered background, low resolution, deformed reflections.)', image: require('@/assets/images/qwenImage2Pro/32ccbe94-155c-4873-9e85-602969ecb6e4.webp') },
                        { prompt: 'A portrait of a young woman in autumn light, natural skin texture, shallow depth of field. (Negative: over-smoothed skin, waxy look, oversaturated colors.)', image: require('@/assets/images/qwenImage2Pro/b4c88e78-6c88-4db5-9ea2-a6041609a380.webp') }
                    ] } },
                    { name: 'Prompt Enhancement', short: 'Optionally expand a short prompt into richer detail.', desc: 'Turn on prompt enhancement and Qwen Image 2.0 Pro automatically enriches a brief prompt with extra detail before generation. This helps non-expert prompts produce more complete, vivid images without manual rewriting.', demo: { type: 'table', rows: [
                        { prompt: 'A cozy reading nook by a rainy window.', image: require('@/assets/images/qwenImage2Pro/f9f87426-60d9-4f97-a372-7cb55b5bf7de.webp') },
                        { prompt: 'A wooden reading desk beside a rain-covered window at night, a warm task lamp illuminating an open book and steaming tea, quiet and cozy interior.', image: require('@/assets/images/qwenImage2Pro/qwen-enhance-rainy-desk.webp') }
                    ] } },
                    { name: 'Generate 1-4 Images at Once', short: 'Produce multiple variations in a single run.', desc: 'Qwen Image 2.0 Pro can generate up to four images per request, so you can compare variations of a concept, angle, or style side by side and pick the best one. This speeds up creative exploration for marketing and product visuals.', prompt: 'A minimalist ceramic table lamp on a walnut side table, warm evening interior, cream wall, soft shadows, Scandinavian product photography.', image: require('@/assets/images/qwenImage2Pro/c4581d5b-f28a-4ae5-8bb2-b110c30d954c.webp') },
                    { name: 'Flexible Aspect Ratios', short: 'Pick landscape, portrait, square, or custom sizes.', desc: 'Choose from ready-made aspect ratios such as 2688×1536 landscape, 1536×2688 portrait, 2048×2048 square, and 2368×1728 / 1728×2368, or enter a custom size from 512×512 to 2048×2048. This makes the Qwen Image 2.0 Pro text to image generator suitable for banners, posters, social posts, and square thumbnails alike.', prompt: 'A cinematic wide landscape shot of a coastal cliff at golden hour, dramatic clouds, fine rock detail, 2688×1536.', image: require('@/assets/images/qwenImage2Pro/e2bd1179-48db-4ce6-a713-2a0a62dd5dd5.webp') },
                    { name: 'Refined Detail & Realism', short: 'Render lifelike textures, lighting, and depth.', desc: 'Qwen Image 2.0 Pro produces fine textures, realistic lighting, and natural depth, making it a solid fit for product photography, portraits, and editorial visuals where believability matters.', prompt: 'Close-up editorial portrait of an elderly ceramic artist in a sunlit workshop, natural skin texture, clay dust on hands, warm window light, shallow depth of field.', image: require('@/assets/images/qwenImage2Pro/3204b3e8-c5ca-40b4-afa9-a65f6dd806e2.webp') }
                ],
                showcaseKicker: 'Prompt examples',
                showcaseTitle: 'Qwen Image 2.0 Pro Prompt Examples for Better AI Images',
                showcaseIntro: 'Use these Qwen Image 2.0 Pro prompt examples as a starting point. Pair each positive prompt with a negative prompt to remove unwanted elements, then send it directly to the generator.',
                useCasesKicker: 'Made for real work',
                useCasesTitle: 'Popular Qwen Image 2.0 Pro Use Cases',
                useCases: [
                    { name: 'Qwen Image 2.0 Pro for Product Photography', desc: 'Create clean product shots with controlled backgrounds using negative prompts to remove clutter.' },
                    { name: 'Qwen Image 2.0 Pro for Marketing', desc: 'Generate campaign concepts, social ads, and banners across multiple aspect ratios.' },
                    { name: 'Qwen Image 2.0 Pro for Posters and Typography', desc: 'Produce poster layouts and text-rich designs with clear headlines and labels.' },
                    { name: 'Qwen Image 2.0 Pro for Portraits', desc: 'Generate detailed portraits with natural skin texture using negative prompts to avoid artifacts.' },
                    { name: 'Qwen Image 2.0 Pro for Concept Art', desc: 'Explore characters, environments, and visual directions with 1-4 variations per run.' },
                    { name: 'Qwen Image 2.0 Pro for E-commerce', desc: 'Produce multiple image variations for listings and ads in a single generation.' }
                ],
                howToKicker: 'Three simple steps',
                howToTitle: 'How to Use the Qwen Image 2.0 Pro AI Image Generator Online',
                howToIntro: 'Use the Qwen Image 2.0 Pro AI image generator online on Miral with positive prompts, negative prompts, and flexible output controls.',
                howToSteps: [
                    { title: 'Enter Your Main Prompt', desc: 'Describe the desired subject, scene, composition, lighting, style, and visual details.' },
                    { title: 'Configure Generation Controls', desc: 'Add a negative prompt if needed, enable prompt enhancement, choose the size, and select one to four images.' },
                    { title: 'Generate and Compare', desc: 'Start generation, compare the returned variations, and download the image that best matches your intent.' }
                ],
                howToCta: 'Try Qwen Image 2.0 Pro AI Image Generator',
                faqTitle: 'Frequently Asked Questions About Qwen Image 2.0 Pro',
                faqs: [
                    { q: 'What is the Qwen Image 2.0 Pro AI image generator?', a: 'Qwen Image 2.0 Pro is Alibaba\'s Tongyi Qwen text-to-image model. The Qwen Image 2.0 Pro AI image generator turns written prompts into high-quality, detailed images and is available on Miral for art, design, marketing, and product visual creation directly in your browser.' },
                    { q: 'What tool can I use to create multiple product image variations with negative prompts?', a: 'Qwen Image 2.0 Pro provides a dedicated negative prompt, optional prompt enhancement, 1-4 images per run, and flexible aspect ratios for product photography, marketing, and e-commerce visual variations.' },
                    { q: 'Can I use the Qwen Image 2.0 Pro AI image generator for free?', a: 'Yes. Sign up to receive free credits and start creating high-quality images with the Qwen Image 2.0 Pro AI image generator immediately. Generating images uses the corresponding credits.' },
                    { q: 'How do I use the Qwen Image 2.0 Pro AI image generator online?', a: 'Enter a detailed text prompt, optionally add a negative prompt describing what to avoid, turn on prompt enhancement if needed, choose an aspect ratio or custom size, set how many images to generate (1-4), and click Generate. Qwen Image 2.0 Pro works well for marketing materials, product photography, portraits, and poster designs.' },
                    { q: 'How to fix unwanted elements in Qwen Image 2.0 Pro results?', a: 'Add a negative prompt describing elements you do not want, such as low clarity, deformed hands, or a cluttered background. Qwen Image 2.0 Pro uses it to steer generation away from those results.' },
                    { q: 'How many images can Qwen Image 2.0 Pro generate at once?', a: 'Qwen Image 2.0 Pro can generate up to 4 images in a single request (n = 1 to 4), so you can compare variations of a concept, angle, or style and choose the best one.' },
                    { q: 'What sizes and aspect ratios does Qwen Image 2.0 Pro support?', a: 'On Miral, Qwen Image 2.0 Pro offers ready-made ratios such as 2688×1536, 1536×2688, 2048×2048, 2368×1728, and 1728×2368, plus a custom size from 512×512 up to 2048×2048. This covers landscape, portrait, and square outputs for banners, posters, social posts, and thumbnails.' },
                    { q: 'What are the best Qwen Image 2.0 Pro prompt examples?', a: 'Effective Qwen Image 2.0 Pro prompts clearly describe the subject, setting, composition, lighting, and style, then pair a positive prompt with a negative prompt to remove unwanted details. Use the Qwen Image 2.0 Pro prompt examples on this page as a starting point and customize them for your project.' },
                    { q: 'Qwen Image 2.0 Pro vs Midjourney: which should I use?', a: 'Choose based on workflow rather than a universal winner. Qwen Image 2.0 Pro is a strong fit when you need explicit negative prompts, prompt enhancement, 1-4 images per run, and flexible aspect ratios in a browser-based generator on Miral. Midjourney may suit creators who prefer its distinctive artistic workflow and community tools.' }
                ],
                ctaTitle: 'Try Qwen Image 2.0 Pro for Free on Miral!',
                ctaDesc: 'Enter your idea above and use the Qwen Image 2.0 Pro AI image generator with optional controls to create precise image variations.'
            },
            stableDiffusion: {
                title: 'Stable Diffusion 3.5 AI Image Generator Free Online | Miral',
                description: 'Generate AI images online with Stable Diffusion 3.5. Use negative prompts, preset aspect ratios, and custom sizes from 512 to 2048 pixels on Miral.',
                heroHeadline: 'Stable Diffusion 3.5 AI Image Generator',
                heroIntro: 'Use the Stable Diffusion 3.5 AI image generator for free on Miral AI. Sign up to receive free credits and quickly create high-quality images with detailed prompts, negative prompts, and flexible sizes.',
                eyebrow: 'Stability AI · Stable Diffusion 3.5',
                sectionKicker: 'Stable Diffusion 3.5',
                ctaTag: 'Stable Diffusion 3.5 · Miral',
                badges: ['Text to Image', 'Negative Prompt', 'Flexible Aspect Ratios', 'Custom Size'],
                previewLabel: 'Stable Diffusion 3.5',
                previewMeta: ['1:1', '512 – 2048', 'Multiples of 64'],
                previewTitle: 'From a detailed prompt to a controlled, polished image',
                previewDesc: 'Pair positive prompts with negative prompts and choose the right aspect ratio to steer Stable Diffusion 3.5 toward clean, on-target visuals.',
                keyFeaturesTitle: 'Create Controlled Visuals with the Stable Diffusion 3.5 Text to Image Generator',
                keyFeaturesIntro: 'Explore the key Stable Diffusion 3.5 AI image generator features for negative prompts, flexible aspect ratios, custom sizes, and detailed prompt understanding.',
                exploreTitle: 'Explore More AI Image Models',
                mainFeaturesTitle: 'Key Stable Diffusion 3.5 Features',
                generatedImageLabel: 'Generated Image',
                versionLabel: 'Control',
                featureLabel: 'What It Changes',
                useCaseLabel: 'Best For',
                variantsTitle: 'Stable Diffusion 3.5 Output Controls',
                variantsIntro: 'Combine the Stable Diffusion 3.5 model with preset aspect ratios or exact custom dimensions based on the final layout you need.',
                variants: [
                    { name: 'Stable Diffusion 3.5', desc: 'Detailed text-to-image generation with positive and negative prompt control.', bestFor: 'Product visuals, portraits, concept art, and marketing images.' },
                    { name: 'Preset Aspect Ratios', desc: 'Ready-made landscape, portrait, and square output dimensions.', bestFor: 'Social posts, banners, posters, and thumbnails.' },
                    { name: 'Custom Image Size', desc: 'Exact width and height from 512 to 2048 in multiples of 64.', bestFor: 'Layout slots and projects that require precise pixel dimensions.' }
                ],
                controlsTitle: 'Choose the Right Prompt Controls and Image Size',
                controlsIntro: 'Use a negative prompt to reduce unwanted details, then select a preset ratio or enter custom dimensions for the intended channel.',
                galleryTitle: 'More Stable Diffusion 3.5 Image Examples',
                discussionTitle: 'Common Stable Diffusion 3.5 Questions',
                communityTitle: 'Popular Ways to Create with Stable Diffusion 3.5',
                tutorialPrompt: 'Editorial product photograph of a sculptural ceramic speaker on pale stone, soft morning window light, realistic texture, balanced composition, subtle shadows, clean background.',
                qualityBenefits: [
                    'Use negative prompts to reduce clutter, malformed details, and unwanted visual styles.',
                    'Follow layered descriptions of the subject, composition, lighting, materials, and mood.',
                    'Create landscape, portrait, and square images with presets or precise custom dimensions.'
                ],
                features: [
                    { name: 'Negative Prompt Control', short: 'Describe what to exclude for cleaner, on-target results.', desc: 'The Stable Diffusion 3.5 AI image generator supports a dedicated negative prompt, so you can tell the model what to avoid — such as low clarity, deformed hands, or a cluttered background. This gives you finer control over the final image and reduces the need to re-roll repeatedly.', demo: { type: 'table', rows: [
                        { prompt: 'A premium product photo of a matte black ceramic vase on a marble pedestal, soft studio light, clean background. (Negative: cluttered background, low resolution, deformed reflections.)', image: require('@/assets/images/stableDiffusion/1783501013638.webp') },
                        { prompt: 'A portrait of a young man in soft window light, natural skin texture, shallow depth of field. (Negative: over-smoothed skin, waxy look, oversaturated colors.)', image: require('@/assets/images/stableDiffusion/1783501332038.webp') }
                    ] } },
                    { name: 'Flexible Aspect Ratios', short: 'Pick landscape, portrait, square, or a custom size.', desc: 'Choose from ready-made aspect ratios such as 1024×1024, 1280×1280, 896×1536, 1536×896, 768×1344, 1344×768, 1024×1536, and 1536×1536, or enter a custom size from 512×512 to 2048×2048. This makes the Stable Diffusion 3.5 text to image generator suitable for banners, posters, social posts, and square thumbnails alike.', prompt: 'A cinematic wide landscape shot of a coastal cliff at golden hour, dramatic clouds, fine rock detail, 1536×896.', image: require('@/assets/images/stableDiffusion/1783501396803.webp') },
                    { name: 'Custom Image Sizes', short: 'Set exact pixel dimensions for precise output.', desc: 'When a preset does not fit, switch to a custom size and enter any width and height from 512 to 2048 in multiples of 64. This lets you match a specific layout, banner slot, or print aspect without manual cropping.', prompt: 'A minimalist poster background with a centered geometric composition, deep blue gradient, subtle grain, 1280×1280.', image: require('@/assets/images/stableDiffusion/0217835023294345bd2f0b9e6315ce45b86fb4e22ec7496156d5f_0.webp') },
                    { name: 'Detailed Prompt Understanding', short: 'Follows layered descriptions of subject, light, and style.', desc: 'Stable Diffusion 3.5 reads layered text instructions and renders the subject, setting, lighting, and mood you describe. Combine a clear positive prompt with a negative prompt to push the result closer to your intent in fewer tries.', demo: { type: 'table', rows: [
                        { prompt: 'Editorial product photo of a wristwatch beside folded linen and a ceramic cup, balanced triangular composition, soft morning light.', image: require('@/assets/images/stableDiffusion/1783501741652.webp') },
                        { prompt: 'A cozy reading nook by a rainy window, warm lamp light, stacked books, textured blanket, cinematic mood.', image: require('@/assets/images/stableDiffusion/1783501817217.webp') }
                    ] } },
                    { name: 'Refined Detail and Realism', short: 'Render believable lighting, materials, and depth.', desc: 'Stable Diffusion 3.5 produces fine textures, realistic lighting, and natural depth, making the Stable Diffusion 3.5 AI image generator a solid fit for product photography, portraits, concept art, and editorial visuals where believability matters.', prompt: 'Close-up editorial portrait of an elderly ceramic artist in a sunlit workshop, natural skin texture, clay dust on hands, warm window light, shallow depth of field.', image: require('@/assets/images/stableDiffusion/021783502374347ebd7c24e3cae4a4b683f52566c3e30e2cb26b5_0.webp') }
                ],
                showcaseKicker: 'Prompt examples',
                showcaseTitle: 'Stable Diffusion 3.5 Prompt Examples for Better AI Images',
                showcaseIntro: 'Use these Stable Diffusion 3.5 prompt examples as a starting point. Describe the subject, composition, lighting, and style clearly, pair each prompt with a negative prompt, then send it directly to the generator.',
                useCasesKicker: 'Made for real work',
                useCasesTitle: 'Popular Stable Diffusion 3.5 Use Cases',
                useCases: [
                    { name: 'Stable Diffusion 3.5 for Product Photography', desc: 'Create clean product shots with controlled backgrounds using negative prompts to remove clutter.' },
                    { name: 'Stable Diffusion 3.5 for Marketing', desc: 'Generate campaign concepts, social ads, and banners across multiple aspect ratios.' },
                    { name: 'Stable Diffusion 3.5 for Posters and Layouts', desc: 'Produce poster backgrounds and layout-ready visuals in custom pixel dimensions.' },
                    { name: 'Stable Diffusion 3.5 for Portraits', desc: 'Generate detailed portraits with natural skin texture, using negative prompts to avoid artifacts.' },
                    { name: 'Stable Diffusion 3.5 for Concept Art', desc: 'Explore characters, environments, and visual directions with layered prompts.' },
                    { name: 'Stable Diffusion 3.5 for Social Content', desc: 'Create square, portrait, and landscape images sized for different social platforms.' }
                ],
                howToKicker: 'Three simple steps',
                howToTitle: 'How to Use the Stable Diffusion 3.5 AI Image Generator Online',
                howToIntro: 'Use the Stable Diffusion 3.5 AI image generator online on Miral with a clear prompt, a negative prompt, and the aspect ratio your project needs.',
                howToSteps: [
                    { title: 'Enter Your Main Prompt', desc: 'Describe the desired subject, scene, composition, lighting, style, and visual details.' },
                    { title: 'Configure Generation Controls', desc: 'Add a negative prompt if needed, then choose a ready-made aspect ratio or enter a custom size.' },
                    { title: 'Generate and Review', desc: 'Start generation, review the result, and download the image or adjust your prompt for another pass.' }
                ],
                howToCta: 'Try Stable Diffusion 3.5 AI Image Generator',
                faqTitle: 'Frequently Asked Questions About Stable Diffusion 3.5',
                faqs: [
                    { q: 'What is the Stable Diffusion 3.5 AI image generator?', a: 'Stable Diffusion 3.5 is a text-to-image model from Stability AI. The Stable Diffusion 3.5 AI image generator turns written prompts into detailed images and is available on Miral for art, design, marketing, and product visual creation directly in your browser.' },
                    { q: 'What tool can I use to create custom-size images with negative prompts?', a: 'Stable Diffusion 3.5 offers a dedicated negative prompt, ready-made aspect ratios, and custom sizes from 512 to 2048 for product photography, marketing visuals, portraits, and concept art.' },
                    { q: 'Can I use the Stable Diffusion 3.5 AI image generator for free?', a: 'Yes. Sign up to receive free credits and start creating high-quality images with the Stable Diffusion 3.5 AI image generator immediately. Generating images uses the corresponding credits.' },
                    { q: 'How do I use the Stable Diffusion 3.5 AI image generator online?', a: 'Enter a detailed text prompt, optionally add a negative prompt describing what to avoid, choose a ready-made aspect ratio or enter a custom size, and click Generate. Stable Diffusion 3.5 works well for marketing materials, product photography, portraits, and poster layouts.' },
                    { q: 'How to fix unwanted or deformed details in Stable Diffusion 3.5 images?', a: 'Add a negative prompt describing elements you do not want, such as low clarity, deformed hands, or a cluttered background. Stable Diffusion 3.5 uses it to steer generation away from those results.' },
                    { q: 'What sizes and aspect ratios does Stable Diffusion 3.5 support?', a: 'On Miral, Stable Diffusion 3.5 offers ready-made ratios such as 1024×1024, 1280×1280, 896×1536, 1536×896, 768×1344, 1344×768, 1024×1536, and 1536×1536, plus a custom size from 512×512 up to 2048×2048 in multiples of 64. This covers landscape, portrait, and square outputs for banners, posters, social posts, and thumbnails.' },
                    { q: 'What are the best Stable Diffusion 3.5 prompt examples?', a: 'Effective Stable Diffusion 3.5 prompts clearly describe the subject, setting, composition, lighting, and style, then pair a positive prompt with a negative prompt to remove unwanted details. Use the Stable Diffusion 3.5 prompt examples on this page as a starting point and customize them for your project.' },
                    { q: 'Stable Diffusion 3.5 vs Midjourney: which should I use?', a: 'Choose based on workflow rather than a universal winner. Stable Diffusion 3.5 is a strong fit when you need explicit negative prompts, ready-made aspect ratios, and custom pixel sizes in a browser-based generator on Miral. Midjourney may suit creators who prefer its distinctive artistic workflow and community tools.' }
                ],
                ctaTitle: 'Try Stable Diffusion 3.5 for Free on Miral!',
                ctaDesc: 'Enter your idea above and use the Stable Diffusion 3.5 AI image generator with negative prompts and flexible sizes to create controlled visuals.'
            },
            zImageTurbo: {
                title: 'Z Image Turbo AI Image Generator Free Online | Miral',
                description: 'Create high-quality AI images online with Z Image Turbo. Extend prompts, choose flexible aspect ratios, set custom dimensions, and control seeds on Miral.',
                heroHeadline: 'Z Image Turbo AI Image Generator',
                heroIntro: 'Use the Z Image Turbo AI image generator for free on Miral AI. Sign up to receive free credits and quickly create high-quality images with prompt extension, flexible aspect ratios, and seed control.',
                eyebrow: 'Z Image Turbo',
                sectionKicker: 'Z Image Turbo',
                ctaTag: 'Z Image Turbo · Miral',
                badges: ['Text to Image', 'Prompt Extension', 'Flexible Aspect Ratios', 'Custom Size', 'Seed Control'],
                previewLabel: 'Z Image Turbo',
                previewMeta: ['1:1', '512 – 2048', 'Seed Control'],
                previewTitle: 'From a short prompt to a polished, high-resolution visual',
                previewDesc: 'Let prompt extension enrich a brief idea, choose the right aspect ratio, and reuse a seed to keep a consistent style across images.',
                keyFeaturesTitle: 'Create Polished Visuals with the Z Image Turbo Text to Image Generator',
                keyFeaturesIntro: 'Explore the key Z Image Turbo AI image generator features for prompt extension, flexible aspect ratios, custom sizes, and seed-based consistency.',
                exploreTitle: 'Explore More AI Image Models',
                mainFeaturesTitle: 'Key Z Image Turbo Features',
                generatedImageLabel: 'Generated Image',
                versionLabel: 'Control',
                featureLabel: 'What It Changes',
                useCaseLabel: 'Best For',
                variantsTitle: 'Z Image Turbo Creation Controls',
                variantsIntro: 'Combine prompt extension, flexible dimensions, and seed control according to how much detail and visual consistency your project needs.',
                variants: [
                    { name: 'Z Image Turbo', desc: 'Fast text-to-image generation with detailed high-resolution output.', bestFor: 'Product visuals, portraits, concept art, and marketing images.' },
                    { name: 'Prompt Extension', desc: 'Automatically enriches short prompts with additional visual detail.', bestFor: 'Turning quick ideas into more complete generation instructions.' },
                    { name: 'Seed Control', desc: 'Reuses the same starting seed while you refine other settings.', bestFor: 'Keeping a coordinated style across image variations or campaigns.' }
                ],
                controlsTitle: 'Choose the Right Prompt, Size, and Seed Settings',
                controlsIntro: 'Enable prompt extension when an idea needs more detail, choose the intended output dimensions, and reuse a seed when visual consistency matters.',
                galleryTitle: 'More Z Image Turbo Image Examples',
                discussionTitle: 'Common Z Image Turbo Questions',
                communityTitle: 'Popular Ways to Create with Z Image Turbo',
                tutorialPrompt: 'A compact electric scooter displayed in a bright architectural studio, pale concrete floor, soft skylight, refined product photography, balanced composition, realistic materials.',
                qualityBenefits: [
                    'Expand short ideas into richer prompts without manually rewriting every visual detail.',
                    'Choose landscape, portrait, square, or precise custom dimensions for the final channel.',
                    'Reuse a seed to keep lighting, palette, and composition more consistent across iterations.'
                ],
                features: [
                    { name: 'Prompt Extension', short: 'Optionally expand a short prompt into richer detail.', desc: 'Turn on prompt extension and Z Image Turbo automatically enriches a brief prompt with extra detail before generation. This helps short or simple prompts produce more complete, vivid images without manual rewriting.', demo: { type: 'table', rows: [
                        { prompt: 'A glass greenhouse filled with tropical plants on the surface of Mars.', image: require('@/assets/images/zImageTurbo/b1057f7b-3e0e-9687-aa55-56cfed42147a0.webp') },
                        { prompt: 'A tiny artisan bakery built inside a vintage train carriage.', image: require('@/assets/images/zImageTurbo/a8dbab92-cfb4-928b-bd20-4f01835aa0ac0.webp') }
                    ] } },
                    { name: 'Flexible Aspect Ratios', short: 'Pick landscape, portrait, square, or a custom size.', desc: 'Choose from ready-made aspect ratios such as 1024×1024, 1280×1280, 864×1536, 1536×864, 720×1280, 1280×720, 1024×1536, and 1536×1536, or enter a custom size from 512×512 to 2048×2048. This makes the Z Image Turbo text to image generator suitable for banners, posters, social posts, and square thumbnails alike.', prompt: 'An ultra-wide aerial view of a Tokyo night market in the rain, glowing paper lanterns, crowded food stalls, reflective streets, cinematic atmosphere, 1536×864.', image: require('@/assets/images/zImageTurbo/b2964bd5-066f-90b6-8c86-91dad79e44120.webp') },
                    { name: 'Custom Image Sizes', short: 'Set exact pixel dimensions for precise output.', desc: 'When a preset does not fit, switch to a custom size and enter any width and height from 512 to 2048. This lets you match a specific layout, banner slot, or print aspect without manual cropping.', prompt: 'A vertical botanical exhibition poster, oversized orange typography, rare tropical leaves, warm off-white paper texture, precise editorial grid, 1152×1728.', image: require('@/assets/images/zImageTurbo/2d5a0c7e-3ef6-9433-be0d-606be80f99e80.webp') },
                    { name: 'Seed Control for Consistency', short: 'Reuse a seed to keep a stable style across images.', desc: 'Set a fixed seed (0 to 2147483647) and the Z Image Turbo AI image generator will lean on the same starting point across runs, making it easier to keep a consistent look while you refine the prompt. Leave the seed at 0 to get a fresh, random result each time.', prompt: 'A coordinated skincare campaign featuring three frosted glass bottles on pale green stone, soft diffused light, eucalyptus accents — reuse the same seed to preserve the lighting, palette, and composition across the product series.', image: require('@/assets/images/zImageTurbo/f688ab6d-a723-969d-8df1-fbac721e66350.webp') },
                    { name: 'Refined Detail and Realism', short: 'Render believable lighting, materials, and depth.', desc: 'Z Image Turbo produces fine textures, realistic lighting, and natural depth, making it a solid fit for product photography, portraits, concept art, and editorial visuals where believability matters.', prompt: 'Documentary close-up of a violin maker carving a maple bridge in a quiet workshop, fine wood shavings, worn hand tools, natural skin texture, soft north-window light, shallow depth of field.', image: require('@/assets/images/zImageTurbo/715e19f5-fea4-9361-a1e3-0f04d595db660.webp') }
                ],
                showcaseKicker: 'Prompt examples',
                showcaseTitle: 'Z Image Turbo Prompt Examples for Better AI Images',
                showcaseIntro: 'Use these Z Image Turbo prompt examples as a starting point. Describe the subject, composition, lighting, and style clearly, optionally enable prompt extension, then send it directly to the generator.',
                useCasesKicker: 'Made for real work',
                useCasesTitle: 'Popular Z Image Turbo Use Cases',
                useCases: [
                    { name: 'Z Image Turbo for Product Photography', desc: 'Create clean product shots with controlled backgrounds and a fixed seed for a consistent look.' },
                    { name: 'Z Image Turbo for Marketing', desc: 'Generate campaign concepts, social ads, and banners across multiple aspect ratios.' },
                    { name: 'Z Image Turbo for Posters and Layouts', desc: 'Produce poster backgrounds and layout-ready visuals in custom pixel dimensions.' },
                    { name: 'Z Image Turbo for Portraits', desc: 'Generate detailed portraits with natural skin texture and believable lighting.' },
                    { name: 'Z Image Turbo for Concept Art', desc: 'Explore characters, environments, and visual directions with layered prompts.' },
                    { name: 'Z Image Turbo for Social Content', desc: 'Create square, portrait, and landscape images sized for different social platforms.' }
                ],
                howToKicker: 'Three simple steps',
                howToTitle: 'How to Use the Z Image Turbo AI Image Generator Online',
                howToIntro: 'Use the Z Image Turbo AI image generator online on Miral with a clear prompt, optional prompt extension, and the aspect ratio your project needs.',
                howToSteps: [
                    { title: 'Enter Your Main Prompt', desc: 'Describe the desired subject, scene, composition, lighting, style, and visual details.' },
                    { title: 'Configure Generation Controls', desc: 'Optionally enable prompt extension, choose a ready-made aspect ratio or enter a custom size, and set a seed if you want consistency.' },
                    { title: 'Generate and Review', desc: 'Start generation, review the result, and download the image or adjust your prompt for another pass.' }
                ],
                howToCta: 'Try Z Image Turbo AI Image Generator',
                faqTitle: 'Frequently Asked Questions About Z Image Turbo',
                faqs: [
                    { q: 'What is the Z Image Turbo AI image generator?', a: 'Z Image Turbo is a text-to-image model for high-resolution image generation. The Z Image Turbo AI image generator turns written prompts into detailed images and is available on Miral for art, design, marketing, and product visual creation directly in your browser.' },
                    { q: 'What tool can I use to create a consistent series of product images?', a: 'Z Image Turbo combines prompt extension, flexible image sizes, and seed control to help create a consistent series of product photography or marketing visuals.' },
                    { q: 'Can I use the Z Image Turbo AI image generator for free?', a: 'Yes. Sign up to receive free credits and start creating high-quality images with the Z Image Turbo AI image generator immediately. Generating images uses the corresponding credits.' },
                    { q: 'How do I use the Z Image Turbo AI image generator online?', a: 'Enter a detailed text prompt, optionally turn on prompt extension, choose a ready-made aspect ratio or enter a custom size, set a seed if you want a consistent look, and click Generate. Z Image Turbo works well for marketing materials, product photography, portraits, and poster layouts.' },
                    { q: 'What is prompt extension in Z Image Turbo?', a: 'Prompt extension is an optional switch that lets Z Image Turbo automatically enrich a short or simple prompt with extra detail before generation. This helps non-expert prompts produce more complete, vivid images without manual rewriting.' },
                    { q: 'How to fix inconsistent results in Z Image Turbo?', a: 'Reuse the same seed while refining other parameters to help maintain a consistent style across images. Leave the seed at 0 only when you want a fresh, random result each time.' },
                    { q: 'What sizes and aspect ratios does Z Image Turbo support?', a: 'On Miral, Z Image Turbo offers ready-made ratios such as 1024×1024, 1280×1280, 864×1536, 1536×864, 720×1280, 1280×720, 1024×1536, and 1536×1536, plus a custom size from 512×512 up to 2048×2048. This covers landscape, portrait, and square outputs for banners, posters, social posts, and thumbnails.' },
                    { q: 'What are the best Z Image Turbo prompt examples?', a: 'Effective Z Image Turbo prompts clearly describe the subject, setting, composition, lighting, and style. For short ideas, enable prompt extension so the model can enrich the prompt automatically. Use the Z Image Turbo prompt examples on this page as a starting point and customize them for your project.' }
                ],
                ctaTitle: 'Try Z Image Turbo for Free on Miral!',
                ctaDesc: 'Enter your idea above and use the Z Image Turbo AI image generator with prompt extension, flexible sizes, and seed control to create polished visuals.'
            },
            midjourney: {
                title: 'Midjourney AI Image Generator Free Online | Miral',
                description: 'Create AI art online with Midjourney on Miral AI. Choose realistic or anime styles, guide results with reference images, and turn text prompts into vivid visuals.',
                heroHeadline: 'Midjourney AI Image Generator',
                heroIntro: 'Use the Midjourney AI image generator for free on Miral AI. Sign up to receive free credits and instantly create high-quality images with Realistic or Anime styles and optional reference image guidance.',
                eyebrow: 'Midjourney',
                sectionKicker: 'Midjourney',
                ctaTag: 'Midjourney · Miral',
                badges: ['Text to Image', 'Realistic & Anime Styles', 'Reference Image Guidance', 'Artistic Direction'],
                previewLabel: 'Midjourney',
                previewMeta: ['Realistic', 'Anime', 'Up to 5 References'],
                previewTitle: 'From a vivid prompt to a cinematic, art-directed image',
                previewDesc: 'Pick a style, describe the mood and lighting, and let Midjourney shape the artistic look of your concept, poster, or character.',
                keyFeaturesTitle: 'Create Art-Directed Visuals with the Midjourney Text to Image Generator',
                keyFeaturesIntro: 'Explore the key Midjourney AI image generator features for style switching, reference image guidance, and rich artistic direction.',
                features: [
                    { name: 'Realistic and Anime Styles', short: 'Switch the visual style with one tap.', desc: 'The Midjourney AI image generator on Miral exposes two ready-made styles — Realistic and Anime. Pick Realistic for photographic detail, natural light, and lifelike textures, or Anime for stylized lines, bold color, and a hand-drawn feel. The style is chosen on the panel, so your prompt can focus on the scene itself.', demo: { type: 'table', rows: [
                        { prompt: 'A lone traveler standing at the edge of a misty mountain ridge at sunrise, volumetric light, cinematic wide shot, fine fabric and rock detail.', image: require('@/assets/images/midjourney/1783505533006329.webp') },
                        { prompt: 'A determined young swordswoman on a rooftop at dusk, flowing hair, glowing lanterns, expressive anime line work, vibrant cel shading.', image: require('@/assets/images/midjourney/45f1eae9-39b9-4cc9-8a4e-e597aa4d344b.webp') }
                    ] } },
                    { name: 'Reference Image Guidance', short: 'Upload up to five images to steer the look.', desc: 'Guide the Midjourney AI image generator with up to five reference images (PNG, JPG, JPEG, or WebP). Use them to carry over a color palette, character look, product shape, or overall aesthetic so the result stays closer to a reference direction rather than the text alone.', prompt: 'A premium product photo of a matte black ceramic vase on a marble pedestal, soft studio light, clean background, matching the mood and palette of the uploaded references.', image: require('@/assets/images/midjourney/1783506116812275.webp') },
                    { name: 'Cinematic Lighting and Mood', short: 'Render dramatic light, atmosphere, and depth.', desc: 'Midjourney is known for art-directed lighting and atmosphere. Describe golden hour, neon glow, fog, rim light, or candlelight, and the model leans into a cinematic look that suits posters, key art, and concept visuals.', demo: { type: 'table', rows: [
                        { prompt: 'A rain-soaked neon alley at night, reflective puddles, soft bokeh from distant signs, moody cinematic atmosphere, a single figure with an umbrella.', image: require('@/assets/images/midjourney/1783506281563151.webp') },
                        { prompt: 'A golden hour portrait of a musician on a rooftop, warm backlight, lens flare, shallow depth of field, film grain.', image: require('@/assets/images/midjourney/1783506420066100.webp') }
                    ] } },
                    { name: 'Character and Concept Art', short: 'Build expressive characters and worlds.', desc: 'The Midjourney text to image generator is a strong fit for character design, fantasy scenes, and concept art. Describe a character\'s pose, outfit, expression, and setting, choose a style, and iterate until the look lands.', prompt: 'A wandering alchemist in a layered travel cloak, carrying a brass lantern and glowing vials, ancient forest path, dappled light, intricate costume detail.', image: require('@/assets/images/midjourney/1783506547640511.webp') },
                    { name: 'Posters and Editorial Art', short: 'Produce striking layouts and key visuals.', desc: 'From campaign key art to editorial illustrations, Midjourney shapes bold compositions and a polished aesthetic. Pair a clear focal subject with a described mood and let the model deliver art-directed visuals for marketing and editorial use.', prompt: 'A bold campaign key visual of a hummingbird hovering above a glowing tropical flower, saturated jewel tones, clean negative space, high-contrast studio lighting.', image: require('@/assets/images/midjourney/55889f96-30d2-4032-9340-2d27090394e6.webp') }
                ],
                showcaseKicker: 'Prompt examples',
                showcaseTitle: 'Midjourney Prompt Examples for Better AI Images',
                showcaseIntro: 'Use these Midjourney prompt examples as a starting point. Describe the subject, mood, lighting, and style of the scene, then choose Realistic or Anime on the panel and send it to the generator.',
                useCasesKicker: 'Made for real work',
                useCasesTitle: 'Popular Midjourney Use Cases',
                useCases: [
                    { name: 'Midjourney for Concept Art', desc: 'Build characters, fantasy worlds, and visual directions with art-directed lighting and mood.' },
                    { name: 'Midjourney for Key Art and Posters', desc: 'Create bold campaign key visuals, posters, and editorial illustrations with a polished look.' },
                    { name: 'Midjourney for Product and Brand Visuals', desc: 'Shape premium product concepts and brand imagery, guided by reference images for consistency.' },
                    { name: 'Midjourney for Portraits', desc: 'Generate cinematic portraits with natural light, film grain, or stylized anime shading.' },
                    { name: 'Midjourney for Anime and Illustration', desc: 'Switch to the Anime style for expressive line work, bold color, and hand-drawn characters.' },
                    { name: 'Midjourney for Social Content', desc: 'Produce striking, shareable visuals for feeds, thumbnails, and creative social posts.' }
                ],
                howToKicker: 'Three simple steps',
                howToTitle: 'How to Use the Midjourney AI Image Generator Online',
                howToIntro: 'Use the Midjourney AI image generator online on Miral with a vivid prompt, a chosen style, and optional reference images.',
                howToSteps: [
                    { title: 'Describe Your Scene', desc: 'Write a vivid prompt covering the subject, setting, mood, lighting, and the artistic look you want.' },
                    { title: 'Choose Style and References', desc: 'Pick Realistic or Anime on the panel, and optionally upload up to five reference images to guide the look.' },
                    { title: 'Generate and Refine', desc: 'Start generation, review the result, and download the image or adjust your prompt and references for another pass.' }
                ],
                howToCta: 'Try Midjourney AI Image Generator',
                faqTitle: 'Frequently Asked Questions About Midjourney',
                faqs: [
                    { q: 'What is the Midjourney AI image generator?', a: 'Midjourney is a widely used text-to-image model known for its art-directed, cinematic visuals. On Miral, the Midjourney AI image generator turns written prompts into striking images for concept art, key visuals, posters, and editorial work directly in your browser.' },
                    { q: 'What tool can I use to create cinematic concept art with reference images?', a: 'Midjourney combines rich artistic direction, dramatic lighting, Realistic and Anime styles, and reference image guidance for cinematic concept art, key visuals, and brand imagery.' },
                    { q: 'Can I use the Midjourney AI image generator for free?', a: 'Yes. Sign up to receive free credits and start creating high-quality images with the Midjourney AI image generator immediately. Generating images uses the corresponding credits.' },
                    { q: 'How do I use the Midjourney AI image generator online?', a: 'Enter a vivid text prompt describing the subject, mood, lighting, and style, choose Realistic or Anime on the panel, optionally upload up to five reference images, and click Generate. Midjourney works well for concept art, key visuals, posters, portraits, and editorial illustrations.' },
                    { q: 'What is the difference between the Realistic and Anime styles?', a: 'Realistic leans toward photographic detail, natural light, and lifelike textures, while Anime favors stylized lines, bold color, and a hand-drawn look. You pick the style on the panel, so your prompt can focus on the scene itself.' },
                    { q: 'How to fix Midjourney images that do not match my reference?', a: 'Upload up to five clear reference images (PNG, JPG, JPEG, or WebP) and describe which color palette, character look, product shape, or overall aesthetic the result should follow.' },
                    { q: 'What are the best Midjourney prompt examples?', a: 'Effective Midjourney prompts describe the subject, setting, mood, lighting, and artistic look in detail, then pair that prompt with the right style on the panel. Use the Midjourney prompt examples on this page as a starting point and adjust them for your project.' },
                    { q: 'Midjourney vs Stable Diffusion 3.5: which should I use?', a: 'Choose based on workflow rather than a universal winner. Midjourney is a strong fit for art-directed concepts, cinematic lighting, and reference-guided visuals with ready-made Realistic and Anime styles on Miral. Stable Diffusion 3.5 may suit creators who need explicit negative prompts and flexible aspect ratios with custom sizes.' }
                ],
                ctaTitle: 'Try Midjourney for Free on Miral!',
                ctaDesc: 'Enter your idea above and use the Midjourney AI image generator with Realistic or Anime styles and reference image guidance to create art-directed visuals.'
            }
        },
        music: {
            title: 'AI Music Generator - Miral',
            description: 'Create unique music from text descriptions using Miral\'s AI music generation.'
        },
        inspiration: {
            title: 'Inspiration - Miral',
            description: 'Browse featured works from the Miral community and get AI creation inspiration.'
        },
        gallery: {
            title: 'My Gallery - Miral',
            description: 'View and manage all your creations on Miral platform.'
        },
        faq: {
            title: 'FAQ - Miral',
            description: 'Frequently asked questions about Miral platform to help you get started with AI creation.'
        },
        about: {
            title: 'About Us - Miral',
            description: 'Learn about the Miral AI platform for image, video, and music creation.'
        },
        contact: {
            title: 'Contact Us - Miral',
            description: 'Contact Miral support for help and feedback.'
        },
        terms: {
            title: 'Terms of Service - Miral',
            description: 'Miral platform terms of service and user agreement.'
        },
        privacy: {
            title: 'Privacy Policy - Miral',
            description: 'Miral platform privacy policy and data protection statement.'
        },
        trustSafety: {
            title: 'Trust & Safety - Miral',
            description: 'Miral platform trust and safety policies.'
        }
    }
}
